{
	"dialog.ok": "ตกลง",
	"dialog.cancel": "ยกเลิก",
	"dialog.confirm": "ยืนยัน",
	"dialog.close": "ปิด",
	"dialog.import": "นำเข้า",
	"dialog.save": "บันทึก",
	"dialog.discard": "ละทิ้ง",
	"dialog.dontshowagain": "ไม่ต้องแสดงอีก",
	"data.cube": "คิวบ์",
	"data.group": "กลุ่ม",
	"data.texture": "เทกซ์เจอร์",
	"data.plugin": "ปลั๊กอิน",
	"data.preview": "ตัวอย่าง",
	"data.toolbar": "แถบเครื่องมือ",
	"data.image": "รูปภาพ",
	"keys.ctrl": "Ctrl",
	"keys.shift": "Shift",
	"keys.alt": "Alt",
	"keys.meta": "Cmd",
	"keys.delete": "Delete",
	"keys.space": "Space",
	"keys.leftclick": "คลิกซ้าย",
	"keys.middleclick": "คลิกกลาง",
	"keys.rightclick": "คลิกขวา",
	"keys.tab": "Tab",
	"keys.backspace": "Backspace",
	"keys.enter": "Enter",
	"keys.escape": "Escape",
	"keys.function": "F%0",
	"keys.numpad": "Numpad %0",
	"keys.caps": "Capslock",
	"keys.menu": "เมนูบริบท",
	"keys.left": "ซ้าย",
	"keys.up": "ขึ้น",
	"keys.right": "ขวา",
	"keys.down": "ลง",
	"keys.pageup": "Page Up",
	"keys.pagedown": "Page Down",
	"keys.plus": "บวก",
	"keys.comma": "จุลภาค",
	"keys.point": "จุด",
	"keys.minus": "ลบ",
	"keys.cross": "กากบาท",
	"keys.end": "End",
	"keys.pos1": "Pos 1",
	"keys.printscreen": "Print Screen",
	"keys.pause": "Pause",
	"message.rotation_limit.title": "ขีดจำกัดการหมุน",
	"message.rotation_limit.message": "การหมุนถูกจำกัดโดย Minecraft ให้หมุนได้เพียงหนึ่งแกน การหมุนบนแกนอื่นจะล้างการหมุนบนแกนที่เหลือ แปลงโมเดลเป็น 'โมเดลทั่วไป' หากคุณกำลังสร้างโมเดลเพื่อวัตถุประสงค์อื่นและต้องการหมุนอิสระ",
	"message.file_not_found.title": "ไม่พบไฟล์",
	"message.file_not_found.message": "Blockbench ไม่พบไฟล์ที่ร้องขอ ตรวจสอบให้แน่ใจว่าไฟล์ถูกบันทึกไว้ในเครื่องไม่ใช่ในคลาวด์",
	"message.screenshot.title": "ภาพหน้าจอ",
	"message.screenshot.clipboard": "คลิปบอร์ด",
	"message.screenshot.right_click": "คลิกขวาหรือกดค้างที่ภาพหน้าจอเพื่อคัดลอก",
	"message.invalid_file.title": "ไฟล์ไม่ถูกต้อง",
	"message.invalid_file.message": "ไม่สามารถเปิดไฟล์ json: %0",
	"message.invalid_model.title": "ไฟล์โมเดลไม่ถูกต้อง",
	"message.invalid_model.message": "ไฟล์นี้ไม่มีข้อมูลโมเดลที่ถูกต้อง",
	"message.child_model_only.title": "โมเดลลูกว่างเปล่า",
	"message.child_model_only.message": "ไฟล์นี้เป็นลูกของ %0 และไม่มีโมเดล",
	"message.unsaved_textures.title": "เทกซ์เจอร์ที่ยังไม่ได้บันทึก",
	"message.unsaved_textures.message": "โมเดลของคุณมีเทกซ์เจอร์ที่ยังไม่ได้บันทึก ตรวจสอบให้แน่ใจว่าบันทึกแล้วและวางในโฟลเดอร์ที่ถูกต้องของแพ็คทรัพยากร",
	"message.model_clipping.title": "โมเดลใหญ่เกินไป",
	"message.model_clipping.message": "โมเดลของคุณมี %0 คิวบ์ที่ใหญ่กว่าขีดจำกัดบล็อกที่ Minecraft อนุญาต โมเดลนี้จะไม่ทำงานใน Minecraft",
	"message.loose_texture.title": "นำเข้าเทกซ์เจอร์",
	"message.loose_texture.message": "เทกซ์เจอร์ที่นำเข้าไม่ได้อยู่ในแพ็คทรัพยากร Minecraft สามารถโหลดเทกซ์เจอร์ได้เฉพาะในโฟลเดอร์ textures ของแพ็คทรัพยากรที่โหลดแล้วเท่านั้น",
	"message.loose_texture.change": "เปลี่ยนเส้นทาง",
	"message.update_res.title": "ความละเอียดเทกซ์เจอร์",
	"message.update_res.message": "คุณต้องการอัปเดตความละเอียดโปรเจกต์ให้ตรงกับความละเอียดของเทกซ์เจอร์นี้หรือไม่? คลิก 'ยกเลิก' หากเทกซ์เจอร์มีความละเอียดสูงกว่าปกติ",
	"message.update_res.update": "อัปเดต",
	"message.bedrock_overwrite_error.message": "Blockbench ไม่สามารถรวมโมเดลนี้กับไฟล์เก่าได้",
	"message.bedrock_overwrite_error.backup_overwrite": "สร้างสำรองและเขียนทับ",
	"message.bedrock_overwrite_error.overwrite": "เขียนทับ",
	"message.close_warning.message": "คุณต้องการบันทึกโมเดลหรือไม่?",
	"message.close_warning.web": "งานปัจจุบันของคุณจะสูญหาย คุณแน่ใจหรือไม่ว่าต้องการออก?",
	"message.default_textures.title": "เทกซ์เจอร์เริ่มต้น",
	"message.default_textures.message": "เลือกโฟลเดอร์ 'textures' ของแพ็คทรัพยากรเริ่มต้น",
	"message.default_textures.detail": "แตกแพ็คทรัพยากรเริ่มต้นจากไฟล์ Minecraft jar หรือค้นหาและดาวน์โหลด จากนั้นค้นหาโฟลเดอร์ 'textures' และเปิดมัน Blockbench จะจำตำแหน่งนั้นและพยายามดึงเทกซ์เจอร์จากที่นั่นหากไม่พบในแพ็คทรัพยากรปัจจุบัน",
	"message.default_textures.select": "เลือกโฟลเดอร์ 'textures' เริ่มต้น",
	"message.image_editor.title": "เลือกตัวแก้ไขรูปภาพ",
	"message.image_editor.file": "เลือกไฟล์...",
	"message.image_editor.exe": "เลือกไฟล์ตัวแก้ไขรูปภาพ",
	"message.display_skin.title": "สกิน Minecraft",
	"message.display_skin.message": "เลือกไฟล์สกินจากคอมพิวเตอร์ของคุณหรือป้อนชื่อผู้เล่น",
	"message.display_skin.upload": "เลือกไฟล์",
	"message.display_skin.reset": "รีเซ็ต",
	"message.invalid_plugin": "ไฟล์ปลั๊กอินไม่ถูกต้อง ดูคอนโซล",
	"message.load_plugin_app": "คุณต้องการอนุญาตให้ปลั๊กอินนี้เปลี่ยนแปลงพีซีของคุณหรือไม่? โหลดปลั๊กอินจากผู้สร้างที่คุณเชื่อถือเท่านั้น",
	"message.load_plugin_web": "คุณต้องการโหลดปลั๊กอินนี้หรือไม่? โหลดปลั๊กอินจากผู้สร้างที่คุณเชื่อถือเท่านั้น",
	"message.preset_no_info": "พรีเซ็ตไม่มีข้อมูลสำหรับช่องนี้",
	"message.restart_to_update": "รีสตาร์ท Blockbench เพื่อใช้การเปลี่ยนแปลง",
	"message.save_file": "บันทึกเป็น %0",
	"dialog.project.title": "โปรเจกต์",
	"dialog.project.name": "ชื่อ",
	"dialog.project.parent": "โมเดลแม่",
	"dialog.project.geoname": "ตัวระบุโมเดล",
	"dialog.project.ao": "แอมเบียนท์ออกคลูชัน",
	"dialog.texture.title": "เทกซ์เจอร์",
	"dialog.texture.variable": "ตัวแปร",
	"dialog.texture.namespace": "เนมสเปซ",
	"dialog.texture.folder": "โฟลเดอร์",
	"dialog.extrude.title": "เอ็กซ์ทรูดรูปภาพ",
	"dialog.extrude.mode": "โหมดสแกน",
	"dialog.extrude.mode.areas": "พื้นที่",
	"dialog.extrude.mode.lines": "เส้น",
	"dialog.extrude.mode.columns": "คอลัมน์",
	"dialog.extrude.mode.pixels": "พิกเซล",
	"dialog.extrude.opacity": "ความทึบต่ำสุด",
	"dialog.extrude.scan": "สแกนและนำเข้า",
	"dialog.display_preset.title": "สร้างพรีเซ็ต",
	"dialog.display_preset.message": "เลือกช่องที่คุณต้องการบันทึก",
	"dialog.display_preset.create": "สร้าง",
	"dialog.select.title": "เลือก",
	"dialog.select.group": "ในกลุ่มที่เลือก",
	"dialog.select.name": "ชื่อมี",
	"dialog.select.random": "โอกาสสุ่ม (%)",
	"dialog.select.select": "เลือก",
	"dialog.scale.title": "ปรับขนาดโมเดล",
	"dialog.scale.axis": "แกน",
	"dialog.scale.clipping": "โมเดลคลิป: โมเดลของคุณใหญ่เกินแคนวาส",
	"dialog.scale.confirm": "ปรับขนาด",
	"dialog.plugins.title": "ปลั๊กอิน",
	"dialog.plugins.installed": "ติดตั้งแล้ว",
	"dialog.plugins.available": "พร้อมใช้งาน",
	"dialog.plugins.install": "ติดตั้ง",
	"dialog.plugins.uninstall": "ถอนการติดตั้ง",
	"dialog.plugins.reload": "โหลดใหม่",
	"dialog.plugins.none_installed": "ไม่มีปลั๊กอินที่ติดตั้ง",
	"dialog.plugins.none_available": "ไม่มีปลั๊กอินที่พร้อมใช้งาน",
	"dialog.plugins.web_only": "สำหรับเว็บแอปเท่านั้น",
	"dialog.plugins.app_only": "สำหรับแอปเดสก์ท็อปเท่านั้น",
	"dialog.plugins.author": "โดย %0",
	"dialog.create_texture.folder": "โฟลเดอร์",
	"dialog.create_texture.resolution": "ความละเอียด",
	"dialog.input.title": "ป้อนข้อมูล",
	"dialog.settings.settings": "การตั้งค่า",
	"dialog.settings.keybinds": "แป้นพิมพ์ลัด",
	"dialog.settings.about": "เกี่ยวกับ",
	"layout.color.back": "พื้นหลัง",
	"layout.color.back.desc": "พื้นหลังและช่องป้อนข้อมูล",
	"layout.color.dark": "มืด",
	"layout.color.dark.desc": "พื้นหลังแคนวาส",
	"layout.color.ui": "UI",
	"layout.color.ui.desc": "สีอินเทอร์เฟซหลัก",
	"layout.color.bright_ui": "UI สว่าง",
	"layout.color.bright_ui.desc": "เมนูบริบทและทูลทิป",
	"layout.color.button": "ปุ่ม",
	"layout.color.button.desc": "ปุ่มและสวิตช์",
	"layout.color.selected": "ถูกเลือก",
	"layout.color.selected.desc": "แท็บและวัตถุที่ถูกเลือก",
	"layout.color.border": "ขอบ",
	"layout.color.border.desc": "ขอบของปุ่มและช่องป้อนข้อมูล",
	"layout.color.accent": "สีเน้น",
	"layout.color.accent.desc": "ตัวเลื่อนและรายละเอียดอื่นๆ",
	"layout.color.grid": "กริด",
	"layout.color.grid.desc": "กริดตัวอย่าง 3D",
	"layout.color.text": "ข้อความ",
	"layout.color.text.desc": "ข้อความปกติ",
	"layout.color.light": "สว่าง",
	"layout.color.light.desc": "ข้อความที่ไฮไลต์",
	"layout.color.accent_text": "ข้อความสีเน้น",
	"layout.color.accent_text.desc": "ข้อความบนพื้นหลังสีเน้น",
	"layout.font.main": "ฟอนต์หลัก",
	"layout.font.headline": "ฟอนต์หัวข้อ",
	"about.version": "เวอร์ชัน:",
	"settings.category.general": "ทั่วไป",
	"settings.category.preview": "ตัวอย่าง",
	"settings.category.grid": "ตาราง",
	"settings.category.edit": "แก้ไข",
	"settings.category.snapping": "จับยึด",
	"settings.category.defaults": "ค่าเริ่มต้น",
	"settings.category.dialogs": "กล่องโต้ตอบ",
	"settings.category.export": "ส่งออก",
	"settings.language": "ภาษา",
	"settings.language.desc": "ภาษาของส่วนติดต่อ",
	"settings.backup_interval": "ช่วงสำรองข้อมูล",
	"settings.backup_interval.desc": "ช่วงของการสำรองข้อมูลอัตโนมัติเป็นนาที",
	"settings.origin_size": "เครื่องหมายจุดหมุน",
	"settings.origin_size.desc": "ขนาดของเครื่องหมายจุดหมุน",
	"settings.control_size": "ขนาดกิซโมเปลี่ยน",
	"settings.control_size.desc": "ขนาดของกิซโมเปลี่ยน",
	"settings.display_skin": "แสดงสกิน",
	"settings.display_skin.desc": "แสดงสกินในมุมมองตัวอย่าง",
	"settings.shading": "แรเงา",
	"settings.shading.desc": "เปิดใช้งานการแรเงาในมุมมองตัวอย่าง",
	"settings.base_grid": "กริดเล็ก",
	"settings.base_grid.desc": "แสดงกริดเล็กและแกน",
	"settings.large_grid": "กริดบล็อก",
	"settings.large_grid.desc": "แสดงกริดขนาด 16x16 บล็อก",
	"settings.full_grid": "กริดบล็อกแม่นยำ",
	"settings.full_grid.desc": "แสดงกริดบล็อกแม่นยำระดับพิกเซล",
	"settings.large_box": "กล่องขีดจำกัดขนาด",
	"settings.large_box.desc": "แสดงขอบเขตขีดจำกัดขนาด",
	"settings.display_grid": "กริดโหมดแสดงผล",
	"settings.display_grid.desc": "แสดงกริดในโหมดแสดงผล",
	"settings.undo_limit": "ขีดจำกัดการเลิกทำ",
	"settings.undo_limit.desc": "จำนวนสูงสุดของขั้นตอนที่สามารถเลิกทำได้",
	"settings.local_move": "ย้ายบนแกนสัมพัทธ์",
	"settings.local_move.desc": "ย้ายองค์ประกอบที่หมุนบนแกนของตัวเองถ้าเป็นไปได้",
	"settings.canvas_unselect": "ยกเลิกการเลือกเมื่อคลิกพื้นหลัง",
	"settings.canvas_unselect.desc": "ยกเลิกการเลือกองค์ประกอบทั้งหมดเมื่อคลิกบนพื้นหลังด้านหลังโมเดลหรือในไทม์ไลน์",
	"settings.paint_side_restrict": "จำกัดแปรงตามด้าน",
	"settings.paint_side_restrict.desc": "จำกัดแปรงให้วาดเฉพาะด้านปัจจุบัน",
	"settings.autouv": "UV อัตโนมัติ",
	"settings.autouv.desc": "เปิดใช้ UV อัตโนมัติโดยค่าเริ่มต้น",
	"settings.create_rename": "เปลี่ยนชื่อองค์ประกอบใหม่",
	"settings.create_rename.desc": "โฟกัสช่องชื่อเมื่อสร้างองค์ประกอบหรือกลุ่มใหม่",
	"settings.edit_size": "ความละเอียดกริด",
	"settings.edit_size.desc": "ความละเอียดของกริดที่องค์ประกอบจับยึด",
	"settings.shift_size": "ความละเอียด Shift",
	"settings.shift_size.desc": "ความละเอียดของกริดขณะกด Shift",
	"settings.ctrl_size": "ความละเอียด Control",
	"settings.ctrl_size.desc": "ความละเอียดของกริดขณะกด Control",
	"settings.negative_size": "ขนาดลบ",
	"settings.negative_size.desc": "อนุญาตให้เครื่องมือปรับขนาดใช้ขนาดลบ",
	"settings.minifiedout": "ส่งออกแบบย่อ",
	"settings.minifiedout.desc": "เขียนไฟล์ JSON ในหนึ่งบรรทัด",
	"settings.export_groups": "ส่งออกกลุ่มในโมเดลบล็อก/ไอเทม Java",
	"settings.export_groups.desc": "บันทึกกลุ่มในไฟล์ JSON โมเดลบล็อกหรือไอเทม Java",
	"settings.credit": "ความคิดเห็นเครดิต",
	"settings.credit.desc": "เพิ่มความคิดเห็นเครดิตในไฟล์ที่ส่งออก",
	"settings.default_path": "เส้นทางเทกซ์เจอร์ Minecraft เริ่มต้น",
	"settings.default_path.desc": "โฟลเดอร์ที่ Blockbench โหลดเทกซ์เจอร์เริ่มต้น",
	"settings.image_editor": "ตัวแก้ไขรูปภาพ",
	"settings.image_editor.desc": "ตัวแก้ไขรูปภาพเริ่มต้นสำหรับแก้ไขเทกซ์เจอร์",
	"category.navigate": "การนำทาง",
	"category.tools": "เครื่องมือ",
	"category.file": "ไฟล์",
	"category.blockbench": "Blockbench",
	"category.edit": "แก้ไข",
	"category.transform": "การแปลง",
	"category.view": "มุมมอง",
	"category.display": "แสดงผล",
	"category.textures": "เทกซ์เจอร์",
	"category.misc": "เบ็ดเตล็ด",
	"keybind.preview_select": "เลือก",
	"keybind.preview_rotate": "หมุนมุมมอง",
	"keybind.preview_drag": "ลากมุมมอง",
	"keybind.confirm": "ยืนยัน",
	"keybind.cancel": "ยกเลิก",
	"action.slider_inflate": "พอง",
	"action.slider_inflate.desc": "พองคิวบ์ในทุกทิศทางโดยไม่เปลี่ยน UV",
	"action.slider_brush_size": "ขนาดแปรง",
	"action.slider_brush_size.desc": "รัศมีของแปรงเป็นพิกเซล",
	"action.slider_brush_opacity": "ความทึบ",
	"action.slider_brush_opacity.desc": "ความทึบของแปรงตั้งแต่ 0 ถึง 255",
	"action.slider_brush_softness": "ความนุ่ม",
	"action.slider_brush_softness.desc": "ความนุ่มของแปรงเป็นเปอร์เซ็นต์",
	"action.uv_slider_pos_x": "ย้ายแนวนอน",
	"action.uv_slider_pos_x.desc": "ย้ายหน้า UV ที่เลือกทั้งหมดแนวนอน",
	"action.uv_slider_pos_y": "ย้ายแนวตั้ง",
	"action.uv_slider_pos_y.desc": "ย้ายหน้า UV ที่เลือกทั้งหมดแนวตั้ง",
	"action.uv_slider_size_x": "ขนาดแนวนอน",
	"action.uv_slider_size_x.desc": "ปรับขนาดหน้า UV ที่เลือกทั้งหมดแนวนอน",
	"action.uv_slider_size_y": "ขนาดแนวตั้ง",
	"action.uv_slider_size_y.desc": "ปรับขนาดหน้า UV ที่เลือกทั้งหมดแนวตั้ง",
	"action.vertex_snap_mode": "โหมดจับยึด",
	"action.vertex_snap_mode.desc": "เลือกว่า Vertex Snap ย้ายองค์ประกอบไปยังตำแหน่งที่เลือกหรือปรับขนาด",
	"action.move_tool": "เครื่องมือย้าย",
	"action.move_tool.desc": "ย้ายองค์ประกอบ",
	"action.resize_tool": "เครื่องมือปรับขนาด",
	"action.resize_tool.desc": "ปรับขนาดองค์ประกอบ",
	"action.brush_tool": "เครื่องมือแปรง",
	"action.brush_tool.desc": "วาดด้วยแปรง",
	"action.vertex_snap_tool": "เครื่องมือจับยึดจุดยอด",
	"action.vertex_snap_tool.desc": "จับยึดจุดยอดไปยังจุดยอดอื่น",
	"action.swap_tools": "สลับเครื่องมือ",
	"action.swap_tools.desc": "สลับระหว่างเครื่องมือทางเลือก เช่น ย้ายและปรับขนาด หรือแปรงและตัวเลือกสี",
	"action.project_window": "หน้าต่างโปรเจกต์",
	"action.project_window.desc": "เปิดหน้าต่างโปรเจกต์ ซึ่งคุณสามารถแก้ไขข้อมูลเมตาของโมเดลได้",
	"action.open_model": "เปิดโมเดล",
	"action.open_model.desc": "เปิดไฟล์โมเดลจากคอมพิวเตอร์ของคุณ",
	"action.extrude_texture": "เอ็กซ์ทรูดเทกซ์เจอร์",
	"action.extrude_texture.desc": "สร้างโมเดลโดยยืดเทกซ์เจอร์ออก",
	"action.export_blockmodel": "ส่งออกโมเดลบล็อก/ไอเทม",
	"action.export_blockmodel.desc": "ส่งออกโมเดลบล็อกหรือไอเทม Minecraft Java Edition",
	"action.export_optifine_part": "ส่งออกส่วน OptiFine",
	"action.export_optifine_part.desc": "ส่งออกส่วนเดียวสำหรับโมเดลเอนทิตี OptiFine",
	"action.export_optifine_full": "ส่งออก OptiFine JEM",
	"action.export_optifine_full.desc": "ส่งออกโมเดลเอนทิตี OptiFine แบบเต็ม",
	"action.export_obj": "ส่งออกโมเดล OBJ",
	"action.export_obj.desc": "ส่งออกโมเดล Wavefront OBJ สำหรับเรนเดอร์",
	"action.settings_window": "การตั้งค่า...",
	"action.settings_window.desc": "เปิดกล่องโต้ตอบการตั้งค่า Blockbench",
	"action.plugins_window": "ปลั๊กอิน...",
	"action.plugins_window.desc": "เปิดหน้าต่างร้านปลั๊กอิน",
	"action.reset_layout": "รีเซ็ตเลย์เอาต์",
	"action.reset_layout.desc": "รีเซ็ตเลย์เอาต์เป็นค่าเริ่มต้นของ Blockbench",
	"action.load_plugin": "โหลดปลั๊กอินจากไฟล์",
	"action.load_plugin.desc": "โหลดปลั๊กอินโดยนำเข้าไฟล์ต้นฉบับ",
	"action.reload_plugins": "โหลดปลั๊กอินใหม่",
	"action.reload_plugins.desc": "โหลดปลั๊กอินพัฒนาทั้งหมดใหม่",
	"action.undo": "เลิกทำ",
	"action.undo.desc": "เลิกทำการกระทำล่าสุด",
	"action.redo": "ทำซ้ำ",
	"action.redo.desc": "ทำซ้ำการกระทำที่ถูกเลิก",
	"action.copy": "คัดลอก",
	"action.copy.desc": "คัดลอกองค์ประกอบที่เลือกไปยังคลิปบอร์ด",
	"action.paste": "วาง",
	"action.paste.desc": "วางจากคลิปบอร์ด",
	"action.cut": "ตัด",
	"action.cut.desc": "ตัดองค์ประกอบที่เลือกไปยังคลิปบอร์ด",
	"action.add_cube": "เพิ่มคิวบ์",
	"action.add_cube.desc": "เพิ่มคิวบ์ใหม่",
	"action.add_group": "เพิ่มกลุ่ม",
	"action.add_group.desc": "เพิ่มกลุ่มใหม่",
	"action.outliner_toggle": "สลับตัวเลือกเพิ่มเติม",
	"action.outliner_toggle.desc": "สลับสวิตช์สำหรับตัวเลือกเพิ่มเติมในเอาต์ไลเนอร์",
	"action.duplicate": "ทำสำเนา",
	"action.delete": "ลบ",
	"action.sort_outliner": "เรียงเอาต์ไลเนอร์",
	"action.sort_outliner.desc": "เรียงเอาต์ไลเนอร์ตามตัวอักษร",
	"action.select_window": "เลือก...",
	"action.select_window.desc": "ค้นหาและเลือกองค์ประกอบตามคุณสมบัติ",
	"action.invert_selection": "กลับการเลือก",
	"action.invert_selection.desc": "กลับการเลือกขององค์ประกอบ",
	"action.select_all": "เลือกทั้งหมด",
	"action.collapse_groups": "ยุบกลุ่ม",
	"action.collapse_groups.desc": "ยุบกลุ่มทั้งหมดในเอาต์ไลเนอร์",
	"action.scale": "ปรับขนาด",
	"action.scale.desc": "ปรับขนาดองค์ประกอบที่เลือก",
	"action.toggle_visibility": "สลับการมองเห็น",
	"action.toggle_visibility.desc": "สลับการมองเห็นขององค์ประกอบที่เลือก",
	"action.toggle_export": "สลับการส่งออก",
	"action.toggle_export.desc": "สลับการตั้งค่าการส่งออกขององค์ประกอบที่เลือก",
	"action.toggle_autouv": "สลับ UV อัตโนมัติ",
	"action.toggle_autouv.desc": "สลับการตั้งค่า UV อัตโนมัติขององค์ประกอบที่เลือก",
	"action.toggle_shade": "สลับการแรเงา",
	"action.toggle_shade.desc": "สลับการแรเงาของคิวบ์ที่เลือก",
	"action.rename": "เปลี่ยนชื่อ",
	"action.rename.desc": "เปลี่ยนชื่อองค์ประกอบหรือกลุ่มที่เลือก",
	"action.add_display_preset": "พรีเซ็ตใหม่",
	"action.add_display_preset.desc": "เพิ่มพรีเซ็ตการตั้งค่าการแสดงผลใหม่",
	"action.fullscreen": "เต็มจอ",
	"action.fullscreen.desc": "สลับโหมดเต็มจอ",
	"action.zoom_in": "ซูมเข้า",
	"action.zoom_in.desc": "ซูมเข้าในมุมมอง",
	"action.zoom_out": "ซูมออก",
	"action.zoom_out.desc": "ซูมออกในมุมมอง",
	"action.zoom_reset": "รีเซ็ตซูม",
	"action.zoom_reset.desc": "รีเซ็ตซูมเป็น 100% ค่าเริ่มต้น",
	"action.reset_interface": "รีเซ็ตอินเทอร์เฟซ",
	"action.reset_interface.desc": "รีเซ็ตขนาดและตำแหน่งของ GUI",
	"action.screenshot_model": "ภาพหน้าจอโมเดล",
	"action.screenshot_model.desc": "ถ่ายภาพหน้าจอโมเดลจากมุมปัจจุบัน",
	"action.screenshot_app": "ภาพหน้าจอแอป",
	"action.screenshot_app.desc": "ถ่ายภาพหน้าจอของทั้งแอปพลิเคชัน",
	"action.import_texture": "นำเข้าเทกซ์เจอร์",
	"action.import_texture.desc": "นำเข้าเทกซ์เจอร์จากไฟล์",
	"action.create_texture": "สร้างเทกซ์เจอร์",
	"action.create_texture.desc": "สร้างเทกซ์เจอร์ใหม่",
	"action.save_textures": "บันทึกเทกซ์เจอร์",
	"action.save_textures.desc": "บันทึกเทกซ์เจอร์ที่ยังไม่ได้บันทึกทั้งหมด",
	"action.animated_textures": "เล่นเทกซ์เจอร์แบบเคลื่อนไหว",
	"action.animated_textures.desc": "เล่นและหยุดตัวอย่างเทกซ์เจอร์แบบเคลื่อนไหว",
	"action.origin_to_geometry": "จัดกึ่งกลางจุดหมุน",
	"action.origin_to_geometry.desc": "ตั้งจุดหมุนไปยังศูนย์กลางของส่วนที่เลือก",
	"action.bone_reset_toggle": "รีเซ็ตกระดูก",
	"action.bone_reset_toggle.desc": "หยุดแสดงคิวบ์จากโมเดลพาเรนต์บนกระดูก",
	"action.reload": "โหลด Blockbench ใหม่",
	"action.reload.desc": "โหลด Blockbench ใหม่ การดำเนินการนี้จะลบความคืบหน้าที่ยังไม่ได้บันทึกทั้งหมด",
	"menu.file": "ไฟล์",
	"menu.edit": "แก้ไข",
	"menu.transform": "การแปลง",
	"menu.display": "แสดงผล",
	"menu.view": "มุมมอง",
	"menu.file.new": "ใหม่",
	"menu.file.recent": "ล่าสุด",
	"menu.file.import": "นำเข้า",
	"menu.file.export": "ส่งออก",
	"menu.transform.rotate": "หมุน",
	"menu.transform.flip": "พลิก",
	"menu.transform.center": "จัดกึ่งกลาง",
	"menu.transform.properties": "คุณสมบัติ",
	"menu.display.preset": "ใช้พรีเซ็ต",
	"menu.display.preset_all": "ใช้พรีเซ็ตทุกที่",
	"menu.display.remove_preset": "ลบพรีเซ็ต",
	"menu.view.zoom": "ซูม",
	"menu.view.background": "พื้นหลัง",
	"menu.view.screenshot": "ภาพหน้าจอ",
	"menu.cube.color": "สีเครื่องหมาย",
	"menu.cube.texture": "เทกซ์เจอร์",
	"menu.cube.texture.transparent": "โปร่งใส",
	"menu.cube.texture.blank": "ว่างเปล่า",
	"menu.group.sort": "เรียงลำดับ",
	"menu.texture.face": "ใช้กับหน้า",
	"menu.texture.file": "ไฟล์",
	"menu.texture.refresh": "รีเฟรช",
	"menu.texture.change": "เปลี่ยนไฟล์",
	"menu.texture.folder": "แสดงในตัวสำรวจไฟล์",
	"menu.texture.edit": "แก้ไข",
	"menu.texture.export": "บันทึกเป็น",
	"menu.texture.save": "บันทึก",
	"menu.texture.properties": "คุณสมบัติ...",
	"menu.preview.background": "พื้นหลัง",
	"menu.preview.background.load": "โหลด",
	"menu.preview.background.position": "ตำแหน่ง",
	"menu.preview.background.lock": "ล็อกกับกล้อง",
	"menu.preview.screenshot": "ภาพหน้าจอ",
	"menu.preview.perspective": "เพอร์สเปกทิฟ",
	"menu.preview.perspective.normal": "ปกติ",
	"menu.preview.quadview": "มุมมอง 4 ส่วน",
	"menu.preview.stop_drag": "หยุดการวางตำแหน่งพื้นหลัง",
	"menu.uv.mapping.rotation": "การหมุน",
	"menu.uv.texture": "เทกซ์เจอร์",
	"cube.color.light_blue": "ฟ้าอ่อน",
	"cube.color.yellow": "เหลือง",
	"cube.color.orange": "ส้ม",
	"cube.color.red": "แดง",
	"cube.color.purple": "ม่วง",
	"cube.color.blue": "น้ำเงิน",
	"cube.color.green": "เขียว",
	"cube.color.lime": "เขียวมะนาว",
	"switches.visibility": "การมองเห็น",
	"switches.export": "ส่งออก",
	"switches.autouv": "UV อัตโนมัติ",
	"panel.uv": "UV",
	"panel.display": "แสดงผล",
	"panel.textures": "เทกซ์เจอร์",
	"panel.outliner": "เอาต์ไลเนอร์",
	"uv_editor.title": "ตัวแก้ไข UV",
	"uv_editor.all_faces": "ทั้งหมด",
	"uv_editor.no_faces": "ไม่มี",
	"face.north": "เหนือ",
	"face.south": "ใต้",
	"face.west": "ตะวันตก",
	"face.east": "ตะวันออก",
	"face.up": "บน",
	"face.down": "ล่าง",
	"direction.north": "เหนือ",
	"direction.south": "ใต้",
	"direction.west": "ตะวันตก",
	"direction.east": "ตะวันออก",
	"direction.top": "บน",
	"direction.bottom": "ล่าง",
	"display.slot.third_right": "บุคคลที่สามขวา",
	"display.slot.third_left": "บุคคลที่สามซ้าย",
	"display.slot.first_right": "บุคคลที่หนึ่งขวา",
	"display.slot.first_left": "บุคคลที่หนึ่งซ้าย",
	"display.slot.head": "หัว",
	"display.slot.ground": "พื้น",
	"display.slot.frame": "กรอบ",
	"display.slot.gui": "GUI",
	"display.rotation": "การหมุน",
	"display.translation": "การเคลื่อนย้าย",
	"display.scale": "มาตราส่วน",
	"display.slot": "ช่อง",
	"display.reference": "โมเดลอ้างอิง",
	"display.reference.player": "ผู้เล่น",
	"display.reference.zombie": "ซอมบี้",
	"display.reference.armor_stand": "แท่นเกราะ",
	"display.reference.baby_zombie": "ซอมบี้เด็ก",
	"display.reference.armor_stand_small": "แท่นเกราะเล็ก",
	"display.reference.monitor": "ปกติ",
	"display.reference.bow": "ธนูที่จัดเตรียม",
	"display.reference.block": "บล็อก",
	"display.reference.frame": "กรอบไอเทม",
	"display.reference.inventory_nine": "3x3",
	"display.reference.inventory_full": "ช่องเก็บของ",
	"display.reference.hud": "HUD",
	"display.preset.blank_name": "กรุณาใส่ชื่อ",
	"display.preset.item": "ไอเทมเริ่มต้น",
	"display.preset.block": "บล็อกเริ่มต้น",
	"display.preset.handheld": "อาวุธเริ่มต้น",
	"display.preset.rod": "เบ็ดเริ่มต้น",
	"dialog.continue": "ดำเนินการต่อ",
	"message.square_textures": "เทกซ์เจอร์ต้องเป็นรูปสี่เหลี่ยมจัตุรัส",
	"message.unsaved_texture.title": "เทกซ์เจอร์ที่ยังไม่ได้บันทึก",
	"message.unsaved_texture.message": "การเปลี่ยนแปลงที่ยังไม่ได้บันทึกทั้งหมดของเทกซ์เจอร์นี้จะสูญหาย คุณต้องการดำเนินการต่อหรือไม่?",
	"action.vertex_snap_mode.move": "ย้าย",
	"action.vertex_snap_mode.scale": "มาตราส่วน",
	"action.open_model_folder": "เปิดโฟลเดอร์โมเดล",
	"action.open_model_folder.desc": "เปิดโฟลเดอร์ที่เก็บโมเดล",
	"action.change_textures_folder": "เปลี่ยนตำแหน่งเทกซ์เจอร์",
	"action.change_textures_folder.desc": "เปลี่ยนโฟลเดอร์ที่บันทึกเทกซ์เจอร์ทั้งหมด",
	"menu.texture.particle": "ใช้สำหรับอนุภาค",
	"message.update_notification.title": "ไม่สามารถติดตั้งอัปเดต",
	"message.update_notification.message": "มีเวอร์ชันใหม่ของ Blockbench กรุณาเปิดใช้งานอัปเดตอัตโนมัติในการตั้งค่าเพื่ออัปเดต!",
	"message.untextured": "พื้นผิวนี้ไม่มีเทกซ์เจอร์",
	"dialog.toolbar_edit.title": "ปรับแต่งแถบเครื่องมือ",
	"keybindings.reset": "รีเซ็ต",
	"keybindings.clear": "ยกเลิกการตั้งค่า",
	"action.cube_counter": "สถิติโมเดล",
	"action.uv_rotation": "การหมุน UV",
	"action.uv_rotation.desc": "การหมุนของหน้า UV",
	"action.uv_grid": "กริด UV",
	"action.uv_grid.desc": "ความละเอียดของกริดที่ตัวเลือก UV จับยึด",
	"action.uv_grid.auto": "อัตโนมัติ",
	"action.uv_maximize": "ขยาย UV ใหญ่สุด",
	"action.uv_maximize.desc": "ตั้ง UV ของหน้านี้เป็นเทกซ์เจอร์ทั้งหมด",
	"action.uv_auto": "UV อัตโนมัติ",
	"action.uv_auto.desc": "ตั้งขนาด UV ของหน้านี้เป็นขนาดจริงของหน้า",
	"action.uv_rel_auto": "UV อัตโนมัติสัมพัทธ์",
	"action.uv_rel_auto.desc": "ตั้ง UV ของหน้านี้เป็นตำแหน่งและขนาดจริงของหน้า",
	"action.uv_mirror_x": "สะท้อน UV X",
	"action.uv_mirror_x.desc": "สะท้อน UV ของหน้านี้บนแกน X",
	"action.uv_mirror_y": "สะท้อน UV Y",
	"action.uv_mirror_y.desc": "สะท้อน UV ของหน้านี้บนแกน Y",
	"action.uv_transparent": "ลบหน้า",
	"action.uv_transparent.desc": "ลบหน้าปัจจุบัน",
	"action.uv_reset": "รีเซ็ตหน้า",
	"action.uv_reset.desc": "รีเซ็ตหน้าปัจจุบัน",
	"action.cullface": "Cullface",
	"action.cullface.desc": "ปิดการเรนเดอร์หน้านี้หากด้านที่เลือกของโมเดลถูกปิด",
	"action.auto_cullface": "เปิดใช้ Cullface",
	"action.auto_cullface.desc": "ตั้ง cullface ของหน้านี้เป็นตัวมันเอง",
	"action.face_tint": "ทินต์",
	"action.face_tint.desc": "เปิดใช้ตัวเลือกทินต์สำหรับหน้าปัจจุบัน",
	"menu.toolbar.edit": "ปรับแต่งแถบเครื่องมือ",
	"menu.toolbar.reset": "รีเซ็ตแถบเครื่องมือ",
	"uv_editor.rotated": "หมุนแล้ว",
	"uv_editor.auto_cull": "Cullface ตัวเอง",
	"uv_editor.copied": "คัดลอกหน้าแล้ว",
	"uv_editor.pasted": "วางหน้าแล้ว",
	"uv_editor.copied_x": "คัดลอก %0 หน้าแล้ว",
	"uv_editor.reset": "รีเซ็ตหน้า",
	"uv_editor.maximized": "ขยายเต็ม",
	"uv_editor.autouv": "ขนาดอัตโนมัติ",
	"uv_editor.mirrored": "สะท้อนแล้ว",
	"uv_editor.to_all": "นำไปใช้กับทุกหน้าแล้ว",
	"uv_editor.transparent": "ทำให้โปร่งใสแล้ว",
	"uv_editor.cullface_on": "เปิด Cullface",
	"uv_editor.cullface_off": "ปิด Cullface",
	"uv_editor.tint_on": "เปิดการย้อมสี",
	"uv_editor.tint_off": "ปิดการย้อมสี",
	"action.uv_apply_all": "ใช้กับหน้าทั้งหมด",
	"action.uv_apply_all.desc": "ใช้การตั้งค่าของหน้าปัจจุบันกับหน้าทั้งหมด",
	"message.image_editor_missing.title": "ตัวแก้ไขรูปภาพเริ่มต้น",
	"message.image_editor_missing.message": "เลือกไฟล์โปรแกรมของตัวแก้ไขรูปภาพของคุณ",
	"message.image_editor_missing.detail": "Blockbench ไม่พบตัวแก้ไขรูปภาพบนคอมพิวเตอร์ของคุณ เลือกไฟล์โปรแกรมของตัวแก้ไขรูปภาพที่คุณต้องการ",
	"action.update_autouv": "อัปเดต UV อัตโนมัติ",
	"action.update_autouv.desc": "อัปเดตการแมป UV อัตโนมัติของคิวบ์ที่เลือก",
	"category.uv": "UV",
	"status_bar.saved": "บันทึกโมเดลแล้ว",
	"status_bar.unsaved": "มีการเปลี่ยนแปลงที่ยังไม่ได้บันทึก",
	"action.move_up": "ย้ายขึ้น",
	"action.move_up.desc": "ย้ายองค์ประกอบที่เลือกขึ้นตามมุมกล้องปัจจุบัน",
	"action.move_down": "ย้ายลง",
	"action.move_down.desc": "ย้ายองค์ประกอบที่เลือกลงตามมุมกล้องปัจจุบัน",
	"action.move_left": "ย้ายซ้าย",
	"action.move_left.desc": "ย้ายองค์ประกอบที่เลือกซ้ายตามมุมกล้องปัจจุบัน",
	"action.move_right": "ย้ายขวา",
	"action.move_right.desc": "ย้ายองค์ประกอบที่เลือกขวาตามมุมกล้องปัจจุบัน",
	"action.move_forth": "ย้ายไปข้างหน้า",
	"action.move_forth.desc": "ย้ายองค์ประกอบที่เลือกไปข้างหน้าตามมุมกล้องปัจจุบัน",
	"action.move_back": "ย้ายกลับ",
	"action.move_back.desc": "ย้ายองค์ประกอบที่เลือกกลับตามมุมกล้องปัจจุบัน",
	"layout.color.wireframe": "โครงลวด",
	"layout.color.wireframe.desc": "เส้นมุมมองโครงลวด",
	"action.add_animation": "เพิ่มแอนิเมชัน",
	"action.add_animation.desc": "เพิ่มแอนิเมชันใหม่",
	"action.load_animation_file": "นำเข้าแอนิเมชัน",
	"action.load_animation_file.desc": "นำเข้าไฟล์แอนิเมชัน",
	"action.play_animation": "เล่นแอนิเมชัน",
	"action.play_animation.desc": "เล่นหรือหยุดแอนิเมชันชั่วคราว",
	"action.slider_keyframe_time": "รหัสเวลา",
	"action.slider_keyframe_time.desc": "เปลี่ยนรหัสเวลาของคีย์เฟรมที่เลือก",
	"timeline.rotation": "การหมุน",
	"timeline.position": "ตำแหน่ง",
	"timeline.scale": "มาตราส่วน",
	"menu.keyframe.quaternion": "ควอเทอร์เนียน",
	"panel.animations": "แอนิเมชัน",
	"panel.keyframe": "คีย์เฟรม",
	"panel.keyframe.type": "คีย์เฟรม (%0)",
	"generic.delete": "ลบ",
	"generic.rename": "เปลี่ยนชื่อ",
	"message.no_animation_selected": "คุณต้องเลือกแอนิเมชันก่อนจึงจะทำได้",
	"message.no_bone_selected": "คุณต้องเลือกกระดูกก่อนจึงจะทำได้",
	"message.duplicate_groups.title": "ชื่อกระดูกซ้ำ",
	"message.duplicate_groups.message": "ชื่อของกระดูกนี้มีอยู่หลายตัว อาจทำให้เกิดปัญหาได้",
	"action.delete_keyframes": "ลบคีย์เฟรม",
	"action.delete_keyframes.desc": "ลบคีย์เฟรมที่เลือกทั้งหมด",
	"menu.animation": "แอนิเมชัน",
	"menu.animation.loop": "โหมดวนซ้ำ",
	"menu.animation.override": "แทนที่",
	"menu.animation.anim_time_update": "อัปเดตเวลาแอนิเมชัน",
	"message.display_skin_model.title": "โมเดลสกิน",
	"message.display_skin_model.message": "เลือกประเภทโมเดลของสกินของคุณ",
	"message.display_skin_model.classic": "คลาสสิก",
	"message.display_skin_model.slim": "สลิม",
	"message.bone_material": "เปลี่ยนวัสดุกระดูก",
	"action.slider_animation_length": "ความยาวแอนิเมชัน",
	"action.slider_animation_length.desc": "เปลี่ยนความยาวของแอนิเมชันที่เลือก",
	"panel.variable_placeholders": "ตัวยึดตัวแปร",
	"panel.variable_placeholders.info": "ระบุตัวแปรที่ต้องการดูตัวอย่างในรูปแบบ ชื่อ=ค่า",
	"status_bar.vertex_distance": "ระยะทาง: %0",
	"dialog.create_gif.title": "บันทึก GIF",
	"dialog.create_gif.length": "ความยาว",
	"dialog.create_gif.fps": "FPS",
	"dialog.create_gif.play": "เล่นแอนิเมชัน",
	"category.animation": "แอนิเมชัน",
	"action.record_model_gif": "บันทึก GIF...",
	"action.record_model_gif.desc": "บันทึก GIF แอนิเมชันของโมเดลจากมุมปัจจุบัน",
	"display.mirror": "สะท้อน",
	"data.separator": "ตัวคั่น",
	"menu.preview.background.set_position": "ตั้งตำแหน่ง",
	"dialog.toolbar_edit.hidden": "ซ่อน",
	"action.export_class_entity": "ส่งออกเอนทิตี Java",
	"action.export_class_entity.desc": "ส่งออกโมเดลเอนทิตีเป็นคลาส Java",
	"settings.seethrough_outline": "เส้นรอบ X-Ray",
	"settings.seethrough_outline.desc": "แสดงเส้นรอบผ่านวัตถุ",
	"mode.edit": "แก้ไข",
	"mode.paint": "วาดรูป",
	"mode.display": "การแสดงผล",
	"mode.animate": "แอนิเมชัน",
	"status_bar.recording_gif": "กำลังบันทึก",
	"status_bar.processing_gif": "กำลังประมวลผล",
	"settings.backup_retain": "ระยะเวลาเก็บสำรอง",
	"settings.backup_retain.desc": "ตั้งระยะเวลาที่ Blockbench เก็บข้อมูลสำรองเก่าเป็นวัน",
	"action.rotate_tool": "เครื่องมือหมุน",
	"action.rotate_tool.desc": "หมุนองค์ประกอบ",
	"action.fill_tool": "เครื่องมือเติมสี",
	"action.fill_tool.desc": "เติมสีในพื้นที่",
	"action.eraser": "ยางลบ",
	"action.eraser.desc": "เครื่องมือยางลบเพื่อแทนที่สีบนเทกซ์เจอร์ด้วยความโปร่งใส",
	"action.color_picker": "ตัวเลือกสี",
	"action.color_picker.desc": "เครื่องมือเลือกสีจากพิกเซลบนเทกซ์เจอร์",
	"switches.mirror": "สะท้อน UV",
	"language_name": "ภาษาไทย",
	"message.plugin_reload": "โหลดปลั๊กอินในเครื่อง %0 ใหม่แล้ว",
	"settings.brightness": "ความสว่าง",
	"settings.brightness.desc": "ความสว่างของตัวอย่าง ค่าเริ่มต้นคือ 50",
	"menu.preview.perspective.reset": "รีเซ็ตกล้อง",
	"action.fill_mode": "โหมดเติม",
	"action.fill_mode.face": "หน้า",
	"action.fill_mode.color": "สี",
	"action.toggle_mirror_uv": "สะท้อน UV",
	"action.toggle_mirror_uv.desc": "สลับการสะท้อน UV บนแกน X ของคิวบ์ที่เลือก",
	"menu.texture.blank": "ใช้กับหน้าที่ไม่มีเทกซ์เจอร์",
	"dialog.scale.select_overflow": "เลือกส่วนเกิน",
	"action.action_control": "ควบคุมแอคชัน",
	"action.action_control.desc": "ค้นหาและเรียกใช้แอคชันที่มีอยู่",
	"keybindings.recording": "กำลังบันทึกแป้นพิมพ์ลัด",
	"keybindings.press": "กดปุ่มหรือชุดปุ่มหรือคลิกที่ใดก็ได้บนหน้าจอเพื่อบันทึกแป้นพิมพ์ลัดของคุณ",
	"action.pivot_tool": "เครื่องมือจุดหมุน",
	"action.pivot_tool.desc": "ย้ายจุดหมุนขององค์ประกอบ",
	"action.slider_animation_speed": "ความเร็วแอนิเมชัน",
	"action.slider_animation_speed.desc": "ปรับความเร็วการเล่นแอนิเมชัน",
	"action.previous_keyframe": "คีย์เฟรมก่อนหน้า",
	"action.previous_keyframe.desc": "ไปยังคีย์เฟรมก่อนหน้า",
	"action.next_keyframe": "คีย์เฟรมถัดไป",
	"action.next_keyframe.desc": "ไปยังคีย์เฟรมถัดไป",
	"message.outdated_client.title": "เวอร์ชันเก่า",
	"message.outdated_client.message": "กรุณาอัปเดตเป็นเวอร์ชันล่าสุดของ Blockbench เพื่อดำเนินการ",
	"action.export_asset_archive": "ดาวน์โหลดไฟล์เก็บถาวร",
	"action.export_asset_archive.desc": "ดาวน์โหลดไฟล์เก็บถาวรพร้อมโมเดลและเทกซ์เจอร์ทั้งหมด",
	"action.upload_sketchfab": "อัปโหลดไป Sketchfab...",
	"message.sketchfab.name_or_token": "กรุณาป้อนโทเคน Sketchfab และชื่อ",
	"dialog.sketchfab_uploader.title": "อัปโหลดโมเดล Sketchfab",
	"dialog.sketchfab_uploader.token": "โทเคน API",
	"dialog.sketchfab_uploader.about_token": "โทเคนใช้เพื่อเชื่อมต่อ Blockbench กับบัญชี Sketchfab ของคุณ คุณสามารถค้นหาได้ที่ %0",
	"dialog.sketchfab_uploader.name": "ชื่อโมเดล",
	"dialog.sketchfab_uploader.description": "คำอธิบาย",
	"dialog.sketchfab_uploader.tags": "แท็ก",
	"settings.sketchfab_token": "โทเคน Sketchfab",
	"settings.sketchfab_token.desc": "โทเคนเพื่ออนุญาตให้ Blockbench อัปโหลดไปยังบัญชี Sketchfab ของคุณ",
	"panel.color": "สี",
	"data.origin": "จุดหมุน",
	"message.sketchfab.success": "อัปโหลดโมเดลสำเร็จ",
	"message.sketchfab.error": "อัปโหลดโมเดลไปยัง Sketchfab ล้มเหลว",
	"settings.outliner_colors": "สีเอาต์ไลเนอร์",
	"settings.outliner_colors.desc": "แสดงสีองค์ประกอบและกลุ่มในเอาต์ไลเนอร์",
	"action.upload_sketchfab.desc": "อัปโหลดโมเดลของคุณไป Sketchfab",
	"action.element_colors": "สีคิวบ์",
	"action.element_colors.desc": "แสดงสีคิวบ์ในเอาต์ไลเนอร์",
	"texture.error.file": "ไม่พบไฟล์",
	"texture.error.parent": "ไฟล์เทกซ์เจอร์จัดเตรียมโดยโมเดลแม่",
	"message.recover_backup.title": "กู้คืนโมเดล",
	"message.recover_backup.message": "Blockbench ถูกปิดโดยไม่ได้บันทึก คุณต้องการกู้คืนโมเดลหรือไม่?",
	"message.invalid_session.title": "โทเคนเซสชันไม่ถูกต้อง",
	"message.invalid_session.message": "เซสชันที่คุณพยายามเข้าร่วมหมดอายุแล้วหรือโทเคนที่ให้มาไม่ถูกต้อง",
	"dialog.create_texture.power": "ขนาดกำลัง 2",
	"dialog.create_gif.turn": "ความเร็วเทิร์นเทเบิล",
	"action.edit_session": "เซสชันแก้ไข",
	"action.edit_session.desc": "เปิดหน้าต่างเซสชันแก้ไข",
	"action.reset_keyframe": "รีเซ็ตคีย์เฟรม",
	"action.reset_keyframe.desc": "รีเซ็ตค่าทั้งหมดของคีย์เฟรมที่เลือก",
	"dialog.edit_session.title": "เซสชันแก้ไข",
	"edit_session.username": "ชื่อผู้ใช้",
	"edit_session.token": "โทเค็น",
	"edit_session.about": "เซสชันแก้ไขสามารถใช้ร่วมกันแก้ไขโมเดลผ่านอินเทอร์เน็ต สร้างเซสชัน คัดลอกโทเค็น และส่งให้เพื่อน ซึ่งสามารถใช้เข้าร่วมได้",
	"edit_session.join": "เข้าร่วมเซสชัน",
	"edit_session.create": "สร้างเซสชัน",
	"edit_session.quit": "ออกจากเซสชัน",
	"edit_session.joined": "%0 เข้าร่วมเซสชันแล้ว",
	"edit_session.left": "%0 ออกจากเซสชันแล้ว",
	"edit_session.quit_session": "ออกจากเซสชันปัจจุบันแล้ว",
	"edit_session.status": "สถานะ",
	"edit_session.hosting": "กำลังโฮสต์",
	"edit_session.connected": "เชื่อมต่อกับเซสชันแล้ว",
	"dialog.sketchfab_uploader.private": "ส่วนตัว (Pro)",
	"dialog.sketchfab_uploader.password": "รหัสผ่าน (Pro)",
	"action.uv_select_all": "เลือกทั้งหมด",
	"action.uv_select_all.desc": "เลือกหน้าทั้งหมดในกล่องโต้ตอบ UV",
	"panel.chat": "แชท",
	"edit_session.welcome": "ยินดีต้อนรับสู่เซสชันของ %0",
	"dialog.yes": "ใช่",
	"dialog.no": "ไม่",
	"generic.remove": "ลบออก",
	"generic.download": "ดาวน์โหลด",
	"generic.search": "ค้นหา",
	"dates.today": "วันนี้",
	"dates.yesterday": "เมื่อวาน",
	"dates.this_week": "สัปดาห์นี้",
	"dates.weeks_ago": "%0 สัปดาห์ที่แล้ว",
	"mode.start.new": "ใหม่",
	"mode.start.recent": "ล่าสุด",
	"format.free": "ทั่วไป",
	"format.free.desc": "โมเดลโดยไม่มีข้อจำกัด สำหรับเอนจินเกม เรนเดอร์ ฯลฯ",
	"format.java_block": "Java Block",
	"format.java_block.desc": "โมเดลบล็อกหรือไอเทมสำหรับ Minecraft Java Edition",
	"format.bedrock": "Bedrock",
	"format.bedrock.desc": "โมเดล Minecraft Bedrock Edition สำหรับเอนทิตีและไอเทมแนบตัว",
	"format.bedrock_old": "Bedrock เก่า",
	"format.bedrock_old.desc": "โมเดลเอนทิตี Minecraft Bedrock Edition ก่อนเวอร์ชัน 1.12",
	"format.modded_entity": "Modded Entity",
	"format.modded_entity.desc": "โมเดลเอนทิตีสำหรับม็อด Minecraft สามารถส่งออกเป็นไฟล์คลาส .java ได้",
	"format.optifine_entity": "OptiFine Entity",
	"format.optifine_entity.desc": "โมเดลเอนทิตีกำหนดเองสำหรับม็อด OptiFine",
	"keys.mouse": "ปุ่มเมาส์ %0",
	"message.cleared_blank_faces.title": "หน้าว่างเปล่า",
	"message.cleared_blank_faces.message": "Blockbench พบ %0 คิวบ์ที่ไม่มีเทกซ์เจอร์ คุณต้องการลบองค์ประกอบเหล่านั้นหรือไม่?",
	"message.wireframe.enabled": "เปิดมุมมองโครงลวดแล้ว",
	"message.wireframe.disabled": "ปิดมุมมองโครงลวดแล้ว",
	"dialog.convert_project.title": "แปลงโปรเจกต์",
	"dialog.create_texture.double_use": "คงการใช้เทกซ์เจอร์หลายอัน",
	"dialog.model_stats.title": "สถิติโมเดล",
	"dialog.model_stats.cubes": "คิวบ์",
	"dialog.model_stats.locators": "ตัวระบุตำแหน่ง",
	"dialog.model_stats.groups": "กลุ่ม",
	"dialog.model_stats.vertices": "จุดยอด",
	"dialog.model_stats.faces": "หน้า",
	"settings.username": "ชื่อผู้ใช้",
	"settings.username.desc": "ชื่อผู้ใช้สำหรับเซสชันแก้ไข",
	"settings.painting_grid": "ตารางวาดรูป",
	"settings.painting_grid.desc": "แสดงตารางในโหมดวาดรูป",
	"action.convert_project": "แปลงโปรเจกต์",
	"action.convert_project.desc": "แปลงโปรเจกต์ปัจจุบันเป็นรูปแบบอื่น",
	"action.close_project": "ปิดโปรเจกต์",
	"action.close_project.desc": "ปิดโปรเจกต์ที่เปิดอยู่",
	"action.export_bedrock": "ส่งออกเรขาคณิต Bedrock",
	"action.export_bedrock.desc": "ส่งออกโมเดลเป็นไฟล์เรขาคณิต Bedrock Edition",
	"action.save_project": "บันทึกโปรเจกต์",
	"action.save_project.desc": "บันทึกโมเดลปัจจุบันเป็นไฟล์โปรเจกต์",
	"action.save_project_as": "บันทึกโปรเจกต์เป็น",
	"action.save_project_as.desc": "บันทึกโมเดลปัจจุบันเป็นไฟล์โปรเจกต์ที่ตำแหน่งใหม่",
	"action.export_over": "บันทึกโมเดล",
	"action.export_over.desc": "บันทึกโมเดล เทกซ์เจอร์ และแอนิเมชันโดยเขียนทับไฟล์",
	"action.add_locator": "เพิ่มตัวระบุตำแหน่ง",
	"action.add_locator.desc": "เพิ่มตัวระบุตำแหน่งใหม่",
	"action.uv_turn_mapping": "เปลี่ยนการแมป",
	"action.uv_turn_mapping.desc": "หมุนการแมป UV 90 องศา",
	"action.remove_blank_faces": "ลบหน้าว่าง",
	"action.remove_blank_faces.desc": "ลบหน้าที่ไม่มีเทกซ์เจอร์ทั้งหมดของส่วนที่เลือก",
	"web.download_app": "ดาวน์โหลดแอป",
	"uv_editor.turned": "หมุนการแมปแล้ว",
	"display.reference.crossbow": "หน้าไม้ที่จัดเตรียม",
	"dialog.settings.search_results": "ผลการค้นหา",
	"settings.animation_snap": "การจับยึดแอนิเมชัน",
	"settings.animation_snap.desc": "ช่วงการจับยึดเริ่มต้นสำหรับคีย์เฟรมในไทม์ไลน์แอนิเมชันเป็นขั้นต่อวินาที สามารถเปลี่ยนได้ต่อแอนิเมชัน ค่าเริ่มต้นคือ 24",
	"action.import_optifine_part": "นำเข้าส่วน OptiFine",
	"action.import_optifine_part.desc": "นำเข้าโมเดลส่วนเอนทิตีสำหรับ OptiFine",
	"data.locator": "ตัวระบุตำแหน่ง",
	"mode.start.no_recents": "ไม่มีโมเดลที่เปิดล่าสุด",
	"panel.element": "องค์ประกอบ",
	"panel.element.position": "ตำแหน่ง",
	"panel.element.size": "ขนาด",
	"panel.element.origin": "จุดหมุน",
	"panel.element.rotation": "การหมุน",
	"message.canvas_limit_error.title": "ข้อผิดพลาดขีดจำกัดแคนวาส",
	"message.canvas_limit_error.message": "ไม่สามารถดำเนินการได้อย่างถูกต้องเนื่องจากรูปแบบจำกัดแคนวาสไว้ที่ 48 หน่วย ย้ายจุดหมุนเพื่อป้องกันปัญหานี้",
	"data.effect": "เอฟเฟกต์",
	"generic.name": "ชื่อ",
	"settings.recent_projects": "จำนวนโมเดลล่าสุด",
	"settings.recent_projects.desc": "จำนวนสูงสุดของโมเดลล่าสุดที่จะจำ",
	"settings.volume": "ระดับเสียง",
	"settings.volume.desc": "ควบคุมระดับเสียงสำหรับเอฟเฟกต์เสียงในแอนิเมชัน",
	"action.clear_timeline": "ล้างไทม์ไลน์",
	"action.clear_timeline.desc": "ล้างกระดูกที่ไม่ได้เลือกทั้งหมดออกจากไทม์ไลน์",
	"action.select_effect_animator": "ทำแอนิเมชันเอฟเฟกต์",
	"action.select_effect_animator.desc": "เปิดไทม์ไลน์เพื่อเพิ่มเอฟเฟกต์เสียงและอนุภาค",
	"action.timeline_focus": "กรองช่อง",
	"action.timeline_focus.desc": "เลือกช่องแอนิเมชันที่จะแสดงในไทม์ไลน์",
	"timeline.particle": "อนุภาค",
	"timeline.sound": "เสียง",
	"timeline.effects": "เอฟเฟกต์",
	"data.format": "รูปแบบ",
	"format.optifine_part": "OptiFine Part",
	"format.optifine_part.desc": "ส่วน JPM สำหรับโมเดลเอนทิตี OptiFine",
	"action.reverse_keyframes": "กลับคีย์เฟรม",
	"action.reverse_keyframes.desc": "กลับลำดับคีย์เฟรมที่เลือก",
	"generic.help": "ช่วยเหลือ",
	"message.removed_faces": "ลบ %0 หน้าแล้ว",
	"dialog.sketchfab_uploader.draft": "ร่าง",
	"action.slider_pos": "ตำแหน่ง %0",
	"action.slider_pos.desc": "ย้ายองค์ประกอบตามแกน %0",
	"action.slider_size": "ขนาด %0",
	"action.slider_size.desc": "ปรับขนาดองค์ประกอบตามแกน %0",
	"action.slider_rotation": "การหมุน %0",
	"action.slider_rotation.desc": "หมุนองค์ประกอบตามแกน %0",
	"action.slider_origin": "จุดหมุน %0",
	"action.slider_origin.desc": "ย้ายจุดหมุนตามแกน %0",
	"action.rotate_cw": "หมุน %0 +90",
	"action.rotate_cw.desc": "หมุนองค์ประกอบที่เลือก 90° บนแกน %0",
	"action.rotate_ccw": "หมุน %0 -90",
	"action.rotate_ccw.desc": "หมุนองค์ประกอบที่เลือก -90° บนแกน %0",
	"action.flip": "พลิก",
	"action.flip.desc": "พลิกองค์ประกอบที่เลือก",
	"action.center": "จัดกึ่งกลาง",
	"action.center.desc": "จัดองค์ประกอบที่เลือกให้อยู่กึ่งกลาง",
	"action.bring_up_all_animations": "นำแอนิเมเตอร์ทั้งหมดขึ้น",
	"panel.bone": "กระดูก",
	"data.color": "สี",
	"generic.export": "ส่งออก",
	"generic.none": "ไม่มี",
	"status_bar.recording": "กำลังบันทึกไทม์แลปส์",
	"message.add_to_palette": "เพิ่มในพาเล็ตแล้ว",
	"message.size_modifiers": "กดปุ่ม Ctrl หรือ Shift ค้างไว้เพื่อปรับเปลี่ยนในระดับที่ละเอียดขึ้น",
	"message.timelapse_start": "เริ่มไทม์แลปส์แล้ว",
	"message.timelapse_stop": "หยุดไทม์แลปส์แล้ว",
	"message.import_palette.replace_palette": "แทนที่พาเล็ตเดิม",
	"message.import_palette.threshold": "ขีดจำกัดการผสาน",
	"dialog.timelapse.interval": "ช่วงเวลา (วินาที)",
	"dialog.timelapse.source": "แหล่งที่มา",
	"dialog.timelapse.source.interface": "อินเทอร์เฟซ",
	"dialog.timelapse.source.locked": "มุมล็อก",
	"dialog.timelapse.destination": "โฟลเดอร์ปลายทาง",
	"layout.color.checkerboard": "ตารางหมากรุก",
	"layout.color.checkerboard.desc": "พื้นหลังของแคนวาสและตัวแก้ไข UV",
	"layout.font.code": "ฟอนต์โค้ด",
	"layout.css": "CSS กำหนดเอง",
	"settings.category.paint": "วาดรูป",
	"settings.deactivate_size_limit": "ปิดใช้ขีดจำกัดขนาด",
	"settings.deactivate_size_limit.desc": "ปิดใช้ขีดจำกัดขนาดสำหรับรูปแบบโมเดลเฉพาะ คำเตือน: อาจทำให้โมเดลไม่ถูกต้อง",
	"settings.brush_opacity_modifier": "ตัวปรับความทึบแปรง",
	"settings.brush_opacity_modifier.desc": "ปรับความทึบแปรงเมื่อใช้สไตลัส",
	"settings.brush_size_modifier": "ตัวปรับขนาดแปรง",
	"settings.brush_size_modifier.desc": "ปรับขนาดแปรงเมื่อใช้สไตลัส",
	"settings.brush_modifier.pressure": "แรงกด",
	"settings.brush_modifier.tilt": "การเอียง",
	"category.color": "สี",
	"action.import_theme": "นำเข้าธีม",
	"action.export_theme": "ส่งออกธีม",
	"action.export_theme.desc": "สร้างไฟล์ธีมจากการตั้งค่าปัจจุบัน",
	"action.slider_color_h": "เฉดสี",
	"action.slider_color_s": "ความอิ่มตัว",
	"action.slider_color_v": "ค่าสี",
	"action.add_to_palette": "เพิ่มในพาเล็ต",
	"action.add_to_palette.desc": "เพิ่มสีที่เลือกในพาเล็ตสี",
	"action.import_palette": "นำเข้าพาเล็ต",
	"action.import_palette.desc": "นำเข้าไฟล์พาเล็ต",
	"action.export_palette": "ส่งออกพาเล็ต",
	"action.export_palette.desc": "ส่งออกพาเล็ตเป็นไฟล์ .GPL",
	"action.generate_palette": "สร้างพาเล็ต...",
	"action.generate_palette.desc": "สร้างพาเล็ตจากเทกซ์เจอร์",
	"action.sort_palette": "เรียงพาเล็ต",
	"action.sort_palette.desc": "เรียงสีทั้งหมดในพาเล็ตตามสีและความสว่าง",
	"action.timelapse": "ทิมแลปส์...",
	"action.timelapse.desc": "บันทึกทิมแลปส์ของการสร้างโมเดลของคุณ",
	"action.add_keyframe": "เพิ่มคีย์เฟรม",
	"action.add_keyframe.desc": "เพิ่มคีย์เฟรมใหม่",
	"action.bring_up_all_animations.desc": "นำแอนิเมเตอร์ที่แก้ไขทั้งหมดขึ้นในไทม์ไลน์",
	"timeline.timeline": "คำสั่ง",
	"menu.palette.load.default": "ค่าเริ่มต้น",
	"generic.import": "นำเข้า",
	"settings.brush_modifier.none": "ไม่มี",
	"action.export_entity": "ส่งออกเอนทิตี Bedrock",
	"action.export_entity.desc": "ส่งออกโมเดลเป็นโมเดลเอนทิตีสำหรับ Minecraft Bedrock Edition",
	"settings.highlight_cubes": "ไฮไลต์องค์ประกอบ",
	"settings.highlight_cubes.desc": "ไฮไลต์องค์ประกอบเมื่อคุณเลื่อนเมาส์ไปหรือเลือก",
	"action.add_marker": "ตั้งเครื่องหมาย",
	"action.add_marker.desc": "ตั้งเครื่องหมายบนไทม์ไลน์",
	"timeline.pre_effect_script": "สคริปต์",
	"format.skin": "สกิน",
	"format.skin.desc": "แก้ไขสกินผู้เล่นและเอนทิตี",
	"message.sketchfab.setup_guide": "ต้องการเรียนรู้วิธีตั้งค่าโมเดลใน Sketchfab หรือไม่? อ่าน %0",
	"dialog.skin.title": "สร้างสกิน Minecraft",
	"dialog.skin.model": "โมเดล",
	"action.toggle_skin_layer": "สลับเลเยอร์สกิน",
	"action.toggle_skin_layer.desc": "สลับเลเยอร์หมวกและเสื้อผ้าของโมเดลสกิน",
	"action.gui_light": "แสง GUI",
	"action.gui_light.desc": "เลือกวิธีการส่องสว่างของไอเทมในช่องเก็บของ",
	"action.gui_light.side": "แสงด้านข้าง",
	"action.gui_light.front": "แสงด้านหน้า",
	"action.move_keyframe_back": "ย้ายคีย์เฟรมกลับ",
	"action.move_keyframe_forth": "ย้ายคีย์เฟรมไปข้างหน้า",
	"menu.help": "ช่วยเหลือ",
	"menu.help.discord": "Discord",
	"menu.help.report_issue": "รายงานปัญหา",
	"menu.help.plugin_documentation": "เอกสารประกอบปลั๊กอิน API",
	"menu.help.search_action": "ค้นหาและเรียกใช้แอคชัน",
	"menu.help.donate": "บริจาค",
	"menu.help.about": "เกี่ยวกับ",
	"menu.preview.background.clipboard": "โหลดจากคลิปบอร์ด",
	"dialog.ignore": "เพิกเฉย",
	"generic.unset": "ยกเลิกการตั้งค่า",
	"message.invalid_builtin_parent.title": "พาเรนต์ในตัวไม่ถูกต้อง",
	"message.invalid_builtin_parent.message": "ลิงก์ไปยังโมเดลพาเรนต์ที่ไม่ถูกต้อง '%0' ถูกลบเพื่อส่งออกโมเดลที่ถูกต้อง",
	"dialog.resize_texture.fill": "เติมสี",
	"dialog.resize_texture.fill.transparent": "โปร่งใส",
	"dialog.resize_texture.fill.color": "สี",
	"dialog.resize_texture.fill.repeat": "ทำซ้ำ",
	"dialog.scale.element_pivot": "จุดหมุนองค์ประกอบ",
	"dialog.scale.selection_center": "ศูนย์กลางที่เลือก",
	"dialog.create_gif.length_mode": "โหมดความยาว",
	"dialog.create_gif.length_mode.seconds": "วินาที",
	"dialog.create_gif.length_mode.frames": "เฟรม",
	"dialog.create_gif.length_mode.animation": "ความยาวแอนิเมชัน",
	"dialog.create_gif.length_mode.turntable": "การหมุนเทิร์นเทเบิล",
	"dialog.save_angle.projection": "การฉายภาพ",
	"dialog.save_angle.projection.perspective": "เพอร์สเปกทิฟ",
	"dialog.save_angle.projection.orthographic": "ออร์โธกราฟิก",
	"dialog.sketchfab_uploader.animations": "แอนิเมชัน",
	"dialog.settings.theme": "ธีม",
	"settings.category.interface": "ส่วนติดต่อ",
	"settings.preview_checkerboard": "ตารางหมากรุกตัวอย่าง",
	"settings.preview_checkerboard.desc": "เปิด/ปิดพื้นหลังตารางหมากรุกหลังตัวอย่าง",
	"settings.uv_checkerboard": "ตารางหมากรุกตัวแก้ไข UV",
	"settings.uv_checkerboard.desc": "เปิด/ปิดพื้นหลังตารางหมากรุกหลังตัวแก้ไข UV",
	"category.paint": "วาดรูป",
	"action.fill_mode.color_connected": "สีที่เชื่อมต่อ",
	"action.draw_shape_type": "ประเภทรูปทรง",
	"action.draw_shape_type.rectangle": "สี่เหลี่ยมผืนผ้า",
	"action.draw_shape_type.rectangle_h": "สี่เหลี่ยมผืนผ้า (กลวง)",
	"action.draw_shape_type.ellipse": "วงรี",
	"action.draw_shape_type.ellipse_h": "วงรี (กลวง)",
	"action.draw_shape_type.line": "เส้น",
	"action.mirror_painting": "วาดสะท้อน",
	"action.mirror_painting.description": "สะท้อนการวาดของคุณไปยังอีกด้านของโมเดล",
	"action.lock_alpha": "ล็อกช่องอัลฟา",
	"action.lock_alpha.description": "ล็อกความโปร่งใสของพิกเซลทั้งหมด",
	"action.draw_shape_tool": "วาดรูปทรง",
	"action.draw_shape_tool.desc": "เครื่องมือวาดรูปทรงง่ายๆ บนเทกซ์เจอร์",
	"action.export_gltf": "ส่งออกโมเดล glTF",
	"action.export_gltf.desc": "ส่งออกโมเดลและแอนิเมชันเป็นไฟล์ glTF สำหรับแชร์และเรนเดอร์",
	"action.transform_space": "พื้นที่เปลี่ยน",
	"action.transform_space.desc": "พื้นที่เปลี่ยนเริ่มต้นสำหรับองค์ประกอบและกระดูก",
	"action.transform_space.global": "ทั่วโลก",
	"action.transform_space.local": "ท้องถิ่น",
	"action.toggle_camera_projection": "สลับการฉายภาพกล้อง",
	"action.toggle_camera_projection.desc": "สลับการฉายภาพกล้องระหว่างเพอร์สเปกทิฟและออร์โธกราฟิก",
	"action.load_camera_angle": "มุมกล้อง: %0",
	"action.load_camera_angle.desc": "โหลดมุมกล้อง '%0'",
	"action.slider_face_tint": "ดัชนีทินต์",
	"action.slider_face_tint.desc": "ตั้งดัชนีทินต์ของหน้าปัจจุบัน -1 หมายถึงยกเลิกการตั้งค่า",
	"menu.help.quickstart": "ตัวช่วยเริ่มต้นด่วน",
	"menu.help.developer": "นักพัฒนา",
	"menu.help.developer.dev_tools": "เปิดเครื่องมือนักพัฒนา",
	"menu.help.developer.reset_storage": "รีเซ็ตจากโรงงาน",
	"menu.help.developer.reset_storage.confirm": "คุณแน่ใจหรือไม่ว่าต้องการรีเซ็ต Blockbench เป็นค่าจากโรงงาน? การดำเนินการนี้จะลบการตั้งค่า แป้นพิมพ์ลัด และปลั๊กอินที่ติดตั้งทั้งหมด",
	"menu.help.developer.cache_reload": "โหลดแคชใหม่",
	"menu.preview.orthographic": "ออร์โธกราฟิก",
	"menu.preview.save_angle": "บันทึกมุม...",
	"menu.preview.angle": "มุม",
	"menu.preview.angle.initial": "มุมเริ่มต้น",
	"menu.preview.maximize": "ขยายใหญ่สุด",
	"uv_editor.copy_selection": "คัดลอกที่เลือก",
	"uv_editor.paste_selection": "วางที่เลือก",
	"uv_editor.copy_paste_tool.place": "วาง",
	"uv_editor.copy_paste_tool.mirror_x": "สะท้อน X",
	"uv_editor.copy_paste_tool.mirror_y": "สะท้อน Y",
	"uv_editor.copy_paste_tool.rotate": "หมุน 90 องศา",
	"dialog.project.modded_entity_version": "เวอร์ชัน Modded Entity",
	"dialog.save_angle.position": "ตำแหน่งกล้อง",
	"dialog.save_angle.target": "จุดโฟกัส",
	"dialog.skin.pose": "ท่าทาง",
	"layout.color.frame": "กรอบหน้าต่าง",
	"layout.color.frame.desc": "ขอบและแถบชื่อของหน้าต่าง",
	"settings.large_grid_size": "ขนาดกริดบล็อก",
	"settings.large_grid_size.desc": "ขนาดของกริดบล็อก",
	"action.load_plugin_from_url": "โหลดปลั๊กอินจาก URL",
	"action.load_plugin_from_url.desc": "โหลดปลั๊กอินจากเซิร์ฟเวอร์โดยระบุ URL",
	"action.cube_counter.desc": "แสดงจำนวนองค์ประกอบปัจจุบันและสถิติอื่นๆ",
	"action.unlock_everything": "ปลดล็อกทั้งหมด",
	"action.unlock_everything.desc": "ปลดล็อกกลุ่มและองค์ประกอบทั้งหมดในเอาต์ไลเนอร์",
	"action.load_palette": "โหลดพาเล็ต",
	"action.load_palette.desc": "โหลดพรีเซ็ตพาเล็ตในตัวหรือที่บันทึกไว้",
	"action.toggle_locked": "สลับการล็อก",
	"action.toggle_locked.desc": "สลับว่าองค์ประกอบที่เลือกถูกล็อกหรือไม่",
	"action.apply_display_preset": "ใช้พรีเซ็ต",
	"action.apply_display_preset.desc": "ใช้พรีเซ็ตการตั้งค่าการแสดงผลเริ่มต้นหรือกำหนดเอง",
	"action.apply_display_preset.here": "ใช้กับช่องนี้",
	"action.apply_display_preset.everywhere": "ใช้กับทุกช่อง",
	"action.resolve_keyframe_expressions": "แก้ไขคีย์เฟรม",
	"action.resolve_keyframe_expressions.desc": "แก้ไขนิพจน์คณิตศาสตร์ของคีย์เฟรมที่เลือก",
	"action.fold_all_animations": "พับแอนิเมเตอร์ทั้งหมด",
	"menu.palette.load.empty": "ว่างเปล่า",
	"switches.lock": "ล็อก",
	"settings.render_sides": "ด้านที่แสดง",
	"settings.render_sides.desc": "เลือกด้านที่จะแสดง",
	"settings.render_sides.auto": "อัตโนมัติ",
	"settings.render_sides.front": "ด้านหน้า",
	"settings.render_sides.double": "ด้านในและด้านนอก",
	"generic.enable": "เปิดใช้งาน",
	"generic.disable": "ปิดใช้งาน",
	"generic.redacted": "ถูกปกปิด",
	"dialog.select_texture.import_all": "นำเข้าทั้งหมด",
	"dialog.skin.layer_template": "เทกซ์เจอร์เลเยอร์",
	"about.version.up_to_date": "เป็นเวอร์ชันล่าสุด",
	"about.version.update_available": "เวอร์ชัน %0 พร้อมใช้งาน",
	"settings.category.application": "แอปพลิเคชัน",
	"settings.streamer_mode": "โหมดสตรีมเมอร์",
	"settings.streamer_mode.desc": "ซ่อนข้อมูลที่ละเอียดอ่อน เช่น โมเดลล่าสุด",
	"settings.automatic_updates": "อัปเดตอัตโนมัติ",
	"settings.automatic_updates.desc": "ดาวน์โหลดเวอร์ชันใหม่โดยอัตโนมัติและรักษา Blockbench ให้ทันสมัย",
	"action.rotation_space": "พื้นที่การหมุน",
	"action.focus_on_selection": "จัดกึ่งกลางที่เลือก",
	"action.focus_on_selection.desc": "จัดกล้องให้โฟกัสที่องค์ประกอบที่เลือก",
	"action.jump_to_timeline_start": "กระโดดไปจุดเริ่มแอนิเมชัน",
	"action.jump_to_timeline_end": "กระโดดไปจุดสิ้นสุดแอนิเมชัน",
	"menu.help.updating": "กำลังอัปเดต (%0%)",
	"menu.help.update_failed": "อัปเดตล้มเหลว",
	"menu.animation.loop.once": "เล่นครั้งเดียว",
	"menu.animation.loop.hold": "หยุดที่เฟรมสุดท้าย",
	"menu.animation.loop.loop": "วนซ้ำ",
	"interface.streamer_mode_on": "เปิดโหมดสตรีมเมอร์แล้ว",
	"generic.reset": "รีเซ็ต",
	"generic.restore": "กู้คืน",
	"keys.mousewheel": "ล้อเลื่อนเมาส์",
	"message.delete_animation.title": "ลบแอนิเมชัน",
	"message.delete_animation.message": "แอนิเมชันถูกลบออกจาก Blockbench แล้ว คุณต้องการลบแอนิเมชันจากไฟล์ที่บันทึกไว้ด้วยหรือไม่?",
	"message.no_animation_to_import": "ไม่มีแอนิเมชันที่จะนำเข้า",
	"dialog.material_instances.title": "วัสดุ",
	"dialog.animation_import.title": "เลือกแอนิเมชันที่จะนำเข้า",
	"dialog.create_texture.padding": "ระยะห่าง",
	"settings.fov": "FOV",
	"settings.fov.desc": "ฟิลด์ออฟวิวของกล้อง ค่าเริ่มต้นคือ 45",
	"settings.minify_bbmodel": "ไฟล์โปรเจกต์แบบย่อ",
	"settings.minify_bbmodel.desc": "เขียนไฟล์ .bbmodel แบบย่อในหนึ่งบรรทัด",
	"action.edit_material_instances": "แก้ไขอินสแตนซ์วัสดุ",
	"action.edit_material_instances.desc": "แก้ไขชื่ออินสแตนซ์วัสดุสำหรับเรขาคณิตบล็อก Bedrock",
	"action.save_all_animations": "บันทึกแอนิเมชันทั้งหมด",
	"action.save_all_animations.desc": "บันทึกแอนิเมชันที่โหลดอยู่ทั้งหมด",
	"action.keyframe_interpolation": "การประมาณคีย์เฟรม",
	"action.keyframe_interpolation.desc": "เปลี่ยนวิธีการประมาณค่าระหว่างคีย์เฟรม",
	"action.keyframe_interpolation.linear": "เชิงเส้น",
	"action.keyframe_interpolation.catmullrom": "CatmullRom",
	"action.timeline_focus.hide_empty": "ซ่อนช่องว่าง",
	"menu.file.preferences": "การตั้งค่า",
	"menu.animation.blend_weight": "น้ำหนักผสม",
	"menu.animation.save": "บันทึก",
	"menu.animation.properties": "คุณสมบัติ...",
	"menu.animation.file": "ไฟล์",
	"menu.animation.snapping": "จับยึด",
	"menu.animation.open_location": "แสดงใน File Explorer",
	"panel.keyframe.add_data_point": "เพิ่มจุดข้อมูลคีย์เฟรม",
	"panel.keyframe.remove_data_point": "ลบจุดข้อมูล",
	"panel.keyframe.pre": "ก่อน",
	"panel.keyframe.post": "หลัง",
	"generic.all": "ทั้งหมด",
	"message.small_face_dimensions.title": "ขนาดหน้าเข้ากันไม่ได้",
	"message.small_face_dimensions.message": "ส่วนที่เลือกมีหน้าที่เล็กกว่า 1 หน่วยในทิศทางหนึ่ง ระบบ Box UV ถือว่าหน้าใดๆ ที่ต่ำกว่าขีดจำกัดนั้นมีความกว้าง 0 พิกเซล เทกซ์เจอร์บนหน้าเหล่านั้นอาจไม่ทำงานอย่างถูกต้อง",
	"message.small_face_dimensions.face_uv": "รูปแบบปัจจุบันรองรับแผนที่ UV ต่อหน้าซึ่งจัดการขนาดหน้าเล็กได้ คลิกขวาที่คิวบ์ที่ได้รับผลกระทบและเปลี่ยน 'โหมด UV' เป็น 'UV ต่อหน้า'",
	"dialog.plugins.outdated_client": "ต้องใช้ Blockbench เวอร์ชันใหม่กว่า",
	"dialog.plugins.outdated_plugin": "ปลั๊กอินล้าสมัยและไม่ทำงานกับ Blockbench เวอร์ชันนี้",
	"settings.motion_trails": "ร่องรอยการเคลื่อนไหว",
	"settings.motion_trails.desc": "แสดงร่องรอยการเคลื่อนไหวในตัวแก้ไขแอนิเมชัน",
	"settings.antialiasing": "แอนติอาเลียสซิง",
	"settings.antialiasing.desc": "เปิด/ปิดแอนติอาเลียสซิงในตัวอย่าง",
	"action.timeline_frame_back": "กระโดดกลับ 1 เฟรม",
	"action.timeline_frame_forth": "กระโดดไปข้างหน้า 1 เฟรม",
	"panel.bone.ik": "อินเวิร์สคิเนมาติกส์ (ทดลอง)",
	"settings.particle_tick_rate": "อัตราทิคอนุภาค",
	"settings.particle_tick_rate.desc": "อัตราทิคสำหรับเอฟเฟกต์อนุภาคเป็นทิคต่อวินาที ค่าเริ่มต้นคือ 30",
	"action.lock_motion_trail": "ล็อกร่องรอยการเคลื่อนไหว",
	"action.lock_motion_trail.desc": "ล็อกร่องรอยการเคลื่อนไหวกับกลุ่มที่เลือก",
	"menu.animation_file.unload": "ยกเลิกโหลดไฟล์",
	"data.null_object": "ออบเจกต์เปล่า",
	"status_bar.toggle_sidebar": "สลับแถบข้าง",
	"message.load_plugin_failed.title": "โหลดปลั๊กอินล้มเหลว",
	"message.load_plugin_failed.message": "ตรวจสอบให้แน่ใจว่าชื่อไฟล์พื้นฐานของปลั๊กอินตรงกับ ID ปลั๊กอิน `%0` ตามที่ระบุใน Plugin.register()",
	"dialog.project.uv_mode": "โหมด UV",
	"dialog.project.uv_mode.box_uv": "Box UV",
	"dialog.project.uv_mode.face_uv": "UV ต่อหน้า",
	"dialog.project.texture_size": "ขนาดเทกซ์เจอร์",
	"dialog.animation_export.title": "ส่งออกแอนิเมชัน",
	"dialog.create_texture.rearrange_uv": "จัดเรียง UV ใหม่",
	"layout.color.subtle_text": "ข้อความจาง",
	"layout.color.subtle_text.desc": "สีข้อความรองที่มีคอนทราสต์น้อยกว่า",
	"settings.interface_scale": "มาตราส่วนส่วนติดต่อ",
	"settings.interface_scale.desc": "ปรับขนาดส่วนติดต่อของโปรแกรม",
	"settings.background_rendering": "เรนเดอร์พื้นหลัง",
	"settings.background_rendering.desc": "อัปเดตตัวอย่างขณะที่หน้าต่างไม่ได้โฟกัส",
	"settings.ctrl_shift_size": "ความละเอียด Control + Shift",
	"settings.ctrl_shift_size.desc": "ความละเอียดของกริดขณะกด Control และ Shift",
	"settings.hardware_acceleration": "การเร่งด้วยฮาร์ดแวร์",
	"settings.hardware_acceleration.desc": "มอบหมายงานเรนเดอร์ให้การ์ดจอ",
	"action.explode_skin_model": "ระเบิดโมเดลสกิน",
	"action.explode_skin_model.desc": "สลับมุมมองแบบระเบิดที่อนุญาตให้แก้ไขหน้าที่ถูกปิด",
	"action.export_minecraft_skin": "ส่งออกสกิน Minecraft",
	"action.export_minecraft_skin.desc": "ส่งออกสกิน Minecraft เป็นเทกซ์เจอร์ PNG",
	"action.add_null_object": "เพิ่มออบเจกต์เปล่า",
	"action.add_null_object.desc": "เพิ่มออบเจกต์เปล่าใหม่",
	"action.animated_texture_frame": "เฟรมเทกซ์เจอร์แบบเคลื่อนไหว",
	"action.animated_texture_frame.desc": "ตั้งเฟรมปัจจุบันของเทกซ์เจอร์แบบเคลื่อนไหว",
	"action.export_animation_file": "ส่งออกแอนิเมชัน...",
	"action.export_animation_file.desc": "ส่งออกแอนิเมชันที่เลือกเป็นไฟล์ใหม่",
	"action.timeline_graph_editor": "สลับตัวแก้ไขกราฟ",
	"action.timeline_graph_editor.desc": "สลับไทม์ไลน์ระหว่างมุมมองตัวแก้ไขกราฟและมุมมองคีย์เฟรม",
	"menu.file.recent.clear": "ล้างไฟล์ล่าสุด",
	"switches.shade": "แรเงา",
	"generic.share": "แชร์",
	"dates.minute": "%0 นาที",
	"dates.minutes": "%0 นาที",
	"dates.hour": "%0 ชั่วโมง",
	"dates.hours": "%0 ชั่วโมง",
	"dates.day": "%0 วัน",
	"dates.days": "%0 วัน",
	"dates.week": "%0 สัปดาห์",
	"dates.weeks": "%0 สัปดาห์",
	"dates.year": "%0 ปี",
	"dates.years": "%0 ปี",
	"message.installed_plugin": "ติดตั้งปลั๊กอิน %0 สำเร็จ",
	"message.installed_plugin_fail": "ติดตั้งปลั๊กอิน %0 ล้มเหลว",
	"dialog.share_model.title": "แชร์โมเดล",
	"dialog.share_model.expire_time": "เวลาหมดอายุ",
	"dialog.share_model.failed": "อัปโหลดโมเดลล้มเหลว",
	"action.import_java_block_model": "เพิ่มโมเดลบล็อก/ไอเทม Java",
	"action.import_java_block_model.desc": "เพิ่มโมเดลบล็อก/ไอเทม Minecraft Java จากไฟล์ json ในโมเดลปัจจุบัน",
	"action.share_model": "แชร์...",
	"action.share_model.desc": "สร้างลิงก์สั้นเพื่อแชร์โมเดลของคุณ",
	"action.import_project": "นำเข้าโปรเจกต์",
	"action.import_project.desc": "นำเข้าโปรเจกต์อื่นจากไฟล์ .bbmodel ในโปรเจกต์ปัจจุบัน",
	"dialog.toolbar_edit.hidden_tools": "เครื่องมือบางอย่างอาจถูกซ่อนเนื่องจากไม่พร้อมใช้งานในโหมด รูปแบบ หรือสถานการณ์ปัจจุบัน",
	"settings.camera_near_plane": "ระนาบใกล้ของกล้อง",
	"settings.camera_near_plane.desc": "ระยะขั้นต่ำจากกล้องที่วัตถุถูกเรนเดอร์ ค่าที่สูงขึ้นลด Z-fighting ค่าเริ่มต้นคือ 1",
	"mode.start.keymap_preference.desc": "หากคุณเป็นผู้ใช้ใหม่ของ Blockbench และมาจากโปรแกรม 3D อื่น คุณสามารถเลือกแป้นพิมพ์ลัดเพื่อให้การใช้งานง่ายขึ้น คุณสามารถเปลี่ยนแป้นพิมพ์ลัดหรือการผูกคีย์แต่ละอันได้ภายหลังในการตั้งค่า",
	"message.load_keymap": "คุณแน่ใจหรือไม่ว่าต้องการโหลดแป้นพิมพ์ลัดนี้? การดำเนินการนี้จะเขียนทับแป้นพิมพ์ลัดปัจจุบันของคุณ",
	"message.keymap_loaded": "โหลดแป้นพิมพ์ลัดแล้ว",
	"dialog.convert_project.current_format": "รูปแบบปัจจุบัน",
	"dialog.create_texture.rearrange_uv.desc": "สร้างการจัดเรียง UV ใหม่เพื่อให้แต่ละหน้ามีพื้นที่ของตัวเองบนเทกซ์เจอร์",
	"dialog.create_texture.power.desc": "ล็อกขนาดเทกซ์เจอร์อัตโนมัติเป็นกำลัง 2 เช่น 64 หรือ 128 จำเป็นสำหรับเรนเดอร์เรอร์บางตัว",
	"dialog.create_texture.double_use.desc": "หากองค์ประกอบสองอันมีพื้นที่ UV เดียวกันอยู่แล้ว คงไว้ในแผนที่ใหม่",
	"dialog.create_texture.padding.desc": "เว้นระยะห่างระหว่างหน้าของคิวบ์ในเทมเพลต",
	"dialog.create_texture.resolution.desc": "ขนาดของเทกซ์เจอร์ในพิกเซล",
	"dialog.create_gif.color": "สีพื้นหลัง",
	"dialog.save_angle.zoom": "ซูม",
	"dialog.skin.variant": "ตัวแปร",
	"dialog.flip_animation.info": "กระดูกด้านตรงข้ามถูกระบุด้วยคำว่า 'left' และ 'right' ในชื่อ",
	"dialog.export_private_settings.title": "การตั้งค่าส่วนตัว",
	"dialog.export_private_settings.message": "ไฟล์ของคุณมีข้อมูลส่วนตัวต่อไปนี้: **%0** ไม่รวมค่าเหล่านี้หากคุณวางแผนจะแชร์ไฟล์กับผู้อื่น",
	"dialog.export_private_settings.keep": "คงไว้",
	"settings.timecode_frame_number": "แสดงรหัสเวลาเป็นหมายเลขเฟรม",
	"settings.timecode_frame_number.desc": "แสดงรหัสเวลาเศษส่วนในไทม์ไลน์เป็นหมายเลขเฟรมแทนเซนติวินาที",
	"settings.animation_sample_rate": "อัตราตัวอย่างแอนิเมชัน",
	"settings.animation_sample_rate.desc": "อัตราตัวอย่างเป็นตัวอย่างต่อวินาทีสำหรับเส้นโค้งที่รูปแบบนั้นไม่รองรับโดยธรรมชาติ",
	"keybind.preview_zoom": "ลากเพื่อซูม",
	"action.gradient_tool": "เครื่องมือไล่ระดับสี",
	"action.gradient_tool.desc": "วาดไล่ระดับสีบนเทกซ์เจอร์",
	"action.import_settings": "นำเข้าการตั้งค่า",
	"action.import_settings.desc": "นำเข้าไฟล์ .bbsettings",
	"action.export_settings": "ส่งออกการตั้งค่า",
	"action.export_settings.desc": "ส่งออกการตั้งค่า Blockbench เป็นไฟล์ .bbsettings",
	"action.load_keymap": "โหลดแป้นพิมพ์ลัด",
	"action.load_keymap.default": "ค่าเริ่มต้น (แทร็คแพด/เมาส์)",
	"action.load_keymap.mouse": "ค่าเริ่มต้น (เมาส์)",
	"action.load_keymap.default.desc": "แป้นพิมพ์ลัดเริ่มต้นของ Blockbench โดยการนำทางวิวพอร์ตเหมาะสำหรับแทร็คแพดแล็ปท็อป",
	"action.load_keymap.mouse.desc": "แป้นพิมพ์ลัดเริ่มต้นของ Blockbench โดยการนำทางวิวพอร์ตผูกกับปุ่มเมาส์กลาง",
	"action.load_keymap.blender.desc": "แป้นพิมพ์ลัดสำหรับผู้ใช้ที่คุ้นเคยกับการควบคุมของ Blender",
	"action.load_keymap.cinema4d.desc": "แป้นพิมพ์ลัดสำหรับผู้ใช้ที่คุ้นเคยกับการควบคุมของ Cinema 4D",
	"action.load_keymap.maya.desc": "แป้นพิมพ์ลัดสำหรับผู้ใช้ที่คุ้นเคยกับการควบคุมของ Autodesk Maya",
	"action.import_keymap": "นำเข้าแป้นพิมพ์ลัด",
	"action.import_keymap.desc": "นำเข้าแป้นพิมพ์ลัดจากไฟล์ .bbkeymap",
	"action.export_keymap": "ส่งออกแป้นพิมพ์ลัด",
	"action.export_keymap.desc": "ส่งออกแป้นพิมพ์ลัดปัจจุบันเป็นไฟล์ .bbkeymap",
	"action.edit_history": "ประวัติการแก้ไข...",
	"action.edit_history.desc": "ดูประวัติการแก้ไขและเลิกทำหรือทำซ้ำขั้นตอน",
	"action.group_elements": "จัดกลุ่มองค์ประกอบ",
	"action.group_elements.desc": "ห่อองค์ประกอบที่เลือกในกลุ่มใหม่",
	"action.unfold_groups": "ขยายกลุ่ม",
	"action.unfold_groups.desc": "ขยายกลุ่มทั้งหมดในเอาต์ไลเนอร์",
	"action.edit_bedrock_binding": "แก้ไขการผูก...",
	"action.edit_bedrock_binding.desc": "เปลี่ยนกระดูกที่เรขาคณิตผูกอยู่",
	"action.pick_screen_color": "เลือกสีจากจอ",
	"action.pick_screen_color.desc": "เลือกสีจากที่ใดก็ได้บนหน้าจอของคุณ",
	"action.view_mode": "โหมดมุมมอง",
	"action.view_mode.desc": "เปลี่ยนโหมดมุมมองโมเดล",
	"action.view_mode.textured": "มีเทกซ์เจอร์",
	"action.view_mode.solid": "ทึบ",
	"action.view_mode.wireframe": "โครงลวด",
	"action.toggle_sidebars": "สลับแถบข้าง",
	"action.toggle_sidebars.desc": "เปิดหรือปิดแถบข้าง",
	"action.set_animation_end": "ตั้งจุดสิ้นสุดแอนิเมชัน",
	"action.set_animation_end.desc": "ตั้งจุดสิ้นสุดของแอนิเมชัน",
	"action.flip_animation": "พลิกแอนิเมชัน",
	"action.flip_animation.desc": "พลิกแอนิเมชันแนวนอน",
	"action.graph_editor_zero_line": "รวมเส้นศูนย์",
	"action.graph_editor_zero_line.desc": "ว่าตัวแก้ไขกราฟจะรวมเส้นศูนย์ในมุมมองเสมอหรือไม่",
	"menu.texture.render_mode": "โหมดเรนเดอร์",
	"menu.texture.render_mode.emissive": "เรืองแสง",
	"menu.texture.render_mode.layered": "แบบเลเยอร์",
	"menu.preview.angle.edit": "แก้ไขมุม...",
	"menu.animation.start_delay": "หน่วงเวลาเริ่มต้น",
	"menu.animation.loop_delay": "หน่วงเวลาวนซ้ำ",
	"menu.animation.flip_keyframes": "พลิกคีย์เฟรม",
	"menu.mobile_keyboard.disable_all": "ปิดทั้งหมด",
	"panel.keyframe.toggle_uniform_scale": "สลับมาตราส่วนสม่ำเสมอ",
	"camera_angle.common_isometric_right": "ไอโซเมตริกขวา (2:1)",
	"camera_angle.common_isometric_left": "ไอโซเมตริกซ้าย (2:1)",
	"camera_angle.true_isometric_right": "ไอโซเมตริกขวาแท้ (30°)",
	"camera_angle.true_isometric_left": "ไอโซเมตริกซ้ายแท้ (30°)",
	"menu.help.wiki": "วิกิ Blockbench",
	"settings.update_to_prereleases": "อัปเดตเป็นรุ่นทดสอบ",
	"settings.update_to_prereleases.desc": "อัปเดตเป็นเวอร์ชันเบต้าของ Blockbench โดยอัตโนมัติเพื่อทดสอบฟีเจอร์ใหม่ รุ่นทดสอบอาจไม่เสถียร อย่าเปิดใช้ตัวเลือกนี้หากคุณพึ่งพา Blockbench ในการทำงานหรือโปรเจกต์สำคัญอื่นๆ",
	"data.separator.spacer": "ตัวเว้นวรรค",
	"data.separator.linebreak": "ตัวแบ่งบรรทัด",
	"data.setting": "การตั้งค่า",
	"generic.select_all": "เลือกทั้งหมด",
	"generic.select_none": "ไม่เลือก",
	"projects.new_tab": "แท็บใหม่",
	"projects.close_tab": "ปิดแท็บ",
	"message.invalid_format.title": "รูปแบบไม่ถูกต้อง",
	"message.invalid_format.message": "โมเดลนี้สร้างในรูปแบบ '%0' ซึ่งไม่มีใน Blockbench ของคุณ คุณอาจต้องใช้ปลั๊กอินเฉพาะเพื่อเปิดได้อย่างถูกต้อง",
	"message.invalid_link": "ลิงก์โมเดลไม่ถูกต้องหรือหมดอายุ",
	"message.default_textures.current": "เส้นทางปัจจุบัน",
	"message.update_after_restart": "อัปเดตจะถูกติดตั้งหลังจากรีสตาร์ทครั้งถัดไป",
	"message.copy_paste_tool_viewport": "เครื่องมือนี้สามารถใช้ได้ในตัวแก้ไข 2D เท่านั้น",
	"dialog.project.shadow_size": "ขนาดเงา",
	"dialog.find_replace.target": "เป้าหมาย",
	"dialog.find_replace.target.element_names": "ชื่อองค์ประกอบ",
	"dialog.find_replace.target.group_names": "ชื่อกลุ่ม",
	"dialog.find_replace.target.animation_names": "ชื่อแอนิเมชัน",
	"dialog.find_replace.target.keyframe_values": "ค่าคีย์เฟรม",
	"dialog.find_replace.find": "ค้นหา",
	"dialog.find_replace.replace": "แทนที่",
	"dialog.find_replace.regex": "นิพจน์ปรกติ",
	"dialog.add_primitive.shape": "รูปทรง",
	"dialog.add_primitive.shape.circle": "วงกลม",
	"dialog.add_primitive.shape.tube": "ท่อ",
	"dialog.add_primitive.shape.cone": "ทรงกรวย",
	"dialog.add_primitive.shape.cylinder": "ทรงกระบอก",
	"dialog.add_primitive.shape.sphere": "ทรงกลม",
	"dialog.add_primitive.shape.torus": "ทอรัส",
	"dialog.add_primitive.shape.cube": "ทรงสี่เหลี่ยมมุมฉาก",
	"dialog.add_primitive.shape.pyramid": "พีระมิด",
	"dialog.add_primitive.diameter": "เส้นผ่านศูนย์กลาง",
	"dialog.add_primitive.height": "ความสูง",
	"dialog.add_primitive.sides": "ด้าน",
	"dialog.add_primitive.minor_diameter": "ความหนา",
	"dialog.add_primitive.minor_sides": "ด้านรอง",
	"dialog.create_texture.combine_polys": "รวมไอแลนด์",
	"dialog.create_texture.combine_polys.desc": "รวมหน้าเป็นไอแลนด์ UV ที่เชื่อมต่อ",
	"dialog.model_stats.meshes": "เมช",
	"dialog.export_private_settings.omit": "ไม่รวม",
	"layout.select": "เลือก",
	"layout.options": "ตัวเลือก",
	"layout.color": "ชุดสี",
	"layout.documentation": "เอกสารประกอบ",
	"layout.color.bright_ui_text": "ข้อความ UI สว่าง",
	"layout.color.bright_ui_text.desc": "ข้อความบนพื้นหลังสว่าง",
	"layout.name": "ชื่อ",
	"layout.author": "ผู้สร้าง",
	"settings.dialog.desc": "แสดงกล่องโต้ตอบ '%0'",
	"settings.export_empty_groups": "ส่งออกกลุ่มว่าง",
	"settings.export_empty_groups.desc": "รวมกลุ่มที่ไม่มีเนื้อหาในไฟล์ที่ส่งออก",
	"category.separators": "ตัวคั่น",
	"keybind.preview_area_select": "เลือกแบบพื้นที่",
	"action.color_erase_mode": "โหมดลบ",
	"action.color_erase_mode.desc": "เมื่อเปิดใช้โหมดลบ เครื่องมือเช่นเติมและสี่เหลี่ยมจะลบสีแทนที่จะเพิ่ม",
	"action.open_from_link": "เปิดโมเดลจากลิงก์...",
	"action.open_from_link.desc": "เปิดโมเดลจาก URL blckbn.ch",
	"action.import_obj": "นำเข้าโมเดล OBJ",
	"action.import_obj.desc": "นำเข้าออบเจกต์จากโมเดล OBJ เป็นเมช",
	"action.add_plugin": "ติดตั้งปลั๊กอิน",
	"action.add_plugin.desc": "ติดตั้งปลั๊กอินผ่านตัวควบคุมแอคชัน",
	"action.remove_plugin": "ถอนการติดตั้งปลั๊กอิน",
	"action.remove_plugin.desc": "ถอนการติดตั้งปลั๊กอินผ่านตัวควบคุมแอคชัน",
	"action.add_mesh": "เพิ่มเมช",
	"action.add_mesh.desc": "เพิ่มเมชใหม่",
	"action.add_texture_mesh": "เพิ่มเมชเทกซ์เจอร์",
	"action.add_texture_mesh.desc": "เพิ่มเมชเทกซ์เจอร์ใหม่",
	"action.find_replace": "ค้นหาและแทนที่",
	"action.find_replace.desc": "ค้นหาและแทนที่ชื่อในโมเดล",
	"action.hide_everything_except_selection": "ซ่อนทั้งหมดยกเว้นที่เลือก",
	"action.hide_everything_except_selection.desc": "สลับการมองเห็นองค์ประกอบทั้งหมดยกเว้นที่เลือก",
	"action.transform_space.normal": "ปกติ",
	"action.selection_mode": "โหมดการเลือก",
	"action.selection_mode.desc": "เปลี่ยนวิธีเลือกองค์ประกอบในวิวพอร์ต",
	"action.selection_mode.object": "วัตถุ",
	"action.selection_mode.face": "หน้า",
	"action.selection_mode.vertex": "จุดยอด",
	"action.create_face": "สร้างหน้าหรือขอบ",
	"action.create_face.desc": "สร้างหน้าหรือขอบใหม่ระหว่างจุดยอดที่เลือก",
	"action.convert_to_mesh": "แปลงเป็นเมช",
	"action.convert_to_mesh.desc": "แปลงองค์ประกอบที่เลือกเป็นเมช",
	"action.invert_face": "กลับด้านหน้า",
	"action.invert_face.desc": "กลับด้านหน้าที่เลือกให้หันไปทิศทางตรงข้าม",
	"action.extrude_mesh_selection": "ดึงออก",
	"action.extrude_mesh_selection.desc": "ดึงออกส่วนที่เลือกของเมช",
	"action.loop_cut": "ตัดวน",
	"action.loop_cut.desc": "สร้างการตัดวนบนเมช",
	"action.merge_meshes": "ผสานเมช",
	"action.merge_meshes.desc": "ผสานเมชหลายอันเป็นหนึ่งอัน",
	"action.keyframe_uniform": "มาตราส่วนสม่ำเสมอ",
	"action.keyframe_uniform.desc": "เปิดใช้มาตราส่วนสม่ำเสมอบนคีย์เฟรมที่เลือก",
	"menu.locator.ignore_inherited_scale": "เพิกเฉยมาตราส่วนที่สืบทอด",
	"menu.texture.elements": "ใช้กับองค์ประกอบ",
	"uv_editor.transparent_face": "หน้าโปร่งใส",
	"display.pose_angle": "มุมท่าทาง (สำหรับตัวอย่างเท่านั้น)",
	"data.mesh": "เมช",
	"dialog.create_texture.type": "ประเภท",
	"dialog.create_texture.type.blank": "เปล่า",
	"dialog.create_texture.type.template": "เทมเพลตเทกซ์เจอร์",
	"dialog.create_texture.type.color_map": "เทมเพลตสีทึบ",
	"dialog.sketchfab_uploader.suggested_tags": "แท็กแนะนำ",
	"dialog.sketchfab_uploader.category": "หมวดหมู่",
	"dialog.sketchfab_uploader.category2": "หมวดหมู่ 2",
	"layout.restore_backup": "ธีมที่คุณปรับแต่ง \"%0\" ถูกเขียนทับ คลิกที่นี่เพื่อกู้คืน",
	"layout.borders": "ขอบ",
	"action.fill_mode.element": "องค์ประกอบ",
	"action.inset_mesh_selection": "เซ็ตด้านใน",
	"action.inset_mesh_selection.desc": "เซ็ตด้านในของหน้าเมชที่เลือก",
	"action.dissolve_edges": "ละลายขอบ",
	"action.dissolve_edges.desc": "ละลายขอบที่เลือกในเมชและผสานหน้าที่แบ่ง",
	"action.split_mesh": "แยกเมช",
	"action.split_mesh.desc": "แยกเมชที่เลือกออกจากกัน",
	"action.merge_vertices": "ผสานจุดยอด",
	"action.merge_vertices.desc": "ผสานจุดยอดที่เลือก",
	"action.view_mode.normal": "การวางแนวหน้า",
	"action.snap_uv_to_pixels": "จับ UV ไปยังพิกเซล",
	"action.snap_uv_to_pixels.desc": "จับจุดยอด UV ที่เลือกไปยังกริดพิกเซล",
	"menu.file.import.import_open_project": "นำเข้าโปรเจกต์ที่เปิดอยู่",
	"menu.help.unlock_projects": "ปลดล็อกโปรเจกต์ทั้งหมด",
	"status_bar.selection.faces": "%0 หน้า",
	"status_bar.selection.vertices": "%0 จุดยอด",
	"message.merged_vertices": "พบและผสาน %0 จุดยอดใน %1 ตำแหน่ง",
	"settings.vertex_merge_distance": "ระยะการผสานจุดยอด",
	"settings.vertex_merge_distance.desc": "ระยะที่จุดยอดจะถูกผสานโดยใช้การผสานตามระยะ",
	"settings.show_only_selected_uv": "แสดงเฉพาะ UV ที่เลือก",
	"settings.show_only_selected_uv.desc": "แสดงเฉพาะหน้า UV ที่เลือกในตัวแก้ไข UV โดยค่าเริ่มต้น",
	"action.merge_vertices.merge_all": "ผสานทั้งหมด",
	"action.merge_vertices.merge_all_in_center": "ผสานทั้งหมดที่ศูนย์กลาง",
	"action.merge_vertices.merge_by_distance": "ผสานตามระยะ",
	"action.merge_vertices.merge_by_distance_in_center": "ผสานตามระยะที่ศูนย์กลาง",
	"action.uv_rotate_left": "หมุน UV ซ้าย",
	"action.uv_rotate_left.desc": "หมุนหน้า UV ที่เลือกทวนเข็มนาฬิกา",
	"action.uv_rotate_right": "หมุน UV ขวา",
	"action.uv_rotate_right.desc": "หมุนหน้า UV ที่เลือกตามเข็มนาฬิกา",
	"menu.uv.display_uv": "แสดง UV",
	"menu.uv.display_uv.selected_faces": "หน้าที่เลือก",
	"menu.uv.display_uv.selected_elements": "ทุกหน้า",
	"menu.uv.display_uv.all_elements": "ทุกหน้าบนทุกองค์ประกอบ",
	"menu.paste.face": "หน้า UV",
	"menu.paste.mesh_selection": "เลือกเมช",
	"menu.paste.outliner": "องค์ประกอบ",
	"uv_editor.show_all_faces": "แสดงทุกหน้า",
	"uv_editor.show_selected_faces": "แสดงหน้าที่เลือก",
	"status_bar.selection.edges": "%0 ขอบ",
	"action.selection_mode.edge": "ขอบ",
	"message.cannot_re_import.title": "ไม่สามารถนำเข้าโมเดลซ้ำได้",
	"message.cannot_re_import.message": "รูปแบบโมเดลที่ส่งออกไม่สามารถนำเข้ากลับเข้า Blockbench ได้อีก กรุณาบันทึกโมเดลเป็นไฟล์โปรเจกต์",
	"generic.default": "ค่าเริ่มต้น",
	"units.pixels_per_meter": "%0 พิกเซลต่อเมตร",
	"mode.pose": "ท่าทาง",
	"modifier_actions.resize_both_sides": "ปรับขนาดทั้งสองทิศทาง",
	"modifier_actions.resize_one_side": "ปรับขนาดทิศทางเดียว",
	"modifier_actions.draw_line": "วาดเส้น",
	"modifier_actions.drag_without_snapping": "ลากโดยไม่จับยึด",
	"modifier_actions.stretch_keyframes": "ยืดคีย์เฟรม",
	"modifier_actions.resize_background": "ปรับขนาดพื้นหลัง",
	"modifier_actions.select_multiple": "เลือกหลายรายการ",
	"modifier_actions.select_range": "เลือกช่วง",
	"modifier_actions.drag_to_duplicate": "ลากเพื่อทำซ้ำ",
	"modifier_actions.uniform_scaling": "ปรับขนาดสม่ำเสมอ",
	"modifier_actions.snap_direction": "ทิศทางการจับยึด",
	"message.no_valid_elements": "ไม่มีองค์ประกอบที่ถูกต้องถูกเลือก...",
	"dialog.add_primitive.shape.plane": "ระนาบ",
	"dialog.save_angle.rotation_mode": "โหมดการหมุน",
	"dialog.save_angle.rotation": "การหมุน",
	"dialog.save_angle.fov": "FOV",
	"settings.hide_tab_bar": "ซ่อนแถบแท็บ",
	"settings.hide_tab_bar.desc": "ซ่อนแถบแท็บเมื่อเปิดแท็บเดียว",
	"settings.status_bar_modifier_keys": "แนะนำปุ่มปรับแต่งในแถบสถานะ",
	"settings.status_bar_modifier_keys.desc": "แสดงปุ่มปรับแต่งที่แนะนำตามบริบทในแถบสถานะ",
	"settings.ground_plane": "ระนาบพื้น",
	"settings.ground_plane.desc": "แสดกระนาบพื้นด้านล่างโมเดล",
	"settings.preview_paste_behavior": "พฤติกรรมการวางในวิวพอร์ตเริ่มต้น",
	"settings.preview_paste_behavior.desc": "เลือกพฤติกรรมเมื่อวางบางอย่างในวิวพอร์ตในโหมดแก้ไขและมีหลายตัวเลือก",
	"settings.preview_paste_behavior.always_ask": "ถามทุกครั้ง",
	"action.new_window": "หน้าต่างใหม่",
	"action.new_window.desc": "เปิดหน้าต่าง Blockbench ใหม่",
	"action.export_collada": "ส่งออกโมเดล Collada (dae)",
	"action.export_collada.desc": "ส่งออกโมเดลและแอนิเมชันเป็นไฟล์ dae เพื่อใช้ในแอป 3D อื่น",
	"action.paint_mode_uv_overlay": "การซ้อน UV",
	"action.paint_mode_uv_overlay.desc": "แสดงแผนที่ UV เป็นการซ้อนในโหมดวาด",
	"action.bake_animation_into_model": "เบคท่าแอนิเมชันลงในโมเดล",
	"action.bake_animation_into_model.desc": "เบคเฟรมแอนิเมชันที่แสดงอยู่ลงในโมเดล ใช้เฉพาะการหมุนและตำแหน่ง มาตราส่วนจะถูกละเลย",
	"action.keyframe_interpolation.step": "ขั้นบันได",
	"action.set_ik_target": "ตั้งเป้าหมาย IK",
	"action.set_ik_target.desc": "เลือกกระดูกเป้าหมายที่ควรถูกเคลื่อนโดยออบเจกต์เปล่านี้ผ่าน Inverse Kinematics",
	"menu.action_control.type.tab": "แท็บ",
	"menu.action_control.type.angle": "มุมกล้อง",
	"menu.action_control.recent_in_streamer_mode": "แน่ใจหรือไม่? โหมดสตรีมเมอร์เปิดอยู่",
	"menu.action_control.recent_in_streamer_mode.desc": "คุณแน่ใจหรือไม่ว่าต้องการแสดงโมเดลล่าสุด?",
	"menu.tools": "เครื่องมือ",
	"menu.file.recent.more": "ดูเพิ่มเติม...",
	"menu.null_object.lock_ik_target_rotation": "ล็อกการหมุนเป้าหมาย IK",
	"menu.animation_file.import_remaining": "นำเข้าที่เหลือจากไฟล์",
	"edit.loop_cut.offset": "ออฟเซ็ต",
	"edit.extrude_mesh_selection.extend": "ขยาย",
	"cube.color.pink": "ชมพู",
	"cube.color.silver": "เงิน",
	"dialog.plugins.offline": "ไม่มีการเชื่อมต่ออินเทอร์เน็ต",
	"dialog.create_texture.pixel_density": "ความหนาแน่นพิกเซล",
	"dialog.create_texture.pixel_density.desc": "ความหนาแน่นพิกเซลของเทกซ์เจอร์ เป็นพิกเซลต่อเมตร ขนาดของแผนที่เทกซ์เจอร์อาจแตกต่างกันขึ้นอยู่กับจำนวนและขนาดขององค์ประกอบ",
	"panel.skin_pose": "ท่าทาง",
	"panel.skin_pose.none": "ไม่มี",
	"panel.skin_pose.natural": "ธรรมชาติ",
	"panel.skin_pose.walking": "เดิน",
	"panel.skin_pose.crouching": "ย่อ",
	"panel.skin_pose.sitting": "นั่ง",
	"panel.skin_pose.jumping": "กระโดด",
	"panel.skin_pose.aiming": "เล็ง",
	"edit.loop_cut.direction": "ทิศทาง",
	"data.texture_mesh": "เมชเทกซ์เจอร์",
	"generic.left": "ซ้าย",
	"generic.right": "ขวา",
	"mode.start.quick_setup": "ตั้งค่าด่วน",
	"mode.start.keymap": "แป้นพิมพ์ลัด",
	"mode.start.quick_setup.more_themes": "เพิ่มเติม...",
	"dialog.resize_texture.animation_frames": "เฟรมแอนิเมชัน",
	"dialog.export_emission_map.title": "ส่งออกแผนที่เรืองแสง",
	"dialog.export_emission_map.format": "รูปแบบ",
	"dialog.export_emission_map.format.luminance": "ความสว่าง",
	"dialog.export_emission_map.format.luminance_inverted": "ความสว่างกลับด้าน",
	"dialog.export_emission_map.format.colors": "สี",
	"dialog.export_emission_map.threshold": "ขีดจำกัดความโปร่งใส",
	"dialog.export_emission_map.round_up": "ปัดขึ้นเป็น %0 x %1",
	"dialog.export_emission_map.flip_y": "พลิกแกน Y",
	"dialog.select.type": "ประเภทองค์ประกอบ",
	"dialog.create_texture.max_edge_angle": "ขีดจำกัดมุมขอบ",
	"dialog.create_texture.max_edge_angle.desc": "มุมสูงสุดระหว่างสองหน้าที่ยังคงถูกรวมกัน",
	"dialog.create_texture.max_island_angle": "ขีดจำกัดมุมไอแลนด์",
	"dialog.create_texture.max_island_angle.desc": "มุมสูงสุดที่สามารถรวมเข้าในไอแลนด์ UV เดียวกัน",
	"settings.mobile_panel_side": "ด้านแผงมือถือ",
	"settings.mobile_panel_side.desc": "เลือกด้านของหน้าจอที่จะแสดงแผงเมื่อใช้ Blockbench ในแนวนอน",
	"settings.obj_face_export_mode": "โหมดส่งออกหน้า OBJ",
	"settings.obj_face_export_mode.desc": "เลือกให้ตัวส่งออก OBJ แปลงหน้าทั้งหมดเป็นสามเหลี่ยมหรือสี่เหลี่ยม",
	"settings.obj_face_export_mode.both": "ค่าเริ่มต้น",
	"settings.obj_face_export_mode.tris": "แปลงเป็นสามเหลี่ยม",
	"settings.obj_face_export_mode.quads": "แปลงเป็นสี่เหลี่ยม",
	"action.seam_tool": "เครื่องมือ Seam",
	"action.seam_tool.desc": "เครื่องมือกำหนด Seam UV บนขอบเมช",
	"action.resolve_group": "ยุบกลุ่ม",
	"action.resolve_group.desc": "ยุบกลุ่มโดยยังคงรักษาลูกไว้ในตำแหน่งเดิม",
	"action.move_to_group": "ย้ายไปยัง",
	"action.move_to_group.desc": "ย้ายองค์ประกอบที่เลือกไปยังกลุ่มหรือองค์ประกอบอื่นในเอาต์ไลเนอร์",
	"action.select_seam": "เลือก Seam UV",
	"action.select_seam.desc": "เลือกโหมด Seam UV สำหรับขอบที่เลือก",
	"action.select_seam.auto": "อัตโนมัติ",
	"action.select_seam.join": "เชื่อม",
	"action.select_seam.divide": "แบ่ง",
	"action.adjust_brightness_contrast": "ปรับความสว่างและคอนทราสต์...",
	"action.adjust_brightness_contrast.desc": "ปรับความสว่างและคอนทราสต์ของเทกซ์เจอร์ที่เลือก",
	"action.adjust_saturation_hue": "ปรับความอิ่มตัวและเฉดสี...",
	"action.adjust_saturation_hue.desc": "ปรับความอิ่มตัวและเฉดสีของเทกซ์เจอร์ที่เลือก",
	"action.invert_colors": "กลับสี",
	"action.invert_colors.desc": "กลับสีทั้งหมดของเทกซ์เจอร์ที่เลือก",
	"action.adjust_curves": "ปรับเส้นโค้ง...",
	"action.adjust_curves.desc": "ปรับเส้นโค้งความสว่างของเทกซ์เจอร์ที่เลือก",
	"action.flip_texture_x": "พลิกแนวนอน",
	"action.flip_texture_y": "พลิกแนวตั้ง",
	"action.resize_texture": "ปรับขนาดเทกซ์เจอร์",
	"action.view_mode.uv": "ดูตัวอย่าง UV",
	"action.append_to_template": "เพิ่มองค์ประกอบในเทมเพลต...",
	"action.append_to_template.desc": "เพิ่มองค์ประกอบที่เลือกในเทมเพลตเทกซ์เจอร์",
	"action.move_texture_with_uv": "ย้ายเทกซ์เจอร์พร้อม UV",
	"action.move_texture_with_uv.desc": "ย้ายเทกซ์เจอร์ของหน้าไปพร้อมกับการลากหน้า UV",
	"action.timeline_setups": "การตั้งค่าไทม์ไลน์",
	"action.save_timeline_setup": "บันทึกการตั้งค่าไทม์ไลน์...",
	"action.save_timeline_setup.desc": "บันทึกพรีเซ็ตสำหรับแอนิเมเตอร์และช่องที่เลือก",
	"menu.texture": "เทกซ์เจอร์",
	"menu.texture.render_mode.default": "ค่าเริ่มต้น",
	"menu.texture.merge_onto_texture": "ผสานลงบนเทกซ์เจอร์ด้านบน",
	"menu.animation.unload": "ยกเลิกโหลด",
	"panel.timeline": "ไทม์ไลน์",
	"action.pan_tool": "เครื่องมือแพน",
	"action.pan_tool.desc": "เครื่องมือนำทางในวิวพอร์ตและตัวแก้ไขเทกซ์เจอร์",
	"mode.start.recent.favorite": "ทำเครื่องหมายเป็นรายการโปรด",
	"mode.start.info": "ข้อมูล",
	"mode.start.target": "เป้าหมาย",
	"mode.start.start": "เริ่มต้น",
	"mode.start.create_new": "สร้างโมเดลใหม่",
	"mode.start.format.informations": "น่ารู้:",
	"mode.start.format.resources": "ทรัพยากร:",
	"format.free.info.meshes": "ในรูปแบบนี้ คุณสามารถสร้างโมเดลโลว์โพลีด้วยคิวบ์และเมชรูปทรงกำหนดเอง",
	"format.free.info.limitation": "โมเดลไม่สามารถโหลดเข้าสู่เกมที่ต้องการรูปแบบเฉพาะ เช่น Minecraft",
	"format.skin.info.skin": "รูปแบบนี้ออกแบบมาเพื่อสร้างสกิน Minecraft และเทกซ์เจอร์เอนทิตี",
	"format.skin.info.model": "ไม่สามารถเปลี่ยนแปลงโมเดลได้ หากต้องการแก้ไขโมเดล ให้แปลงเป็นรูปแบบอื่นผ่าน **ไฟล์** > **แปลงโปรเจกต์**",
	"format.java_block.info.rotation": "การหมุนจำกัดเพียงหนึ่งแกนต่อองค์ประกอบ",
	"format.java_block.info.size": "โมเดลจำกัดขนาด 3x3x3 บล็อก การตั้งค่าการแสดงผลสามารถทำให้โมเดลไอเทมใหญ่ขึ้นได้",
	"format.java_block.info.animation": "รูปแบบนี้ไม่รองรับแอนิเมชันใน Minecraft แบบดั้งเดิม หากคุณกำลังสร้างม็อด คุณสามารถใช้ GeckoLib เพื่อทำแอนิเมชันโมเดลได้ หากไม่ใช่ วิธีเดียวคือสลับโมเดลโดยใช้คำสั่งหรือเทกซ์เจอร์แบบเคลื่อนไหว",
	"format.bedrock.info.textures": "แต่ละโมเดลสามารถมีเทกซ์เจอร์ได้เพียงหนึ่งอันเท่านั้น",
	"format.bedrock_block": "บล็อก Bedrock",
	"format.bedrock_block.desc": "โมเดลบล็อกสำหรับ Minecraft Bedrock Edition",
	"format.modded_entity.info.integer_size": "ขนาดของคิวบ์แต่ละอันจำกัดเป็นจำนวนเต็ม",
	"format.modded_entity.info.format": "โมเดลถูกเขียนในโค้ด Java แทนที่จะเป็นโครงสร้างข้อมูลเฉพาะเหมือนรูปแบบส่งออกอื่นๆ ของ Blockbench",
	"format.optifine_entity.info.optifine_required": "ผู้ใช้ที่ไม่ได้ติดตั้ง OptiFine จะไม่เห็นโมเดล",
	"format.optifine_entity.info.pivots": "จุดหมุนของกระดูกถูกล็อก ดังนั้นควรปล่อยไว้ไม่ต้องเปลี่ยนแปลง",
	"format_category.low_poly": "โลว์โพลี",
	"format_category.minecraft": "Minecraft",
	"format_category.other": "อื่นๆ",
	"format_category.loaders": "ตัวโหลด",
	"message.recover_backup.recover": "กู้คืน",
	"message.invalid_characters.title": "เส้นทางไม่ถูกต้อง",
	"message.invalid_characters.message": "เส้นทางของไฟล์ที่นำเข้ามีอักขระ ตัวอักษรพิมพ์ใหญ่ หรือช่องว่างที่ไม่ถูกต้อง อักขระที่รองรับคือ: %0",
	"dialog.share_model.thumbnail": "ภาพปก",
	"dialog.skin.high_res_texture": "โปรดทราบว่าสกินที่มีความละเอียดที่เลือกจะไม่ทำงานเป็นสกิน Minecraft ปกติ เลือกความละเอียดที่ต่ำกว่า",
	"settings.allow_display_slot_mirror": "อนุญาตการสะท้อนช่องแสดงผล",
	"settings.allow_display_slot_mirror.desc": "อนุญาตให้ช่องแสดงผลสำหรับโมเดลไอเทม Java สะท้อน คำเตือน: ทำงานเฉพาะใน Minecraft 1.14 หรือเก่ากว่าหรือในกรณีพิเศษ",
	"action.switch_tabs": "สลับแท็บ",
	"action.switch_tabs.desc": "สลับระหว่างแท็บที่เปิดอยู่ กด Shift เพื่อสลับในทิศทางตรงกันข้าม",
	"action.unselect_all": "ยกเลิกการเลือกทั้งหมด",
	"action.save_palette": "บันทึกพาเล็ต...",
	"action.save_palette.desc": "บันทึกพาเล็ตสีปัจจุบันใน Blockbench เพื่อใช้ภายหลัง",
	"action.keyframe_column_create": "สร้างคอลัมน์คีย์เฟรม",
	"action.keyframe_column_create.desc": "ตั้งค่าทุกช่องในไทม์ไลน์ที่เวลาปัจจุบัน หากมีคีย์เฟรมอยู่แล้ว",
	"action.keyframe_column_select": "เลือกคอลัมน์คีย์เฟรม",
	"action.keyframe_column_select.desc": "เลือกคีย์เฟรมทั้งหมดในไทม์ไลน์ตามคอลัมน์ใต้เฮดเพลย์",
	"menu.uv": "UV",
	"menu.keyframe": "คีย์เฟรม",
	"menu.palette.load.update": "อัปเดตพาเล็ต",
	"menu.palette.load.update.desc": "อัปเดตพาเล็ตนี้ด้วยสีของพาเล็ต Blockbench ปัจจุบัน",
	"menu.timeline_marker.set_time": "ตั้งเวลา...",
	"uv_editor.scale_uv": "ปรับขนาด UV",
	"action.preview_scene": "ฉากตัวอย่าง",
	"action.preview_scene.desc": "เปลี่ยนฉากตัวอย่างโมเดล",
	"preview_scene.minecraft_overworld": "โอเวอร์เวิลด์",
	"preview_scene.minecraft_nether": "เนเธอร์",
	"preview_scene.minecraft_end": "ดิเอนด์",
	"dialog.project.modded_entity_flip_y": "พลิกแกน Y",
	"preview_scene.studio": "สตูดิโอ",
	"format.image": "รูปภาพ",
	"modifier_actions.set_copy_source": "ตั้งแหล่งที่มาของการคัดลอก",
	"message.load_images.title": "โหลดรูปภาพ",
	"message.load_images.edit_image": "แก้ไขรูปภาพ",
	"dialog.add_primitive.align_edges": "จัดขอบ",
	"dialog.flip_animation.show_in_timeline": "แสดงกระดูกที่แก้ไขในไทม์ไลน์",
	"settings.default_cube_size": "ขนาดคิวบ์เริ่มต้น",
	"settings.default_cube_size.desc": "ขนาดเริ่มต้นเมื่อสร้างคิวบ์ใหม่",
	"settings.uniform_keyframe": "คีย์เฟรมมาตราส่วนสม่ำเสมอ",
	"settings.uniform_keyframe.desc": "ตั้งคีย์เฟรมมาตราส่วนเป็นมาตราส่วนสม่ำเสมอโดยค่าเริ่มต้น",
	"settings.nearest_rectangle_select": "การเลือกสี่เหลี่ยม: ขอบใกล้สุด",
	"settings.nearest_rectangle_select.desc": "จับการเลือกสี่เหลี่ยมไปยังขอบพิกเซลใกล้สุด เหมือนใน GIMP แทนที่จะเป็นพิกเซลทั้งหมด",
	"settings.pick_color_opacity": "เลือกความทึบสี",
	"settings.pick_color_opacity.desc": "เลือกความทึบสีด้วยตัวเลือกสีและตั้งเป็นความทึบของแปรง",
	"settings.paint_with_stylus_only": "วาดด้วยสไตลัสเท่านั้น",
	"settings.paint_with_stylus_only.desc": "ใช้สไตลัสสำหรับวาดเท่านั้น สำรองเมาส์หรือการสัมผัสสำหรับการนำทาง",
	"action.copy_brush_mode": "โหมดแปรงคัดลอก",
	"action.copy_brush_mode.copy": "คัดลอก",
	"action.copy_brush_mode.pattern": "ลวดลาย",
	"action.copy_brush_mode.sample": "ตัวอย่าง",
	"action.brush_shape": "รูปร่างแปรง",
	"action.brush_shape.square": "สี่เหลี่ยม",
	"action.brush_shape.circle": "วงกลม",
	"action.blend_mode": "โหมดผสม",
	"action.blend_mode.default": "ค่าเริ่มต้น",
	"action.blend_mode.set_opacity": "ตั้งความทึบ",
	"action.blend_mode.color": "สี",
	"action.blend_mode.behind": "ด้านหลัง",
	"action.blend_mode.multiply": "คูณ",
	"action.blend_mode.divide": "หาร",
	"action.blend_mode.add": "เพิ่ม",
	"action.blend_mode.subtract": "ลบ",
	"action.blend_mode.screen": "สกรีน",
	"action.blend_mode.overlay": "ซ้อนทับ",
	"action.blend_mode.hard_light": "แสงแข็ง",
	"action.blend_mode.difference": "ความแตกต่าง",
	"action.copy_brush": "แปรงคัดลอก",
	"action.copy_brush.desc": "แปรงเพื่อโคลนส่วนของเทกซ์เจอร์หรือวาดลวดลาย กด Ctrl ค้างและคลิกเพื่อเลือกแหล่งที่มาของการคัดลอก",
	"action.validator_window": "ดูปัญหาโมเดล...",
	"action.validator_window.desc": "เปิดตัวตรวจสอบ ซึ่งแสดงปัญหาของโมเดลปัจจุบัน",
	"action.cancel_gif": "ยกเลิก GIF",
	"menu.text_edit.copy_vector": "คัดลอกเวกเตอร์",
	"menu.brush_presets.dialog": "พรีเซ็ตแปรง...",
	"menu.brush_presets.pixel_brush": "แปรงพิกเซล",
	"menu.brush_presets.smooth_brush": "แปรงเรียบ",
	"menu.texture.edit_in_blockbench": "แก้ไขใน Blockbench",
	"menu.mirror_painting.axis": "แกน",
	"menu.mirror_painting.axis.desc": "เลือกแกนที่จะสะท้อนการวาด",
	"menu.mirror_painting.global": "สมมาตรทั่วโลก",
	"menu.mirror_painting.global.desc": "เปิดใช้การวาดสะท้อนบนโมเดลในพื้นที่ส่วนกลาง",
	"menu.mirror_painting.local": "สมมาตรท้องถิ่น",
	"menu.mirror_painting.local.desc": "เปิดใช้การวาดสะท้อนในพื้นที่ท้องถิ่นสำหรับแต่ละองค์ประกอบ",
	"menu.mirror_painting.texture_frames": "ทำซ้ำบนเฟรมฟลิปบุ๊ค",
	"menu.mirror_painting.texture_frames.desc": "สะท้อนการวาดไปยังทุกเฟรมของเทกซ์เจอร์แบบเคลื่อนไหว",
	"format.bedrock_block.info.size_limit": "ขนาดรวมของบล็อกจำกัดที่ 30 พิกเซลในทุกมิติ ขีดจำกัดสามารถเลื่อนออกจากศูนย์กลางได้ 7 พิกเซลในทุกทิศทาง",
	"format.bedrock_block.info.textures": "สามารถใช้เทกซ์เจอร์หลายอันกับคิวบ์ต่างๆ ใน Blockbench ได้ แต่ต้องมีการตั้งค่าเพิ่มเติมในแพ็คพฤติกรรมเพื่อให้ทำงานในเกมได้อย่างถูกต้อง",
	"format.image.desc": "แก้ไขรูปภาพในตัวแก้ไขรูปภาพ 2D",
	"generic.delete_all": "ลบทั้งหมด",
	"message.child_model_only.open": "เปิดต้นแบบ",
	"message.child_model_only.open_with_textures": "เปิดต้นแบบและนำเทกซ์เจอร์มาใช้",
	"dialog.project.credit": "เครดิต",
	"dialog.convert_project.create_copy": "สร้างสำเนา",
	"dialog.texture.frame_time": "เวลาเฟรม",
	"dialog.texture.frame_time.desc": "ตั้งค่าระยะเวลาที่เฟรมแต่ละเฟรมจะแสดง เป็นหน่วย tick 1 tick เท่ากับ 1/20 วินาที",
	"dialog.texture.frame_interpolate": "ประมาณค่าระหว่างเฟรม",
	"dialog.texture.frame_interpolate.desc": "ประมาณค่าระหว่างเฟรมแอนิเมชันโดยการค่อยๆ เปลี่ยนไปเฟรมถัดไป",
	"dialog.texture.frame_order_type": "โหมดวนซ้ำ",
	"dialog.texture.frame_order_type.loop": "วนซ้ำ",
	"dialog.texture.frame_order_type.backwards": "วนซ้ำย้อนกลับ",
	"dialog.texture.frame_order_type.back_and_forth": "ไป-กลับ",
	"dialog.texture.frame_order_type.custom": "ลำดับกำหนดเอง",
	"dialog.texture.frame_order": "ลำดับเฟรม",
	"dialog.texture.frame_order.desc": "ตั้งค่าลำดับเฟรมแบบกำหนดเองโดยระบุดัชนีเฟรมในลำดับใหม่ ดัชนีเฟรมเริ่มจาก 0 ที่เฟรมแรก",
	"dialog.select.mode": "โหมด",
	"dialog.select.mode.new": "เลือกใหม่",
	"dialog.select.mode.add": "เพิ่มในที่เลือก",
	"dialog.select.mode.remove": "ลบออกจากที่เลือก",
	"dialog.select.mode.in_selection": "เลือกเฉพาะจากที่เลือก",
	"dialog.predicate_overrides.model": "โมเดล",
	"dialog.predicate_overrides.predicates": "เพรดิเคต",
	"dialog.predicate_overrides.variants": "ตัวแปร",
	"dialog.predicate_overrides.start_value": "เริ่มต้น",
	"dialog.predicate_overrides.add_override": "เพิ่มโอเวอร์ไรด์",
	"dialog.predicate_overrides.add_predicate": "เพิ่มเพรดิเคต",
	"dialog.predicate_overrides.generate_overrides": "สร้างโอเวอร์ไรด์",
	"dialog.predicate_overrides.confirm_delete": "คุณแน่ใจหรือไม่ว่าต้องการลบโอเวอร์ไรด์ทั้งหมด?",
	"dialog.predicate_overrides.predicate.angle": "มุมเข็มทิศ",
	"dialog.predicate_overrides.predicate.blocking": "กำลังบล็อก",
	"dialog.predicate_overrides.predicate.broken": "พังแล้ว",
	"dialog.predicate_overrides.predicate.cast": "ถูกโยน",
	"dialog.predicate_overrides.predicate.cooldown": "คูลดาวน์",
	"dialog.predicate_overrides.predicate.damage": "ความเสียหาย",
	"dialog.predicate_overrides.predicate.damaged": "เสียหาย",
	"dialog.predicate_overrides.predicate.lefthanded": "ถนัดซ้าย",
	"dialog.predicate_overrides.predicate.pull": "ปริมาณดึง",
	"dialog.predicate_overrides.predicate.pulling": "กำลังดึง",
	"dialog.predicate_overrides.predicate.charged": "ชาร์จแล้ว",
	"dialog.predicate_overrides.predicate.firework": "มีดอกไม้ไฟ",
	"dialog.predicate_overrides.predicate.throwing": "พร้อมโยน",
	"dialog.predicate_overrides.predicate.time": "เวลาของวัน",
	"dialog.predicate_overrides.predicate.custom_model_data": "ข้อมูลโมเดลกำหนดเอง",
	"dialog.predicate_overrides.predicate.level": "ระดับแสง",
	"dialog.predicate_overrides.predicate.filled": "ระดับการเติมบันเดิล",
	"dialog.predicate_overrides.predicate.tooting": "กำลังเป่า",
	"settings.model_export_scale": "มาตราส่วนส่งออกโมเดล",
	"settings.model_export_scale.desc": "ตัวคูณที่มาตราส่วนของโมเดล glTF, DAE และ FBX ที่ส่งออกลดลง ค่าเริ่มต้นคือ 16 ซึ่งแปลง 16 หน่วย Blockbench เป็น 1 เมตรในการส่งออก",
	"action.export_fbx": "ส่งออกโมเดล FBX",
	"action.export_fbx.desc": "ส่งออกโมเดลและแอนิเมชันเป็นไฟล์ FBX เพื่อใช้ในแอป 3D และเอนจินเกมอื่น",
	"action.center_lateral": "จัดกึ่งกลางแนวนอน",
	"action.center_lateral.desc": "จัดองค์ประกอบที่เลือกให้อยู่กึ่งกลางบนแกน X และ Z",
	"action.adjust_opacity": "ปรับความทึบ...",
	"action.adjust_opacity.desc": "ปรับความทึบของเทกซ์เจอร์ที่เลือก",
	"action.rotate_texture_cw": "หมุนตามเข็มนาฬิกา",
	"action.rotate_texture_ccw": "หมุนทวนเข็มนาฬิกา",
	"action.predicate_overrides": "แก้ไขตัวดัดแปลงเงื่อนไข...",
	"action.predicate_overrides.desc": "เลือกโมเดลที่จะแทนที่โมเดลนี้ตามเงื่อนไขที่เลือก",
	"action.auto_set_cullfaces": "ตั้ง Cullface อัตโนมัติ",
	"action.auto_set_cullfaces.desc": "สร้าง cullface อัตโนมัติเพื่อซ่อนหน้าเมื่อถูกบล็อกข้างเคียงปิด",
	"menu.texture.edit_externally": "แก้ไขภายนอก",
	"menu.mirror_painting.texture": "สมมาตรตัวแก้ไข 2D",
	"menu.mirror_painting.texture.desc": "เปิดใช้การวาดสะท้อนในพื้นที่ 2D บนรูปภาพหรือเทกซ์เจอร์",
	"menu.animator.rotation_global": "หมุนในพื้นที่ส่วนกลาง",
	"uv_editor.face_properties": "คุณสมบัติหน้า",
	"uv_editor.face_properties.material_instance": "วัสดุ",
	"uv_editor.tint.info": "สามารถเปิดใช้การย้อมสีบนหน้าเพื่อบอกให้ Minecraft ย้อมสี ในแวนิลลา การย้อมสีสามารถใช้ได้เฉพาะบล็อกเฉพาะ เช่น ใบไม้ และฝุ่นเรดสโตน และมีค่าได้เพียง 0",
	"uv_editor.cullface.info": "การเปิดใช้ cullface จะบอกให้หน้าของบล็อกไม่แสดงผลถ้ามีบล็อกเต็มอยู่ข้างๆ ในทิศทางที่ระบุในโลก Minecraft ของคุณ สามารถใช้เพื่อเพิ่มประสิทธิภาพ",
	"uv_editor.material_instance.info": "วัสดุสามารถตั้งเป็นชื่อที่กำหนดเอง ชื่อนั้นสามารถใช้ในไฟล์ JSON ของบล็อกใน behavior pack เพื่อกำหนดเทกซ์เจอร์และวัสดุเฉพาะให้กับหน้านั้น",
	"display.reference.frame_invisible": "กรอบไอเทม (ล่องหน)",
	"data.settings_profile": "โปรไฟล์",
	"message.display_skin.invalid_name": "ไม่พบบัญชี Minecraft ที่มีชื่อ \"%0\"",
	"dialog.load_plugins_from_query.title": "โหลดปลั๊กอิน",
	"dialog.load_plugins_from_query.text": "คุณใช้ลิงก์ที่ต้องใช้ปลั๊กอิน คุณต้องการติดตั้งหรือไม่?",
	"dialog.select_model.title": "เลือกโมเดล",
	"dialog.select_model.bones": "กระดูก",
	"dialog.select_model.cubes": "คิวบ์",
	"dialog.settings.create_profile": "สร้างโปรไฟล์...",
	"settings_profile.confirm_delete": "คุณแน่ใจหรือไม่ว่าต้องการลบโปรไฟล์การตั้งค่านี้?",
	"settings_profile.condition.type.selectable": "เลือกได้ด้วยตนเอง",
	"settings.interface_mode": "โหมดอินเทอร์เฟซ",
	"settings.interface_mode.desc": "โหมดอินเทอร์เฟซ",
	"settings.interface_mode.auto": "อัตโนมัติ",
	"settings.interface_mode.desktop": "เดสก์ท็อป",
	"settings.interface_mode.mobile": "มือถือ",
	"settings.paint_through_transparency": "วาดผ่านความโปร่งใส",
	"settings.paint_through_transparency.desc": "วาดผ่านพิกเซลโปร่งใสเมื่อล็อกช่องอัลฟา",
	"action.tab_overview": "ภาพรวมแท็บ",
	"action.tab_overview.desc": "ดูแท็บที่เปิดอยู่ทั้งหมดและกระโดดไปยังแท็บหนึ่ง",
	"action.slider_color_red": "สีแดง",
	"action.slider_color_green": "สีเขียว",
	"action.slider_color_blue": "สีน้ำเงิน",
	"action.add_animation_controller": "เพิ่มคอนโทรลเลอร์แอนิเมชัน",
	"action.add_animation_controller.desc": "สร้างคอนโทรลเลอร์แอนิเมชันเปล่า",
	"action.animation_controller_preview_mode": "ตัวอย่างคอนโทรลเลอร์",
	"action.animation_controller_preview_mode.paused": "หยุดชั่วคราว",
	"action.animation_controller_preview_mode.manual": "ตัวอย่างด้วยตนเอง",
	"action.animation_controller_preview_mode.play": "เล่นอัตโนมัติ",
	"action.keyframe_interpolation.bezier": "เบซิเยร์",
	"action.keyframe_bezier_linked": "เชื่อมแฮนเดิล Bézier",
	"action.keyframe_bezier_linked.desc": "เชื่อมแฮนเดิลเบซิเยร์ซ้ายและขวาของคีย์เฟรม",
	"action.reset_keyframe_handles": "รีเซ็ตแฮนเดิลคีย์เฟรม",
	"action.reset_keyframe_handles.desc": "รีเซ็ตแฮนเดิลเบซิเยร์ของคีย์เฟรมที่เลือก",
	"action.looped_animation_playback": "เล่นวนลูป",
	"action.looped_animation_playback.desc": "ดูตัวอย่างแอนิเมชันในลูปไม่รู้จบ",
	"timeline.bind_to_actor": "ผูกกับแอกเตอร์",
	"animation_controllers.select_preset": "เลือกพรีเซ็ตคอนโทรลเลอร์...",
	"animation_controllers.state.animations": "แอนิเมชัน",
	"animation_controllers.state.particles": "อนุภาค",
	"animation_controllers.state.sounds": "เสียง",
	"animation_controllers.state.on_entry": "เมื่อเข้า",
	"animation_controllers.state.on_exit": "เมื่อออก",
	"animation_controllers.state.transitions": "ทรานซิชัน",
	"animation_controllers.state.condition": "เงื่อนไข",
	"animation_controllers.state.blend_transition": "เวลาผสม",
	"animation_controllers.state.shortest_path": "ผสมตามเส้นทางสั้นสุด",
	"animation_controllers.state.edit_transition": "แก้ไขทรานซิชัน",
	"menu.color_picker.picker_type": "ประเภทตัวเลือก",
	"menu.color_picker.picker_type.square": "สี่เหลี่ยม",
	"menu.color_picker.picker_type.wheel": "วงล้อ",
	"menu.color_picker.slider_mode": "โหมดสลาย",
	"menu.color_picker.slider_mode.hsv": "เฉดสี, ความอิ่มตัว, ค่าสี",
	"menu.color_picker.slider_mode.rgb": "แดง, เขียว, น้ำเงิน",
	"menu.texture.render_mode.additive": "แบบเพิ่ม",
	"panel.color.picker_options": "ตัวเลือกตัวเลือกสี",
	"panel.animation_controllers": "ตัวควบคุมแอนิเมชัน",
	"display.preset.armor_stand": "พื้น (แท่นเกราะ)",
	"data.file_path": "เส้นทางไฟล์",
	"dialog.extrude.orientation": "การวางแนว",
	"dialog.extrude.orientation.upright": "ตั้งตรง",
	"dialog.extrude.orientation.flat": "ราบ",
	"dialog.scale.box_uv_warning": "การปรับขนาดโมเดล Box UV อาจทำให้ UV เสียหาย ลองปรับขนาดโมเดลภายนอก หรือเปลี่ยนเป็นโหมด UV ต่อหน้าใน ไฟล์ > โปรเจกต์",
	"dialog.create_gif.format": "รูปแบบ",
	"dialog.create_gif.format.gif": "GIF",
	"dialog.create_gif.format.png_sequence": "ลำดับ PNG",
	"dialog.create_gif.pixelate": "พิกเซลเลต",
	"dialog.create_gif.bg_image": "ภาพพื้นหลัง",
	"dialog.create_gif.turn.desc": "หมุนโมเดลขณะบันทึก ใช้ค่าลบเพื่อหมุนตามเข็มนาฬิกา ค่า 60 หมายถึงหมุนหนึ่งรอบต่อวินาที",
	"settings_profile.condition": "เงื่อนไข",
	"settings_profile.condition.type.file_path.desc": "ใช้ไวยากรณ์นิพจน์ปกติเพื่อจับคู่เส้นทางไฟล์ของโปรเจกต์ปัจจุบัน ใช้เครื่องหมายทับสำหรับไดเรกทอรี",
	"settings.only_selected_bezier_handles": "แสดงเฉพาะแฮนเดิล Bézier ที่เลือก",
	"settings.only_selected_bezier_handles.desc": "ซ่อนแฮนเดิลของคีย์เฟรมเบซิเยร์ที่ยังไม่ได้เลือก",
	"settings.embed_textures": "ฝังเทกซ์เจอร์",
	"settings.embed_textures.desc": "ฝังเนื้อหาไฟล์เทกซ์เจอร์ในไฟล์ .bbmodel",
	"action.selection_mode.cluster": "คลัสเตอร์",
	"dialog.copied_to_clipboard": "คัดลอกไปยังคลิปบอร์ดแล้ว",
	"data.reference_image": "รูปอ้างอิง",
	"message.delete_reference_image": "คุณแน่ใจหรือไม่ว่าต้องการลบภาพอ้างอิงนี้? ไม่สามารถย้อนกลับได้",
	"message.add_reference_image.message": "เลือกตำแหน่งที่จะโหลดภาพอ้างอิง",
	"message.add_reference_image.project": "เพิ่มในโปรเจกต์นี้",
	"message.add_reference_image.app": "เพิ่มในทุกโปรเจกต์",
	"message.import_particle_texture.import": "นำเข้าเทกซ์เจอร์อนุภาค",
	"message.import_particle_texture.message": "คุณต้องการนำเข้าไฟล์เทกซ์เจอร์สำหรับอนุภาคของคุณหรือไม่?",
	"message.save_codec_selector.title": "รูปแบบบันทึกโมเดล",
	"message.save_codec_selector.message": "เลือกรูปแบบที่จะบันทึกโมเดล",
	"message.save_codec_selector.project_file": "โปรเจกต์ Blockbench (.bbmodel)",
	"message.save_codec_selector.both": "ทั้งสอง",
	"message.display_skin.username": "ชื่อผู้ใช้ (Java)",
	"message.palette_locked": "พาเล็ตถูกล็อก",
	"dialog.project.default_uv_mode": "โหมด UV เริ่มต้น",
	"dialog.project.default_uv_mode.description": "โหมด UV เริ่มต้นของโปรเจกต์ โหมด UV สามารถเปลี่ยนได้ต่อคิวบ์",
	"dialog.export_options.title": "ตัวเลือกการส่งออก",
	"dialog.edit_texture.preview": "ตัวอย่าง",
	"dialog.proportional_editing.range": "ช่วง",
	"dialog.proportional_editing.falloff": "การลดทอน",
	"dialog.proportional_editing.falloff.linear": "เชิงเส้น",
	"dialog.proportional_editing.falloff.hermite_spline": "เรียบ",
	"dialog.proportional_editing.falloff.constant": "คงที่",
	"dialog.proportional_editing.selection": "การเลือก",
	"dialog.proportional_editing.selection.linear": "ระยะทางเชิงเส้น",
	"dialog.proportional_editing.selection.connections": "การเชื่อมต่อ",
	"dialog.mirror_painting_texture_center.middle": "กลาง",
	"dialog.mirror_painting_texture_center.custom": "กำหนดเอง",
	"dialog.settings.reset_to_default": "รีเซ็ตเป็นค่าเริ่มต้น",
	"keybindings.item.num_slider.increase": "เพิ่ม",
	"keybindings.item.num_slider.decrease": "ลด",
	"settings.always_show_splash_art": "แสดงภาพสแปลชเสมอ",
	"settings.always_show_splash_art.desc": "แสดงภาพสแปลชบนหน้าจอเริ่มต้นเสมอ",
	"action.slider_palette_color": "สลับสีพาเล็ต",
	"action.slider_palette_color.desc": "วนสลับระหว่างสีในพาเล็ต",
	"action.proportional_editing": "การแก้ไขตามสัดส่วน",
	"action.proportional_editing.desc": "มีผลต่อจุดยอดโดยรอบตามสัดส่วนเมื่อแก้ไขส่วนของเมช",
	"action.limit_to_palette": "จำกัดเป็นพาเล็ต",
	"action.limit_to_palette.desc": "จำกัดสีของเทกซ์เจอร์เป็นสีในพาเล็ตที่โหลดอยู่",
	"action.edit_reference_images": "แก้ไขภาพอ้างอิง",
	"action.edit_reference_images.desc": "เปิดโหมดภาพอ้างอิงเพื่อเพิ่มหรือแก้ไขภาพอ้างอิงและพิมพ์เขียว",
	"action.add_reference_image": "เพิ่มภาพอ้างอิง",
	"action.reference_image_from_clipboard": "ภาพอ้างอิงจากคลิปบอร์ด",
	"action.reference_image_list": "ภาพอ้างอิง",
	"action.connect_uv_faces": "เชื่อมหน้า UV",
	"action.connect_uv_faces.desc": "เชื่อมหน้า UV ที่เลือกกับหน้า UV ที่เลือกล่าสุด",
	"action.merge_uv_vertices": "ผสานจุดยอด UV",
	"action.merge_uv_vertices.desc": "จับจุดยอด UV ที่เลือกแรกไปยังจุดยอด UV ที่เลือกล่าสุด",
	"action.bedrock_animation_mode": "โหมดแอนิเมชัน Bedrock",
	"action.bedrock_animation_mode.desc": "เลือกโหมดเพื่อแก้ไขแอนิเมชันสำหรับ Minecraft: Bedrock Edition",
	"action.bedrock_animation_mode.entity": "เอนทิตี",
	"action.bedrock_animation_mode.attachable_first": "ไอเทมมุมมองบุคคลที่ 1",
	"action.bedrock_animation_mode.attachable_third": "ไอเทมมุมมองบุคคลที่ 3",
	"timeline.amplify": "ขยาย",
	"menu.options": "ตัวเลือก...",
	"menu.palette.lock_palette": "ล็อกพาเล็ต",
	"menu.uv.export": "ส่งออกการแมป UV",
	"menu.uv.flip_x": "สะท้อน X",
	"menu.uv.flip_y": "สะท้อน Y",
	"menu.mirror_painting.enabled": "เปิดใช้",
	"reference_image.position": "ตำแหน่ง",
	"reference_image.size": "ขนาด",
	"reference_image.rotation": "การหมุน",
	"reference_image.opacity": "ความทึบ",
	"reference_image.visibility": "การมองเห็น",
	"reference_image.clear_mode": "โหมดล้าง",
	"reference_image.layer": "เลเยอร์",
	"reference_image.layer.background": "หลังโมเดล",
	"reference_image.layer.viewport": "หน้าโมเดล",
	"reference_image.layer.float": "หน้าส่วนติดต่อ",
	"reference_image.scope": "ขอบเขต",
	"reference_image.scope.project": "เฉพาะโปรเจกต์นี้",
	"reference_image.scope.global": "ทุกโปรเจกต์",
	"reference_image.enabled_modes": "เปิดใช้ในโหมด",
	"codec.common.encoding": "การเข้ารหัส",
	"codec.common.armature": "ส่งออกกลุ่มเป็นอาร์มาเจอร์",
	"codec.common.export_animations": "ส่งออกแอนิเมชัน",
	"codec.common.embed_textures": "ฝังเทกซ์เจอร์",
	"preview.center_camera": "จัดกล้องกึ่งกลาง",
	"display.reference.frame_top": "กรอบไอเทมด้านบน",
	"display.reference.frame_top_invisible": "กรอบไอเทมด้านบน (ล่องหน)",
	"action.proportional_editing_range": "ช่วงการแก้ไขตามสัดส่วน",
	"action.proportional_editing_range.desc": "ปรับช่วงสำหรับการแก้ไขตามสัดส่วน",
	"action.toggle_all_reference_images": "ซ่อน/แสดงภาพอ้างอิงทั้งหมด",
	"action.toggle_all_reference_images.desc": "สลับการมองเห็นภาพอ้างอิงทั้งหมดพร้อมกัน",
	"action.add_animation_controller_state": "เพิ่มสถานะคอนโทรลเลอร์แอนิเมชัน",
	"action.add_animation_controller_state.desc": "เพิ่มสถานะใหม่ในคอนโทรลเลอร์แอนิเมชัน",
	"menu.slider.round_value": "ปัดค่า",
	"texture.error.too_large": "ความละเอียดเกินค่าสูงสุด %0",
	"dialog.copy_to_clipboard": "คัดลอกไปยังคลิปบอร์ด",
	"dialog.open_url": "เปิด URL",
	"reference_image.image": "รูปภาพ",
	"uv_editor.rotate_uv": "หมุน UV",
	"generic.error": "ข้อผิดพลาด",
	"projects.start_screen": "หน้าจอเริ่มต้น",
	"message.invalid_link.message": "โมเดลที่แชร์ \"%0\" ที่คุณพยายามโหลดไม่ถูกต้องหรือหมดอายุแล้ว",
	"message.plugin_dependencies.title": "การพึ่งพาปลั๊กอิน",
	"message.plugin_dependencies.message1": "ปลั๊กอินต้องใช้ส่วนที่ต้องพึ่งพาเหล่านี้:",
	"message.plugin_dependencies.message1_update": "ปลั๊กอิน %0 ได้รับการอัปเดตและตอนนี้ต้องใช้ส่วนที่ต้องพึ่งพาเหล่านี้:",
	"message.plugin_dependencies.message2": "คุณต้องการติดตั้งเพื่อดำเนินการต่อหรือไม่?",
	"message.plugin_dependencies.invalid": "น่าเสียดายที่ปลั๊กอินไม่สามารถติดตั้งได้ มีส่วนพึ่งพาที่ไม่ถูกต้อง:",
	"message.preview_scene_load_failed": "โหลดฉากตัวอย่างล้มเหลว ตรวจสอบการเชื่อมต่ออินเทอร์เน็ตของคุณ",
	"dialog.convert_project.text1": "แปลงโปรเจกต์เป็นรูปแบบอื่น",
	"dialog.convert_project.text2": "ใช้การแปลงด้วยความเสี่ยงของคุณเอง รูปแบบต่างๆ มีคุณสมบัติและข้อจำกัดต่างกัน ดังนั้นการแปลงอาจทำให้บางส่วนของโปรเจกต์เสียหายในบางกรณี",
	"dialog.convert_project.text3": "คุณไม่สามารถเลิกทำการแปลงได้ นั่นคือเหตุผลที่โดยค่าเริ่มต้นจะสร้างสำเนา",
	"dialog.unsaved_work.title": "งานที่ยังไม่ได้บันทึก",
	"dialog.unsaved_work.text": "โปรเจกต์ต่อไปนี้มีการเปลี่ยนแปลงที่ยังไม่ได้บันทึก คุณต้องการบันทึกการเปลี่ยนแปลงหรือไม่?",
	"dialog.unsaved_work.discard_all": "ละทิ้งทั้งหมด",
	"dialog.unsaved_work.save_all": "บันทึกทั้งหมด",
	"dialog.resize_texture.mode": "โหมด",
	"dialog.resize_texture.mode.crop": "ครอบตัด/ขยาย",
	"dialog.resize_texture.mode.scale": "ปรับขนาด",
	"dialog.plugins.is_installed": "ติดตั้งแล้ว",
	"dialog.plugins.is_disabled": "ปิดใช้งาน",
	"dialog.plugins.disable": "ปิดใช้งาน",
	"dialog.plugins.enable": "เปิดใช้งาน",
	"dialog.plugins.dependencies": "ขึ้นต่อ:",
	"dialog.view_backups.open_folder": "เปิดโฟลเดอร์",
	"dialog.share_model.reference_images": "รวมภาพอ้างอิง",
	"dialog.share_model.too_large": "อัปโหลดล้มเหลว: โมเดลใหญ่เกินไป",
	"dialog.share_model.too_large_references": "อัปโหลดล้มเหลว: โมเดลใหญ่เกินไป ลองโดยไม่มีภาพอ้างอิง",
	"settings.stretch_linked": "เชื่อมการยืด",
	"settings.stretch_linked.desc": "ยืดคิวบ์ในทุกทิศทางด้วยค่าเดียวกัน",
	"settings.grids": "แสดงกริด",
	"settings.grids.desc": "แสดงหรือซ่อนกริด 3D ทั้งหมด",
	"settings.double_click_switch_tools": "สลับเครื่องมือเมื่อดับเบิลคลิก",
	"settings.double_click_switch_tools.desc": "ดับเบิลคลิกวิวพอร์ตเพื่อสลับระหว่างเครื่องมือ",
	"settings.outlines_in_paint_mode": "เส้นรอบการเลือกในโหมดวาด",
	"settings.outlines_in_paint_mode.desc": "แสดงเส้นรอบการเลือกองค์ประกอบขณะอยู่ในโหมดวาด",
	"settings.json_indentation": "การเยื้อง JSON",
	"settings.json_indentation.desc": "รูปแบบการเยื้องสำหรับไฟล์ JSON ที่ส่งออก",
	"settings.json_indentation.tabs": "แท็บ",
	"settings.json_indentation.spaces_4": "ช่องว่าง: 4",
	"settings.json_indentation.spaces_2": "ช่องว่าง: 2",
	"action.slider_stretch": "ยืด",
	"action.slider_stretch.desc": "ยืดคิวบ์แบบทวีคูณตามแกน %0 โดยไม่เปลี่ยน UV",
	"action.view_backups": "ดูสำรองข้อมูล",
	"action.view_backups.desc": "เรียกดูรายการสำรองข้อมูลอัตโนมัติของโปรเจกต์",
	"action.search_outliner": "ค้นหาเอาต์ไลเนอร์",
	"action.search_outliner.desc": "ค้นหาชื่อองค์ประกอบเฉพาะในเอาต์ไลเนอร์",
	"action.mirror_modeling": "Mirror Modeling",
	"action.mirror_modeling.desc": "เปิดใช้ Mirror Modeling บนแกน X การเปลี่ยนแปลงทั้งหมดที่คุณทำในวิวพอร์ตจะถูกสะท้อนไปยังอีกด้าน ยกเว้นว่าปิดใช้โดยเฉพาะบนองค์ประกอบ",
	"action.allow_element_mirror_modeling": "อนุญาต Mirror Modeling",
	"action.allow_element_mirror_modeling.desc": "เลือกว่าองค์ประกอบที่เลือกสามารถได้รับผลจาก Mirror Modeling หรือไม่",
	"action.switch_face_crease": "สลับครีสหน้า",
	"action.switch_face_crease.desc": "สลับทิศทางที่ควอดพับตรงกลาง",
	"action.clear_unused_texture_space": "ล้างพื้นที่เทกซ์เจอร์ที่ไม่ได้ใช้",
	"action.clear_unused_texture_space.desc": "ล้างส่วนของเทกซ์เจอร์ที่ไม่ได้แมป UV ไปยังองค์ประกอบใดๆ",
	"action.split_screen": "แบ่งหน้าจอ",
	"action.split_screen.desc": "เลือกโหมดแบ่งหน้าจอ",
	"action.split_screen.single": "เดี่ยว",
	"action.split_screen.double_horizontal": "คู่แนวนอน",
	"action.split_screen.double_vertical": "คู่แนวตั้ง",
	"action.split_screen.quad": "สี่ส่วน",
	"action.split_screen.triple_left": "สามซ้าย",
	"action.split_screen.triple_right": "สามขวา",
	"action.split_screen.triple_top": "สามบน",
	"action.split_screen.triple_bottom": "สามล่าง",
	"action.uv_project_from_view": "โปรเจกต์ UV จากมุมมอง",
	"action.uv_project_from_view.desc": "สร้าง UV อัตโนมัติสำหรับหน้าที่เลือกจากมุมมอง 3D",
	"action.graph_editor_other_graphs": "แสดงกราฟอื่น",
	"action.graph_editor_other_graphs.desc": "ว่าจะแสดงกราฟของแกนที่ไม่ได้เลือกหรือไม่",
	"action.graph_editor_include_other_graphs": "รวมกราฟอื่น",
	"action.graph_editor_include_other_graphs.desc": "ว่าตัวแก้ไขกราฟรวมกราฟที่ไม่ได้เลือกในมุมมองหรือไม่",
	"action.set_ik_source": "ตั้งราก IK",
	"action.set_ik_source.desc": "เลือกกระดูกรากของโซ่ที่ควรถูกเคลื่อนโดยออบเจกต์เปล่านี้ผ่าน Inverse Kinematics",
	"edit.loop_cut.cuts": "จำนวนตัด",
	"panel.element.stretch": "ยืด",
	"preview_scene.minecraft_plains": "ที่ราบ",
	"preview_scene.minecraft_cherry_grove": "สวนเชอร์รี่",
	"preview_scene.minecraft_snowy_tundra": "ทุนดราหิมะ",
	"preview_scene.minecraft_sunset": "พระอาทิตย์ตก",
	"preview_scene.minecraft_night": "กลางคืน",
	"preview_scene.minecraft_desert": "ทะเลทราย",
	"preview_scene.minecraft_underwater": "ใต้น้ำ",
	"preview_scene.minecraft_coral_reef": "ปะการัง",
	"preview_scene.minecraft_lush_cave": "ถ้ำอุดม",
	"preview_scene.minecraft_deep_dark": "ดีปดาร์ก",
	"generic.navigate_forward": "ไปข้างหน้า",
	"generic.navigate_back": "ย้อนกลับ",
	"action.element_render_order": "ลำดับเรนเดอร์ความโปร่งใส",
	"action.element_render_order.default": "อัตโนมัติ",
	"action.element_render_order.behind": "ด้านหลัง",
	"action.element_render_order.in_front": "ด้านหน้า",
	"message.installing_update.title": "มีอัปเดตพร้อมใช้งาน",
	"message.installing_update.message": "เวอร์ชันใหม่พร้อมติดตั้ง หลังจากปิดแอป กรุณารอประมาณ %0 วินาทีก่อนเปิด Blockbench อีกครั้งหรือปิดคอมพิวเตอร์ เพื่อให้อัปเดตถูกติดตั้ง",
	"settings.brush_cursor_2d": "เคอร์เซอร์แปรง 2D",
	"settings.brush_cursor_2d.desc": "แสดงเส้นรอบรอบแปรงในพื้นที่ทำงาน 2D",
	"settings.brush_cursor_3d": "เคอร์เซอร์แปรง 3D",
	"settings.brush_cursor_3d.desc": "แสดงเส้นรอบรอบแปรงในพื้นที่ทำงาน 3D",
	"settings.cdn_mirror": "ใช้ CDN Mirror",
	"settings.cdn_mirror.desc": "ใช้ CDN mirror เพื่อดาวน์โหลดปลั๊กอิน Mirror จะได้รับการอัปเดตเร็วกว่า และทำงานในบางภูมิภาคที่ค่าเริ่มต้นไม่ทำงาน",
	"data.layer": "เลเยอร์",
	"data.panel": "แผง",
	"generic.confirm_delete": "คุณแน่ใจหรือไม่ว่าต้องการลบรายการนี้?",
	"format_category.general": "ทั่วไป",
	"modifier_actions.no_uniform_scaling": "ปรับขนาดอิสระ",
	"message.texture_refresh_conflict.title": "เวอร์ชันเทกซ์เจอร์ขัดแย้ง",
	"message.texture_refresh_conflict.message": "ไฟล์เทกซ์เจอร์อาจมีการเปลี่ยนแปลงที่ขัดแย้งกับเวอร์ชันของ Blockbench",
	"message.texture_refresh_conflict.keep_ours": "ใช้เวอร์ชันของ Blockbench",
	"message.texture_refresh_conflict.keep_theirs": "โหลดไฟล์และละทิ้งการเปลี่ยนแปลงและเลเยอร์ทั้งหมดใน Blockbench",
	"message.group_required_to_animate": "คุณไม่สามารถทำแอนิเมชันองค์ประกอบประเภทนี้ได้ สร้างกลุ่มหรืออาร์มาเจอร์เพื่อทำแอนิเมชัน",
	"dialog.texture.uv_size": "ขนาด UV",
	"dialog.advanced_screenshot.angle_preset": "พรีเซ็ตมุม",
	"dialog.advanced_screenshot.resolution": "ความละเอียด",
	"dialog.advanced_screenshot.zoom_to_fit": "ซูมให้พอดี",
	"dialog.advanced_screenshot.zoom": "ซูม / ความยาวโฟกัส",
	"dialog.advanced_screenshot.anti_aliasing": "แอนติอาเลียสซิง",
	"dialog.advanced_screenshot.anti_aliasing.off": "ปิด",
	"dialog.advanced_screenshot.anti_aliasing.msaa": "มัลติแซมปลิง",
	"dialog.advanced_screenshot.anti_aliasing.ssaa": "ซูเปอร์แซมปลิง",
	"dialog.advanced_screenshot.show_gizmos": "แสดงกิซโมแก้ไข",
	"dialog.advanced_screenshot.shading": "การแรเงา",
	"settings.auto_keyframe": "สร้างคีย์เฟรมอัตโนมัติ",
	"settings.auto_keyframe.desc": "สร้างคีย์เฟรมโดยอัตโนมัติเมื่อแปลงองค์ประกอบ",
	"settings.modded_entity_integer_size": "ขนาดจำนวนเต็มเอนทิตีม็อด",
	"settings.modded_entity_integer_size.desc": "จำกัดขนาดคิวบ์ในรูปแบบเอนทิตีม็อดเป็นจำนวนเต็ม แม้ว่าเลขทศมิติได้รับการรองรับในบางเวอร์ชัน จำนวนเต็มง่ายต่อการแมป UV กว่ามาก",
	"category.layers": "เลเยอร์",
	"keybind.paint_secondary_color": "วาดด้วยสีรอง",
	"action.selection_tool_operation_mode": "โหมดการทำงานเครื่องมือเลือก",
	"action.selection_tool_operation_mode.create": "เลือกใหม่",
	"action.selection_tool_operation_mode.add": "เพิ่มในส่วนที่เลือก",
	"action.selection_tool_operation_mode.subtract": "ลบออกจากส่วนที่เลือก",
	"action.selection_tool_operation_mode.intersect": "ตัดกัน",
	"action.pixel_perfect_drawing": "การวาดพิกเซลเพอร์เฟกต์",
	"action.pixel_perfect_drawing.desc": "วาดเส้นพิกเซลอาร์ตเรียบโดยไม่มีพิกเซลซ้ำที่โค้ง",
	"action.selection_tool": "เครื่องมือเลือก",
	"action.selection_tool.desc": "เลือกพื้นที่บนเทกซ์เจอร์",
	"action.selection_tool.rectangle": "สี่เหลี่ยม",
	"action.selection_tool.ellipse": "วงรี",
	"action.selection_tool.lasso": "ลาสโซ",
	"action.selection_tool.wand": "ไม้กายสิทธิ์",
	"action.selection_tool.color": "สีเดียวกัน",
	"action.move_layer_tool": "ย้ายเลเยอร์",
	"action.move_layer_tool.desc": "ย้ายเลเยอร์หรือส่วนที่เลือกปัจจุบัน",
	"action.export_modded_animations": "ส่งออกแอนิเมชันเอนทิตีม็อด",
	"action.export_modded_animations.desc": "ส่งออกแอนิเมชันสำหรับโมเดลเอนทิตีม็อด Minecraft Java Edition",
	"action.swap_colors": "สลับสี",
	"action.swap_colors.desc": "สลับสีหลักกับสีรอง",
	"action.apply_mesh_rotation": "ใช้การหมุน",
	"action.apply_mesh_rotation.desc": "รีเซ็ตการหมุนองค์ประกอบของเมช และใช้กับเรขาคณิตแทน",
	"action.flip_texture_x.desc": "พลิกเทกซ์เจอร์หรือเลเยอร์แนวนอน",
	"action.flip_texture_y.desc": "พลิกเทกซ์เจอร์หรือเลเยอร์แนวตั้ง",
	"action.rotate_texture_cw.desc": "หมุนเทกซ์เจอร์หรือเลเยอร์ตามเข็มนาฬิกา",
	"action.rotate_texture_ccw.desc": "หมุนเทกซ์เจอร์หรือเลเยอร์ทวนเข็มนาฬิกา",
	"action.crop_texture_to_selection": "ครอบเทกซ์เจอร์ตามที่เลือก",
	"action.create_empty_layer": "สร้างเลเยอร์เปล่า",
	"action.enable_texture_layers": "เปิดใช้เลเยอร์",
	"action.disable_texture_layers": "ปิดใช้เลเยอร์",
	"action.layer_opacity": "ความทึบเลเยอร์",
	"action.layer_to_texture_size": "ขยายเลเยอร์ให้เท่าขนาดเทกซ์เจอร์",
	"action.layer_to_texture_size.desc": "ขยายเลเยอร์ให้เท่าขนาดของเทกซ์เจอร์",
	"action.merge_layer_down": "ผสานลงด้านล่าง",
	"action.merge_layer_down.desc": "ผสานเข้ากับเลเยอร์ด้านล่าง",
	"action.advanced_screenshot": "ภาพหน้าจอขั้นสูง...",
	"action.advanced_screenshot.desc": "ถ่ายภาพหน้าจอของโมเดลด้วยตัวเลือกขั้นสูง",
	"action.bake_ik_animation": "เบค Inverse Kinematics",
	"action.bake_ik_animation.desc": "เบคการหมุนที่ใช้โดย inverse kinematics ลงในแอนิเมชันที่เลือก",
	"action.save_animation_preset": "บันทึกพรีเซ็ตแอนิเมชัน...",
	"action.save_animation_preset.desc": "บันทึกคีย์เฟรมที่เลือกเป็นพรีเซ็ตแอนิเมชัน",
	"action.animation_onion_skin": "ออเนียนสกินแอนิเมชัน",
	"action.animation_onion_skin.desc": "แสดงมุมมองโครงลวดของเฟรมอื่นในแอนิเมชันเพื่ออ้างอิง",
	"action.apply_animation_preset": "ใช้พรีเซ็ตแอนิเมชัน",
	"action.apply_animation_preset.desc": "เลือกจากรายการพรีเซ็ตแอนิเมชันและใช้กับกระดูกที่เลือก",
	"menu.brush_presets.pixel_perfect": "แปรงพิกเซลเพอร์เฟกต์",
	"panel.layers": "เลเยอร์",
	"uv_editor.copy_paste_tool.to_layer": "ไปยังเลเยอร์ใหม่",
	"format.image.new": "สร้างรูปภาพใหม่",
	"format.image.info.summary": "ตัวแก้ไขรูปภาพ 2D ช่วยให้คุณสร้างและแก้ไขรูปภาพและพิกเซลอาร์ตได้โดยตรงใน Blockbench โดยไม่ต้องใช้ตัวแก้ไขรูปภาพภายนอก แก้ไขรูปภาพ ปรับเปลี่ยนเทกซ์เจอร์ หรือสร้างพิกเซลอาร์ตของคุณเอง!",
	"settings.move_with_selection_tool": "ใช้เครื่องมือเลือกเพื่อย้ายส่วนที่เลือก",
	"settings.move_with_selection_tool.desc": "อนุญาตให้เครื่องมือเลือกย้ายส่วนที่เลือกโดยตรง โดยไม่ต้องสลับไปยังเครื่องมือย้ายเลเยอร์",
	"settings.final_newline": "บรรทัดใหม่สุดท้าย",
	"settings.final_newline.desc": "แทรกอักขระบรรทัดใหม่ที่ท้ายไฟล์ที่ส่งออก",
	"action.crop_layer_to_selection": "ครอบเลเยอร์ตามที่เลือก",
	"action.edit_mode_uv_overlay.desc": "แสดงการซ้อนแผนที่ UV สำหรับองค์ประกอบทั้งหมดในโหมดแก้ไข",
	"menu.image": "รูปภาพ",
	"menu.texture.discard_changes": "ละทิ้งการเปลี่ยนแปลง",
	"menu.texture.discard_changes.desc": "ละทิ้งการเปลี่ยนแปลงที่ยังไม่ได้บันทึกทั้งหมดและโหลดเวอร์ชันล่าสุดจากไฟล์",
	"panel.textures.images": "รูปภาพ",
	"dialog.advanced": "ขั้นสูง",
	"dialog.recommended_option": "แนะนำ",
	"modifier_actions.snap_to_center": "จับยึดไปยังศูนย์กลาง",
	"modifier_actions.snap_to_pixels": "จับยึดไปยังพิกเซล",
	"message.invalid_format.install_plugin": "ติดตั้งปลั๊กอิน '%0'",
	"message.plugin_deprecated.message": "คุณแน่ใจหรือไม่ว่าต้องการติดตั้งปลั๊กอินที่เลิกใช้แล้วนี้?",
	"message.plugin_deprecated.install_anyway": "ติดตั้งต่อไป",
	"message.image_editor.not_found": "ไม่พบตัวแก้ไขรูปภาพที่เลือก กรุณาเลือกตัวเลือกอื่น",
	"message.knife_tool.confirm": "กด %0 หรือคลิกที่นี่เพื่อใช้ Knife Tool",
	"message.knife_tool.skipped_face": "ไม่สามารถตัดระหว่างหน้าต่างๆ ได้ รวมขอบหรือจุดยอดระหว่างนั้นด้วย!",
	"message.optimize_animation.keyframes_removed": "ลบคีย์เฟรมซ้ำ %0 อันแล้ว",
	"message.optimize_animation.nothing_to_optimize": "ไม่พบสิ่งที่ต้องเพิ่มประสิทธิภาพ!",
	"message.duplicate_bone_copy_animation.title": "คัดลอกแอนิเมชัน",
	"message.duplicate_bone_copy_animation.message": "กระดูกที่ทำซ้ำมีแอนิเมชันใน %0 แอนิเมชัน คุณต้องการคัดลอกคีย์เฟรมไปยังกระดูกใหม่หรือไม่?",
	"message.auto_fix_mesh_edit.title": "แก้ไขอัตโนมัติ",
	"message.auto_fix_mesh_edit.revert": "ย้อนกลับการแก้ไข",
	"message.auto_fix_mesh_edit.overlapping_vertices": "จุดยอดบางจุดถูกย้ายไปยังตำแหน่งเดียวกัน คุณต้องการดำเนินการอย่างไร?",
	"message.auto_fix_mesh_edit.concave_quads": "หน้าควอดอย่างน้อยหนึ่งหน้าเป็นรูปเว้า ซึ่งอาจทำให้เกิดปัญหาในการแมป UV และการเรนเดอร์ Blockbench สามารถแก้ไขให้คุณโดยอัตโนมัติ:",
	"message.auto_fix_mesh_edit.merge_vertices": "ผสานจุดยอด",
	"message.auto_fix_mesh_edit.split_quads": "แยกควอด",
	"message.load_images.add_image": "เพิ่มรูปภาพ",
	"dialog.project.modded_entity_entity_class": "คลาสเอนทิตี",
	"dialog.resize_texture.offset": "ออฟเซ็ต",
	"dialog.animated_texture_editor.code_reference": "อ้างอิงโค้ด",
	"dialog.animated_texture_editor.code_reference.about": "โค้ดนี้สร้างขึ้นเพื่อใช้เป็นข้อมูลอ้างอิงสำหรับการทำแอนิเมชันเทกซ์เจอร์ และอาจไม่สามารถใช้งานได้โดยไม่มีการแก้ไข ดูเอกสารประกอบเพื่อเรียนรู้เพิ่มเติม",
	"dialog.animated_texture_editor.code_reference.docs": "เอกสารประกอบ",
	"dialog.animated_texture_editor.reframe": "จัดเฟรมใหม่",
	"dialog.animated_texture_editor.stride": "ขนาดเฟรม",
	"dialog.animated_texture_editor.frames": "จำนวนเฟรม",
	"dialog.animated_texture_editor.add_frame": "เพิ่มเฟรม",
	"dialog.animated_texture_editor.resize_frames": "ปรับขนาดเฟรม...",
	"dialog.animated_texture_editor.apply": "ใช้",
	"dialog.add_primitive.edge_size": "ขนาดขอบ",
	"dialog.change_animation_speed.speed": "ความเร็ว",
	"dialog.change_animation_speed.adjust_snapping": "ปรับการจับยึด",
	"dialog.optimize_animation.selection": "ส่วนที่เลือก",
	"dialog.optimize_animation.selection.selected_keyframes": "คีย์เฟรมที่เลือก",
	"dialog.optimize_animation.selection.selected_animation": "แอนิเมชันที่เลือก",
	"dialog.optimize_animation.selection.all_animations": "แอนิเมชันทั้งหมด",
	"dialog.optimize_animation.thresholds": "ค่าขีดจำกัด",
	"dialog.import_obj.obj": "ไฟล์ OBJ",
	"dialog.import_obj.mtl": "ไฟล์ MTL",
	"dialog.import_obj.scale": "มาตราส่วน",
	"layout.thumbnail": "CSS ภาพปกกำหนดเอง",
	"settings.pixel_grid": "กริดพิกเซล",
	"settings.pixel_grid.desc": "แสดงกริดพิกเซลเทกซ์เจอร์บนองค์ประกอบในโหมดแก้ไข",
	"settings.image_editor_grid_size": "ขนาดกริดตัวแก้ไขรูปภาพ",
	"settings.image_editor_grid_size.desc": "ขนาดของกริดใหญ่ในตัวแก้ไขรูปภาพ 2D",
	"settings.ground_plane_double_side": "ระนาบพื้นสองด้าน",
	"settings.ground_plane_double_side.desc": "ทำให้ระนาบพื้นมองเห็นได้จากด้านล่าง",
	"settings.optifine_save_default_texture": "OptiFine JEM: ส่งออกเทกซ์เจอร์ที่เลือก",
	"settings.optifine_save_default_texture.desc": "ส่งออกเทกซ์เจอร์ที่เลือกเป็นเทกซ์เจอร์เริ่มต้นของโมเดล",
	"action.slider_color_select_threshold": "ขีดจำกัดการเลือกสี",
	"action.slider_color_select_threshold.desc": "สีของพิกเซลข้างเคียงต้องใกล้เคียงเพียงใดจึงจะถูกเลือกโดยการเลือกสีหรือไม้กายสิทธิ์",
	"action.stretch_tool": "ยืด",
	"action.stretch_tool.desc": "เครื่องมือเลือกและยืดองค์ประกอบ",
	"action.knife_tool": "เครื่องมือมีด",
	"action.knife_tool.desc": "ตัดขอบเมชด้วยมีด",
	"action.duplicate_project": "ทำสำเนาโปรเจกต์",
	"action.duplicate_project.desc": "สร้างสำเนาของโปรเจกต์ที่เปิดอยู่",
	"action.transform_space.parent": "พาเรนต์",
	"action.transform_pivot_space": "พื้นที่เปลี่ยนจุดหมุน",
	"action.solidify_mesh_selection": "เพิ่มความหนา",
	"action.solidify_mesh_selection.desc": "ทำให้เมชที่เลือกหนาขึ้น",
	"action.animated_texture_editor": "ตัวแก้ไขฟลิปบุ๊ค...",
	"action.animated_texture_editor.desc": "แก้ไขแอนิเมชันฟลิปบุ๊คของเทกซ์เจอร์ที่เลือก",
	"action.center_individual_pivots": "จัดกึ่งกลางจุดหมุนแต่ละอัน",
	"action.center_individual_pivots.desc": "ตั้งจุดหมุนของแต่ละองค์ประกอบที่เลือกไปยังศูนย์กลางของมัน",
	"action.uv_cycle": "หมุน UV",
	"action.uv_cycle.desc": "หมุนลำดับจุดยอด UV โดยไม่เปลี่ยนตำแหน่ง UV",
	"action.uv_cycle_invert": "กลับลำดับ UV",
	"action.uv_cycle_invert.desc": "กลับลำดับจุดยอด UV โดยไม่เปลี่ยนตำแหน่ง UV",
	"action.slider_animation_controller_speed": "ความเร็วเล่นคอนโทรลเลอร์",
	"action.slider_animation_controller_speed.desc": "ความเร็วเล่นของคอนโทรลเลอร์แอนิเมชันเป็นเปอร์เซ็นต์",
	"action.optimize_animation": "เพิ่มประสิทธิภาพแอนิเมชัน",
	"action.optimize_animation.desc": "ลบคีย์เฟรมที่ไม่จำเป็น",
	"action.change_animation_speed": "เปลี่ยนความเร็วแอนิเมชัน",
	"action.change_animation_speed.desc": "เปลี่ยนความเร็วของแอนิเมชัน",
	"timeline.select_particle_file": "เลือกไฟล์อนุภาค",
	"timeline.select_sound_file": "เลือกไฟล์เสียง",
	"menu.cube.texture.default": "ค่าเริ่มต้น",
	"menu.texture.particle.clear": "หยุดใช้สำหรับอนุภาค",
	"menu.texture.use_as_default": "ตั้งเป็นค่าเริ่มต้น",
	"menu.texture.use_as_default.clear": "ยกเลิกตั้งเป็นค่าเริ่มต้น",
	"menu.toolbar.overflow": "แถบเครื่องมือล้น",
	"edit.solidify_mesh_selection.thickness": "ความหนา",
	"reference_image.sync_to_timeline": "ซิงค์กับไทม์ไลน์",
	"reference_image.toggle_playback": "เล่น/หยุดชั่วคราว",
	"dialog.add_primitive.shape.beveled_cuboid": "ทรงสี่เหลี่ยมมุมฉากเอียง",
	"dialog.ignore_all": "เพิกเฉยทั้งหมด",
	"data.texture_group": "กลุ่มเทกซ์เจอร์",
	"data.animation": "แอนิเมชัน",
	"generic.on": "เปิด",
	"generic.off": "ปิด",
	"format.free.info.3d_printing": "พิมพ์ 3D",
	"message.invalid_file.merge_conflict": "ไฟล์มีข้อขัดแย้ง Git merge ที่ยังไม่ได้แก้ไข",
	"dialog.expand_texture_selection.radius": "จำนวน",
	"dialog.expand_texture_selection.corner": "รูปร่างมุม",
	"dialog.expand_texture_selection.corner.round": "มน",
	"dialog.expand_texture_selection.corner.square": "สี่เหลี่ยม",
	"dialog.expand_texture_selection.corner.manhattan": "แมนฮัตตัน",
	"dialog.merge_animation.merge_target": "ผสานเข้าสู่",
	"keybindings.variation_conflict": "ตัวแปรขัดแย้งกับแป้นพิมพ์ลัดหลัก",
	"settings.recovery_save_interval": "ช่วงเวลาบันทึกกู้คืน",
	"settings.recovery_save_interval.desc": "ระยะเวลาระหว่างการบันทึกจุดกู้คืนอัตโนมัติ",
	"settings.save_view_per_tab": "บันทึกมุมมองต่อแท็บ",
	"settings.save_view_per_tab.desc": "บันทึกมุมมองปัจจุบันแยกสำหรับแต่ละแท็บ",
	"settings.inherit_parent_color": "สืบทอดสีพาเรนต์",
	"settings.inherit_parent_color.desc": "ตั้งสีเครื่องหมายขององค์ประกอบที่สร้างใหม่เป็นสีของพาเรนต์แทนสีสุ่ม",
	"keybind.preview_select.multi_select": "เลือกหลายรายการ",
	"keybind.preview_select.group_select": "เลือกกลุ่ม",
	"keybind.preview_select.loop_select": "เลือกแบบวน",
	"action.fill_mode.selection": "ส่วนที่เลือก",
	"action.fill_mode.selected_elements": "องค์ประกอบที่เลือก",
	"action.image_tiled_view": "มุมมองเรียงต่อกัน",
	"action.image_tiled_view.description": "เปิดใช้มุมมองเรียงต่อกันในตัวแก้ไข 2D",
	"action.image_onion_skin_view": "ออเนียนสกินตัวแก้ไขรูปภาพ",
	"action.image_onion_skin_view.description": "เปิดใช้มุมมองออเนียนสกินในตัวแก้ไข 2D",
	"action.expand_texture_selection": "ขยายการเลือกเทกซ์เจอร์",
	"action.expand_texture_selection.desc": "ขยายหรือย่อการเลือกเทกซ์เจอร์",
	"action.switch_tabs.reverse_order": "ย้อนลำดับ",
	"action.save_project_incremental": "บันทึกโปรเจกต์เลขเพิ่ม",
	"action.save_project_incremental.desc": "บันทึกโมเดลปัจจุบันเป็นไฟล์โปรเจกต์พร้อมเลขเพิ่ม (เช่น project_2.bbmodel)",
	"action.copy.multiple": "คัดลอกทั้งหมด",
	"action.copy.multiple.desc": "คัดลอกข้อมูลที่มีทั้งหมดแยกกัน",
	"action.paste.multiple": "วางทั้งหมด",
	"action.randomize_marker_colors": "สุ่มสีเครื่องหมาย",
	"action.cube_light_emission": "การปล่อยแสง",
	"action.cube_light_emission.desc": "เปลี่ยนการปล่อยแสงของคิวบ์ที่เลือก เป็นค่าระหว่าง 0 ถึง 15",
	"action.view_mode.colored_solid": "ทึบพร้อมสีเครื่องหมาย",
	"action.focus_on_selection.rotate_only": "หมุนเท่านั้น",
	"action.create_texture_group": "สร้างกลุ่มเทกซ์เจอร์",
	"action.create_texture_group.desc": "สร้างกลุ่มสำหรับเทกซ์เจอร์ของคุณ",
	"action.uv_maximize.all_faces": "มีผลกับหน้าทั้งหมด",
	"action.retarget_animators": "กำหนดเป้าหมายแอนิเมชันใหม่",
	"action.retarget_animators.desc": "เลือกว่าแอนิเมเตอร์เป้าหมายกระดูกหรือองค์ประกอบใด",
	"action.merge_animation": "ผสานแอนิเมชัน",
	"action.merge_animation.desc": "ผสานแอนิเมชันเข้าด้วยกัน",
	"action.add_keyframe.reset_values": "ด้วยค่าเริ่มต้น",
	"action.set_timeline_range_start": "ตั้งจุดเริ่มช่วงไทม์ไลน์",
	"action.set_timeline_range_start.desc": "ตั้งจุดเริ่มต้นสำหรับช่วงเล่นกำหนดเองในไทม์ไลน์แอนิเมชัน",
	"action.set_timeline_range_end": "ตั้งจุดสิ้นสุดช่วงไทม์ไลน์",
	"action.set_timeline_range_end.desc": "ตั้งจุดสิ้นสุดสำหรับช่วงเล่นกำหนดเองในไทม์ไลน์แอนิเมชัน",
	"action.disable_timeline_range": "ปิดใช้ช่วงไทม์ไลน์",
	"action.disable_timeline_range.desc": "ปิดใช้ช่วงเล่นกำหนดเองในไทม์ไลน์แอนิเมชัน",
	"menu.texture_group.resolve": "ยุบ",
	"menu.image_tiled_view.mirrored": "ขอบสะท้อน",
	"menu.image_onion_skin_view.frame": "เฟรม",
	"menu.image_onion_skin_view.frame.last_viewed": "เฟรมที่ดูล่าสุด",
	"menu.image_onion_skin_view.frame.previous": "เฟรมก่อนหน้า",
	"menu.image_onion_skin_view.frame.next": "เฟรมถัดไป",
	"menu.image_onion_skin_view.frame.both": "ก่อนหน้า + ถัดไป",
	"menu.image_onion_skin_view.display": "การแสดงผล",
	"menu.image_onion_skin_view.display.pixels": "พิกเซลเล็กลง",
	"menu.image_onion_skin_view.display.transparent": "โปร่งใส",
	"menu.image_onion_skin_view.above": "แสดงด้านบน",
	"menu.animation.reload": "โหลดใหม่",
	"switches.autouv.alt": "สัมพัทธ์",
	"display.rotation_pivot": "จุดหมุนการหมุน",
	"display.scale_pivot": "จุดหมุนมาตราส่วน",
	"display.reference.fox": "สุนัขจิ้งจอก",
	"display.reference.eating": "กำลังกิน",
	"preview_scene.sky": "ท้องฟ้า",
	"preview_scene.space": "อวกาศ",
	"preview_scene.minecraft_ocean": "มหาสมุทร",
	"message.import_palette.selection_only": "เฉพาะที่เลือก",
	"dialog.blend_transition_edit.ease_in_out": "เข้า-ออก (%0)",
	"dialog.blend_transition_edit.generate": "สร้าง...",
	"dialog.blend_transition_edit.generate.learn_more": "ข้อมูลเพิ่มเติมและตัวอย่าง",
	"dialog.blend_transition_edit.generate.curve": "ประเภท Easing",
	"dialog.blend_transition_edit.generate.steps": "คีย์เฟรม",
	"settings.fps_limit": "ขีดจำกัด FPS",
	"settings.fps_limit.desc": "จำกัดจำนวนเฟรมต่อวินาทีที่ Blockbench เรนเดอร์ อัตราเฟรมจริงจำกัดตามที่อุปกรณ์ของคุณแสดงได้",
	"settings.outliner_reveal_on_select": "เปิดเผยองค์ประกอบเมื่อเลือก",
	"settings.outliner_reveal_on_select.desc": "เปิดเผยองค์ประกอบในเอาต์ไลเนอร์เมื่อถูกเลือก",
	"settings.java_export_pivots": "ส่งออกจุดหมุนในโมเดลบล็อก/ไอเทม Java",
	"settings.java_export_pivots.desc": "บันทึกจุดหมุนในโมเดลบล็อก/ไอเทม Java บนคิวบ์ที่ไม่มีการหมุน",
	"animation_controllers.state.blend_transition_curve": "เส้นโค้งทรานซิชันผสม",
	"menu.slider.reset_vector": "รีเซ็ตเวกเตอร์",
	"dialog.blend_transition_edit.extended": "กราฟขยาย",
	"message.screenshot_too_large.title": "ปัญหาความละเอียดภาพหน้าจอ",
	"message.screenshot_too_large.message": "ไม่สามารถเรนเดอร์ภาพหน้าจอได้สำเร็จ กรุณาลองอีกครั้งด้วยความละเอียดที่ต่ำลงหรือไม่ใช้ซูเปอร์แซมปลิง",
	"message.rename_elements.numbering": "คุณสามารถใช้อักขระพิเศษเพื่อสร้างตัวเลขลำดับ: % เพื่อรับดัชนีขององค์ประกอบในกลุ่ม, $ เพื่อรับดัชนีภายในส่วนที่เลือก",
	"generic.edit_externally": "แก้ไขภายนอก",
	"message.settings_require_restart.title": "ต้องรีสตาร์ท",
	"message.settings_require_restart.message": "การตั้งค่าบางอย่างจะมีผลหลังจากรีสตาร์ทโปรแกรม",
	"message.settings_require_restart.restart_now": "รีสตาร์ทเดี๋ยวนี้",
	"message.settings_require_restart.restart_later": "รีสตาร์ทภายหลัง",
	"message.classroom_mode.install_plugin": "ไม่สามารถติดตั้งปลั๊กอินในโหมดห้องเรียน",
	"dialog.collection.export_path": "เส้นทางส่งออก",
	"dialog.collection.select_all": "เลือกทั้งหมด",
	"dialog.collection.select_none": "ยกเลิกเลือกทั้งหมด",
	"dialog.collection.add_with_filter": "เพิ่มด้วยตัวกรอง",
	"dialog.collection.remove": "ลบออก",
	"dialog.material_config.title": "การตั้งค่าวัสดุ",
	"dialog.material_config.color_value": "ค่าสี",
	"dialog.material_config.mer": "โลหะ-เรืองแสง-ความหยาบ",
	"dialog.material_config.mer_value": "ค่า MER",
	"dialog.material_config.depth_type": "ประเภทความลึก",
	"dialog.create_texture.disable_mirror_uv": "ปิดใช้งานการสะท้อน UV",
	"dialog.create_texture.disable_mirror_uv.desc": "ปิดใช้งานตัวเลือกสะท้อน UV ใน Mirror Modeling เพื่อรักษา UV แยกสำหรับแต่ละด้านของโมเดล",
	"dialog.create_gif.turn.sync_to_anim_length": "ซิงค์กับความยาวแอนิเมชัน",
	"settings.category.controls": "การควบคุม",
	"settings.classroom_mode": "โหมดห้องเรียน",
	"settings.classroom_mode.desc": "จำกัดฟังก์ชันบางอย่าง เช่น การติดตั้งปลั๊กอิน และลบลิงก์ไปยังโซเชียลมีเดีย",
	"settings.antialiasing_bleed_fix": "แก้ไขสีล้นของแอนติอาเลียสซิง",
	"settings.antialiasing_bleed_fix.desc": "แก้ไขสีล้นของเทกซ์เจอร์เมื่อใช้แอนติอาเลียสซิง อาจไม่รองรับบนฮาร์ดแวร์เก่า",
	"settings.tone_mapping": "โทนแมปปิง",
	"settings.tone_mapping.desc": "วิธีการประมาณค่าสำหรับแสดงช่วงไดนามิกสูงบนหน้าจอมาตรฐานสำหรับการเรนเดอร์ PBR",
	"settings.audio_scrubbing": "เสียงเลื่อนไทม์ไลน์",
	"settings.audio_scrubbing.desc": "เล่นตัวอย่างสั้นของเสียงขณะเลื่อนผ่านไทม์ไลน์",
	"settings.viewport_rotate_speed": "ความเร็วการหมุนวิวพอร์ต",
	"settings.viewport_rotate_speed.desc": "ความไวของอินพุตเมื่อหมุนในวิวพอร์ต",
	"settings.viewport_zoom_speed": "ความเร็วการซูมวิวพอร์ต",
	"settings.viewport_zoom_speed.desc": "ความไวของอินพุตเมื่อซูมในวิวพอร์ต",
	"settings.editor_2d_zoom_speed": "ความเร็วการซูมตัวแก้ไข 2D",
	"settings.editor_2d_zoom_speed.desc": "ความไวของอินพุตเมื่อซูมในตัวแก้ไข UV และวาด 2D",
	"category.select": "เลือก",
	"action.vertex_snap_mode.rotate": "หมุน",
	"action.export_image": "ส่งออกรูปภาพ",
	"action.export_image.desc": "ส่งออกเทกซ์เจอร์เป็นไฟล์รูปภาพ",
	"action.apply_mirror_modeling": "ใช้ Mirror Modeling",
	"action.apply_mirror_modeling.desc": "ใช้ Mirror Modeling กับส่วนที่เลือก องค์ประกอบที่เลือกทั้งหมดจะถูกคัดลอกและพลิกข้ามแกน X",
	"action.create_collection": "สร้างคอลเลกชัน",
	"action.create_collection.desc": "สร้างคอลเลกชันจากส่วนที่เลือกในเอาต์ไลเนอร์",
	"action.set_collection_content_to_selection": "ตั้งเนื้อหาคอลเลกชันตามที่เลือก",
	"action.set_collection_content_to_selection.desc": "ตั้งกลุ่มและองค์ประกอบที่เลือกเป็นเนื้อหาของคอลเลกชัน",
	"action.add_to_collection": "เพิ่มที่เลือกในคอลเลกชัน",
	"action.add_to_collection.desc": "เพิ่มกลุ่มและองค์ประกอบที่เลือกในคอลเลกชัน",
	"action.view_mode.material": "ตัวอย่างวัสดุ",
	"action.create_material": "สร้างวัสดุ",
	"action.create_material.desc": "สร้างวัสดุ PBR ใหม่จากเทกซ์เจอร์ที่เลือก",
	"action.generate_pbr_map": "สร้างแผนที่ PBR...",
	"action.generate_pbr_map.desc": "สร้างแผนที่ PBR (แผนที่ความสูงหรือโลหะ เรืองแสง ความหยาบ) จากเทกซ์เจอร์ที่มีอยู่",
	"menu.tools.main_tools": "กล่องเครื่องมือ",
	"menu.view.panels": "แผง",
	"menu.texture.pbr_channel": "ช่อง PBR",
	"menu.texture.pbr_channel.color": "สี",
	"menu.texture.pbr_channel.normal": "ปกติ",
	"menu.texture.pbr_channel.height": "ความสูง",
	"menu.texture.pbr_channel.mer": "MER (โลหะ-เรืองแสง-ความหยาบ)",
	"menu.texture.pbr_channel.mer_subsurface": "MER ใต้ผิว",
	"menu.collection.export_project": "ส่งออกโปรเจกต์",
	"menu.collection.export_as": "ส่งออกเป็น \"%0\"",
	"menu.panel.enable": "เปิดใช้",
	"menu.panel.move_to": "ย้ายไปยัง",
	"menu.panel.move_to.left_bar": "แถบข้างซ้าย",
	"menu.panel.move_to.right_bar": "แถบข้างขวา",
	"menu.panel.move_to.top": "ด้านบน",
	"menu.panel.move_to.bottom": "ด้านล่าง",
	"menu.panel.move_to.float": "ลอย",
	"menu.panel.move_to.hidden": "ซ่อน",
	"menu.panel.fold": "ยุบ",
	"menu.mirror_painting.texture_center": "จุดกำเนิด",
	"menu.mirror_modeling.mirror_uv": "สะท้อน UV",
	"menu.animation_onion_skin.frames": "เฟรม",
	"menu.animation_onion_skin.select": "เลือก",
	"menu.animation_onion_skin.previous": "ก่อนหน้า",
	"menu.animation_onion_skin.next": "ถัดไป",
	"menu.animation_onion_skin.previous_next": "ก่อนหน้า + ถัดไป",
	"menu.animation_onion_skin.count": "จำนวน",
	"menu.animation_onion_skin.interval": "ช่วง",
	"menu.animation_onion_skin_selective": "ออเนียนสกินเลือก",
	"menu.animation_onion_skin_selective.desc": "แสดงออเนียนสกินเฉพาะส่วนที่เลือกของโมเดล",
	"edit.loop_cut.unit": "หน่วย",
	"edit.loop_cut.unit.size_units": "หน่วยขนาด",
	"edit.loop_cut.unit.percent": "เปอร์เซ็นต์",
	"edit.extrude_mesh_selection.direction": "ทิศทาง",
	"edit.extrude_mesh_selection.direction.outwards": "ออกด้านนอก",
	"edit.extrude_mesh_selection.direction.average": "เฉลี่ย",
	"edit.extrude_mesh_selection.even_extend": "ขยายเท่าๆ กัน",
	"edit.vertex_snap.align": "จัดเรียง",
	"edit.vertex_snap.align.longest": "แกนที่ยาวที่สุด",
	"edit.vertex_snap.align.direction": "ทิศทางจากจุดหมุน",
	"edit.vertex_snap.align.align_axis": "แกน %0",
	"edit.vertex_snap.ignore_axis": "เพิกเฉยแกน",
	"codec.common.format": "รูปแบบ",
	"codec.image.quality": "คุณภาพ",
	"panel.collections": "คอลเลกชัน",
	"modifier_actions.always": "เปิดใช้งานเสมอ",
	"modifier_actions.unless": "ยกเว้น %0",
	"settings.undo_selections": "เลิกทำการเลือก",
	"settings.undo_selections.desc": "ติดตามการเปลี่ยนแปลงการเลือกเป็นขั้นตอนในประวัติการเลิกทำ",
	"action.focus_on_selection.zoom": "ซูมให้พอดี",
	"display.reference.tooting": "เป่าแตร",
	"settings.selection_tolerance": "ความทนทานการเลือก",
	"settings.selection_tolerance.desc": "ขนาดของพื้นที่ที่สามารถคลิกเพื่อเลือกขอบหรือจุดยอด",
	"action.delete.keep_vertices": "คงขอบ/จุดยอด",
	"menu.mesh": "เมช",
	"dialog.material_config.subsurface": "การกระเจิงใต้ผิว",
	"dialog.material_config.subsurface_enabled.desc": "ใช้ช่องอัลฟาของแผนที่ MER สำหรับการกระเจิงใต้ผิว",
	"settings.pick_combined_color": "เลือกสีรวม",
	"settings.pick_combined_color.desc": "เลือกสีรวมของทุกเลเยอร์ที่พิกเซลนั้น แทนที่จะเป็นสีบนเลเยอร์ที่ใช้งานอยู่",
	"action.split_rgb_into_layers": "แยกช่อง RGBA เป็นเลเยอร์",
	"action.split_rgb_into_layers.desc": "แยกเทกซ์เจอร์เป็นเลเยอร์เพิ่ม หนึ่งสำหรับแต่ละช่อง RGBA",
	"dialog.project.java_block_version": "เวอร์ชันรูปแบบ",
	"data.spline_mesh": "สไปลน์",
	"data.billboard": "บิลบอร์ด",
	"data.armature": "อาร์มาเจอร์",
	"data.armature_bone": "กระดูกอาร์มาเจอร์",
	"generic.reload": "โหลดใหม่",
	"modifier_actions.subtract": "ลบออก",
	"modifier_actions.reduced_intensity": "ปรับละเอียด",
	"modifier_actions.select_bone": "เลือกกระดูก",
	"modifier_actions.spline_select_multiple_points": "เลือกหลายจุดหรือแฮนเดิล",
	"modifier_actions.move_panel_without_docking": "ย้ายโดยไม่ตรึง",
	"message.save_all_textures.message": "คุณต้องการบันทึกเทกซ์เจอร์แต่ละอันต่อไปนี้หรือไม่?",
	"message.save_all_textures.skip": "ข้าม",
	"dialog.add_spline.shape": "รูปทรง",
	"dialog.add_spline.shape.segment": "ส่วน",
	"dialog.add_spline.shape.square": "สี่เหลี่ยมผืนผ้า",
	"dialog.add_spline.shape.circle": "วงกลม",
	"dialog.add_spline.diameter": "เส้นผ่านศูนย์กลาง",
	"dialog.add_spline.sides_tubular": "ส่วนท่อ",
	"dialog.add_spline.sides_radial": "ส่วนวงแหวน",
	"dialog.add_spline.radius": "รัศมีท่อ",
	"dialog.add_spline.length": "ความยาว",
	"dialog.add_spline.width": "ความกว้าง",
	"dialog.plugins.revoke_permissions": "เพิกถอนสิทธิ์",
	"dialog.expression_editor.pretty_print": "พริตตี้พรินต์",
	"dialog.expression_editor.minify": "ย่อให้เล็กสุด",
	"dialog.expression_editor.find_replace": "ค้นหา/แทนที่",
	"dialog.create_gif.show_gizmos": "บันทึกกิซโมและกริด",
	"dialog.preview_options.title": "ตัวเลือกตัวอย่าง",
	"dialog.preview_options.background": "พื้นหลัง",
	"dialog.preview_options.background.checkerboard": "ตารางหมากรุก",
	"dialog.preview_options.background.solid": "ทึบ",
	"dialog.preview_options.background.custom_color": "สีกำหนดเอง",
	"dialog.preview_options.show_gizmos": "แสดงกิซโม",
	"dialog.skin.texture_source": "แหล่งเทกซ์เจอร์",
	"dialog.skin.texture_source.template": "สร้างเทมเพลต",
	"dialog.skin.texture_source.load_texture": "โหลดจาก Minecraft",
	"dialog.skin.texture_file": "ไฟล์เทกซ์เจอร์",
	"dialog.convert_skin.adjust_texture": "ปรับเทกซ์เจอร์",
	"dialog.settings.clear_profile_value": "ล้างค่าโปรไฟล์",
	"layout.section.customize": "ปรับแต่ง",
	"layout.theme.configure": "กำหนดค่า",
	"layout.color.elevated": "ยกระดับ",
	"layout.color.elevated.desc": "องค์ประกอบ UI ยกระดับ มักแยกด้วยเงาตก",
	"layout.file.watch_changes": "ดูการเปลี่ยนแปลงและโหลดใหม่",
	"settings.autocomplete_code": "เติมโค้ดอัตโนมัติ",
	"settings.autocomplete_code.desc": "แสดงข้อเสนอแนะการเติมอัตโนมัติในตัวแก้ไขโค้ด",
	"settings.detect_flipbook_textures": "ตรวจจับเทกซ์เจอร์ฟลิปบุ๊ค",
	"settings.detect_flipbook_textures.desc": "ตรวจจับเทกซ์เจอร์ฟลิปบุ๊คแบบเคลื่อนไหวโดยอัตโนมัติและดูตัวอย่างเป็นแอนิเมชัน",
	"settings.double_click_select_reference": "เลือกภาพอ้างอิงเมื่อดับเบิลคลิก",
	"settings.double_click_select_reference.desc": "ดับเบิลคลิกวิวพอร์ตเพื่อเลือกภาพอ้างอิง",
	"settings.default_keyframe_interpolation": "การประมาณคีย์เฟรมเริ่มต้น",
	"settings.default_keyframe_interpolation.desc": "เลือกโหมดการประมาณคีย์เฟรมเริ่มต้น",
	"settings.color_picker_style": "รูปแบบตัวเลือกสี",
	"settings.color_picker_style.desc": "เลือกรูปแบบของตัวเลือกสีในโหมดวาด",
	"settings.export_asset_paths": "ส่งออกเส้นทางแอสเซ็ต",
	"settings.export_asset_paths.desc": "เลือกวิธีบันทึกเส้นทางไปยังแอสเซ็ตเช่นเทกซ์เจอร์หรือแอนิเมชันในไฟล์ .bbmodel",
	"settings.export_asset_paths.relative": "เส้นทางสัมพัทธ์",
	"settings.export_asset_paths.absolute": "เส้นทางแบบเต็ม",
	"settings.export_asset_paths.both": "เส้นทางสัมพัทธ์และแบบเต็ม (เฉพาะเทกซ์เจอร์)",
	"settings.export_asset_paths.none": "ไม่ส่งออก",
	"action.slider_spline_resolution": "ความละเอียดสไปลน์ %0",
	"action.slider_spline_resolution.desc": "เปลี่ยนความละเอียดสไปลน์ตามแกน %0 (%1)",
	"action.slider_spline_resolution.u.desc_precision": "วงแหวน",
	"action.slider_spline_resolution.v.desc_precision": "ท่อ",
	"action.slider_spline_radius": "รัศมีสไปลน์",
	"action.slider_spline_radius.desc": "เปลี่ยนรัศมีสไปลน์",
	"action.slider_spline_handle_tilt": "มุมเอียงจุดควบคุม",
	"action.slider_spline_handle_tilt.desc": "เปลี่ยนการเอียงแฮนเดิลสไปลน์",
	"action.slider_spline_handle_size": "ขนาดแฮนเดิล",
	"action.slider_spline_handle_size.desc": "เปลี่ยนขนาดแฮนเดิลสไปลน์",
	"action.blend_mode.lighten": "สว่างขึ้น",
	"action.blend_mode.darken": "มืดลง",
	"action.weight_brush": "แปรงน้ำหนัก",
	"action.weight_brush.desc": "วาดน้ำหนักจุดยอดบนเมชสำหรับการเปลี่ยนรูปอาร์มาเจอร์",
	"action.convert_minecraft_skin_variant": "แปลงสกิน Slim/Wide",
	"action.convert_minecraft_skin_variant.desc": "สลับโมเดลสกินระหว่างโมเดลไวด์คลาสสิก (สตีฟ) และสลิม (อเล็กซ์) ปรับเทกซ์เจอร์อัตโนมัติให้พอดีกับโมเดลได้",
	"action.custom_skin_poses": "ท่าสกินกำหนดเอง",
	"action.custom_skin_poses.desc": "โหลดพรีเซ็ตท่าสกินกำหนดเอง",
	"action.custom_skin_poses.update": "อัปเดตท่า",
	"action.custom_skin_poses.update.desc": "เขียนทับท่าที่บันทึกด้วยท่าปัจจุบันของโมเดล",
	"action.add_custom_skin_pose": "เพิ่มท่าสกินกำหนดเอง",
	"action.add_custom_skin_pose.desc": "บันทึกท่าปัจจุบันของโมเดลเป็นพรีเซ็ตท่า",
	"action.export_stl": "ส่งออก STL",
	"action.export_stl.desc": "ส่งออกโมเดล STL สำหรับพิมพ์ 3D",
	"action.add_element": "เพิ่มองค์ประกอบ",
	"action.add_element.desc": "เพิ่มองค์ประกอบใหม่จากรายการประเภทองค์ประกอบ",
	"action.add_spline": "เพิ่มสไปลน์",
	"action.add_spline.desc": "เพิ่มสไปลน์ใหม่",
	"action.add_billboard": "เพิ่มบิลบอร์ด",
	"action.add_billboard.desc": "เพิ่มบิลบอร์ดใหม่",
	"action.add_armature": "เพิ่มอาร์มาเจอร์",
	"action.add_armature.desc": "เพิ่มอาร์มาเจอร์ที่อนุญาตให้ผิวเมชเปลี่ยนรูปผ่านแอนิเมชัน",
	"action.add_armature_bone": "เพิ่มกระดูกอาร์มาเจอร์",
	"action.add_armature_bone.desc": "เพิ่มกระดูกในอาร์มาเจอร์",
	"action.search_textures": "ค้นหาเทกซ์เจอร์",
	"action.search_textures.desc": "ค้นหาเทกซ์เจอร์ตามชื่อ",
	"action.search_animations": "ค้นหาแอนิเมชัน",
	"action.search_animations.desc": "ค้นหาแอนิเมชันตามชื่อ",
	"action.spline_selection_mode": "โหมดการเลือกสไปลน์",
	"action.spline_selection_mode.object": "วัตถุ",
	"action.spline_selection_mode.handles": "แฮนเดิล",
	"action.spline_render_mode": "เรขาคณิต",
	"action.spline_render_mode.mesh": "เมช",
	"action.spline_render_mode.path": "เส้นทาง",
	"action.spline_render_mode.desc": "เรขาคณิตที่สไปลน์นี้ควรเรนเดอร์",
	"action.spline_uv_mode": "รูปแบบ UV",
	"action.spline_uv_mode.length_accurate": "ความยาวแม่นยำ",
	"action.spline_uv_mode.uniform": "สม่ำเสมอ",
	"action.spline_uv_mode.per_segment": "ต่อส่วน",
	"action.spline_uv_mode.desc": "วิธีที่เมชท่อของสไปลน์วาง UV",
	"action.spline_ring_segments": "ส่วนวงแหวน",
	"action.spline_ring_segments.desc": "จำนวนการแบ่งย่อยของสไปลน์นี้ต่อวงแหวนท่อ",
	"action.spline_tube_segments": "ส่วนท่อ",
	"action.spline_tube_segments.desc": "จำนวนการแบ่งย่อยของสไปลน์นี้ตามเส้นทาง",
	"action.spline_tube_radius": "รัศมีท่อ",
	"action.spline_tube_radius.desc": "ตั้งรัศมีท่อของสไปลน์",
	"action.spline_display_space": "พื้นที่แสดงผล",
	"action.spline_display_space.desc": "แสดงตัวบ่งชี้พื้นที่สไปลน์บนเส้นทาง",
	"action.spline_handle_mode": "โหมดแฮนเดิลสไปลน์",
	"action.spline_handle_mode.desc": "โหมดที่ใช้สำหรับเปลี่ยนแฮนเดิลสไปลน์",
	"action.spline_handle_mode.aligned": "จัดเรียง",
	"action.spline_handle_mode.free": "อิสระ",
	"action.spline_handle_mode.mirrored": "สะท้อน",
	"action.slider_weight_brush_size": "ขนาดแปรงน้ำหนัก",
	"action.weight_brush_xray": "โหมด XRay แปรงน้ำหนัก",
	"action.weight_brush_xray.desc": "เมื่อเปิดใช้ แปรงน้ำหนักจะมีผลกับจุดยอดทั้งหมดแทนที่จะเฉพาะที่มองเห็นบนพื้นผิว",
	"action.apply_spline_rotation": "ใช้การหมุน",
	"action.apply_spline_rotation.desc": "รีเซ็ตการหมุนองค์ประกอบของสไปลน์ และใช้กับเรขาคณิตแทน",
	"action.extrude_spline_selection": "ดึงสไปลน์ออก",
	"action.extrude_spline_selection.desc": "ดึงส่วนที่เลือกของสไปลน์ออก",
	"action.split_spline": "แยกสไปลน์",
	"action.split_spline.desc": "แยกสไปลน์เป็นสองสไปลน์ที่แฮนเดิลที่เลือก",
	"action.divide_spline_curve": "แบ่งเส้นโค้งสไปลน์",
	"action.divide_spline_curve.desc": "แบ่งเส้นโค้งของสไปลน์",
	"action.set_vertex_weights": "ตั้งน้ำหนักจุดยอด",
	"action.set_vertex_weights.desc": "ตั้งน้ำหนักจุดยอดของจุดยอดที่เลือกเป็นค่าเฉพาะบนกระดูกอาร์มาเจอร์ที่กำหนด",
	"action.calculate_vertex_weights": "คำนวณน้ำหนักจุดยอด",
	"action.calculate_vertex_weights.desc": "กำหนดน้ำหนักจุดยอดโดยอัตโนมัติตามตำแหน่งของกระดูก",
	"action.shelf_alignment": "การจัดชั้นวาง",
	"action.shelf_alignment.desc": "เลือกการจัดแนวแนวตั้งของไอเทมบนชั้นวาง",
	"action.shelf_alignment.top": "จัดชิดบน",
	"action.shelf_alignment.bottom": "จัดชิดล่าง",
	"action.view_mode.vertex_weight": "น้ำหนักจุดยอด",
	"action.view_mode.weighted_bone_colors": "สีกระดูกจุดยอด",
	"action.create_animation_group": "สร้างกลุ่มแอนิเมชัน",
	"action.create_animation_group.desc": "สร้างกลุ่มของแอนิเมชัน",
	"action.move_graph_keyframes_up": "ย้ายกราฟคีย์เฟรมขึ้น",
	"action.move_graph_keyframes_down": "ย้ายกราฟคีย์เฟรมลง",
	"menu.skin": "สกิน",
	"menu.text_edit.expression_editor": "ตัวแก้ไขนิพจน์",
	"menu.color_picker.picker_type.normal": "แผนที่ปกติ",
	"menu.texture.flipbook_animation": "แอนิเมชันฟลิปบุ๊ค",
	"menu.panel.attach_to": "แนบกับ",
	"menu.animation.playing": "กำลังเล่น",
	"menu.animation_file.save_as": "บันทึกเป็น",
	"menu.animator.quaternion_interpolation": "การประมาณค่าควอเทอร์เนียน",
	"edit.extrude_spline_selection.extend": "ขยาย",
	"edit.divide_spline_curve.position": "ตำแหน่ง",
	"group.bedrock_binding": "การผูก",
	"group.cem_attach": "CEM แนบ",
	"group.cem_model": "CEM โมเดล",
	"group.cem_scale": "CEM มาตราส่วน",
	"cube.rescale": "ปรับขนาดการหมุนใหม่",
	"cube.rescale.desc": "ปรับขนาดคิวบ์ใหม่เพื่อชดเชยมุมการหมุน",
	"mesh.shading": "การแรเงา",
	"mesh.shading.flat": "แบน",
	"mesh.shading.smooth": "เรียบ",
	"spline_mesh.cyclic": "วนรอบ",
	"spline_mesh.cyclic.desc": "สไปลน์ที่เลือกควรเชื่อมเป็นวงหรือไม่ (วนรอบ)",
	"billboard.offset": "ออฟเซ็ต",
	"billboard.facing_mode": "โหมดหันหน้า",
	"billboard.facing_mode.lookat": "มองไปที่",
	"billboard.facing_mode.lookat_y": "มองไปที่ Y",
	"billboard.facing_mode.rotate": "หมุน",
	"billboard.facing_mode.rotate_y": "หมุน Y",
	"armature_bone.connected": "เชื่อมต่อ",
	"reference_image.blueprint": "พิมพ์เขียวล็อก",
	"codec.image.alpha_channel": "ช่องอัลฟา",
	"codec.image.animation_fps": "FPS แอนิเมชัน",
	"panel.palette": "จานสี",
	"panel.keyframe.change_effect_file": "เปลี่ยนไฟล์เอฟเฟกต์",
	"panel.transform": "การแปลง",
	"panel.element.spline_dimensions": "มิติสไปลน์",
	"display.slot.on_shelf": "ชั้นวาง",
	"display.reference.shelf": "ชั้นวาง (ทุกช่อง)",
	"display.reference.shelf_left": "ชั้นวาง (ช่องซ้าย)",
	"display.reference.shelf_center": "ชั้นวาง (ช่องกลาง)",
	"display.reference.shelf_right": "ชั้นวาง (ช่องขวา)",
	"message.newer_project_format_version.title": "เวอร์ชันเก่า",
	"message.newer_project_format_version.message": "ไฟล์นี้บันทึกในเวอร์ชันที่ใหม่กว่าของ Blockbench อัปเดตเป็น Blockbench %0 หรือใหม่กว่าเพื่อเปิดได้อย่างถูกต้อง",
	"message.load_images.add_layer": "เพิ่มเป็นเลเยอร์",
	"message.load_images.category.add_to_project": "เพิ่มในโปรเจกต์",
	"message.load_images.category.new_project": "โปรเจกต์ใหม่",
	"message.load_palette.title": "โหลดพาเล็ต",
	"message.load_palette.message": "คุณแน่ใจหรือไม่ว่าต้องการโหลดพาเล็ตนี้? การดำเนินการนี้จะแทนที่พาเล็ตสีปัจจุบันของคุณ",
	"dialog.set_vertex_weights.weight": "น้ำหนัก",
	"dialog.set_vertex_weights.overwrite": "เขียนทับกระดูกอื่น",
	"action.element_render_order.short": "ลำดับเรนเดอร์",
	"action.element_render_order.desc": "ลำดับเรนเดอร์ขององค์ประกอบ ช่วยแก้ไของค์ประกอบที่ซ่อนอยู่หลังองค์ประกอบอื่นที่มีเทกซ์เจอร์โปร่งใส ปล่อยเป็นอัตโนมัติสำหรับองค์ประกอบทึบ",
	"spline.shading.flat": "แบน",
	"spline.shading.smooth": "เรียบ",
	"spline.shading": "การแรเงา",
	"spline.shading.desc": "วิธีการแรเงาท่อของสไปลน์นี้",
	"action.slider_weight_brush_limit": "ขีดจำกัดแปรงน้ำหนัก",
	"action.slider_weight_brush_limit.desc": "ตั้งขีดจำกัดบนว่าแปรงน้ำหนักสามารถกำหนดน้ำหนักให้จุดยอดได้มากเพียงใด",
	"action.weight_brush_blend_mode": "โหมดผสมแปรงน้ำหนัก",
	"action.weight_brush_blend_mode.set": "ตั้งค่า",
	"action.weight_brush_blend_mode.add": "เพิ่ม",
	"action.apply_texture_to_elements": "ใช้เทกซ์เจอร์กับองค์ประกอบ",
	"action.apply_texture_to_elements.desc": "ใช้เทกซ์เจอร์ที่เลือกกับองค์ประกอบที่เลือก",
	"menu.panel.reset_size": "รีเซ็ตขนาด",
	"action.import_layer": "นำเข้าเลเยอร์",
	"action.import_layer.desc": "นำเข้าไฟล์รูปภาพเป็นเลเยอร์",
	"menu.collection.open_file": "เปิดไฟล์",
	"layout.version": "เวอร์ชัน",
	"settings.status_bar_transform_sliders": "สลายเปลี่ยนในแถบสถานะ",
	"settings.status_bar_transform_sliders.desc": "แสดงสลายเปลี่ยนของเครื่องมือที่เลือกในแถบสถานะแทนการใช้แผงเปลี่ยน",
	"settings.default_bedrock_format": "รูปแบบ Bedrock เริ่มต้น",
	"settings.default_bedrock_format.desc": "เลือกรูปแบบเริ่มต้นสำหรับโหลดโมเดล Minecraft Bedrock เมื่อไม่สามารถตรวจจับรูปแบบเฉพาะจากบริบทได้",
	"settings.limit_brush_opacity_per_stroke": "จำกัดความทึบแปรงต่อสโตรก",
	"settings.limit_brush_opacity_per_stroke.desc": "จำกัดความทึบที่แปรงสามารถใช้ได้ตามค่าของสลายความทึบในแต่ละสโตรก ด้วยแปรงเรียบ พฤติกรรมนี้อาจทำให้เกิดนอยส์ไม่พึงประสงค์เล็กน้อย",
	"action.merge_splines": "ผสานสไปลน์",
	"action.merge_splines.desc": "ผสานสไปลน์หลายอันเป็นหนึ่งอัน",
	"settings.default_java_block_version": "เวอร์ชันบล็อก/ไอเทม Java เริ่มต้น",
	"settings.default_java_block_version.desc": "เวอร์ชันรูปแบบเริ่มต้นเมื่อสร้างโมเดลบล็อก/ไอเทม Java ใหม่หรือเปิดไฟล์ที่ไม่มีเวอร์ชันรูปแบบ",
	"data.bounding_box": "กรอบขอบเขต",
	"keys.option": "Option",
	"keys.slide_lmb_horizontal": "เลื่อนคลิกซ้ายแนวนอน",
	"keys.slide_lmb_vertical": "เลื่อนคลิกซ้ายแนวตั้ง",
	"keys.slide_rmb_horizontal": "เลื่อนคลิกขวาแนวนอน",
	"keys.slide_rmb_vertical": "เลื่อนคลิกขวาแนวตั้ง",
	"message.recover_backup.unknown_project": "โปรเจกต์ไม่ทราบ",
	"message.recover_backup.discard_others": "ละทิ้งทั้งหมด",
	"message.unsupported_file_extension.title": "รูปแบบไฟล์ไม่รองรับ",
	"message.unsupported_file_extension.message": "ไม่สามารถเปิดไฟล์ %0 รูปแบบไม่รองรับ คุณอาจต้องใช้ปลั๊กอินสำหรับไฟล์ประเภทนี้",
	"message.unsupported_file_extension.open_in_default_program": "เปิดในโปรแกรมเริ่มต้น",
	"dialog.project.uv_size": "ขนาด UV",
	"dialog.collection.offset": "ออฟเซ็ต",
	"dialog.texture.fps": "FPS",
	"dialog.texture.fps.desc": "เฟรมต่อวินาทีของแอนิเมชัน flipbook เทกซ์เจอร์",
	"dialog.edit_uv_size.title": "แก้ไขขนาด UV",
	"dialog.edit_uv_size.target": "เป้าหมาย",
	"dialog.edit_uv_size.adjust": "ปรับ",
	"dialog.edit_uv_size.adjust.adjust_uv": "ปรับ UV กลับ",
	"dialog.edit_uv_size.adjust.adjust_scale": "ปรับ UV และมาตราส่วน",
	"dialog.edit_uv_size.adjust.keep": "คง UV",
	"dialog.edit_uv_size.target_size": "ขนาด UV เป้าหมาย",
	"dialog.edit_uv_size.preset.original": "ต้นฉบับ",
	"dialog.edit_uv_size.preset.match_texture": "ตรงกับเทกซ์เจอร์",
	"dialog.edit_uv_size.result": "ผลลัพธ์",
	"dialog.edit_uv_size.result.textures": "เทกซ์เจอร์",
	"dialog.adjust_brightness_contrast.brightness": "ความสว่าง",
	"dialog.adjust_brightness_contrast.contrast": "คอนทราสต์",
	"dialog.adjust_saturation_hue.saturation": "ความอิ่มตัว",
	"dialog.adjust_saturation_hue.hue": "เฉดสี",
	"dialog.adjust_opacity.mode": "โหมด",
	"dialog.adjust_opacity.mode.multiply": "คูณ",
	"dialog.adjust_opacity.mode.set": "ตั้งค่า",
	"dialog.bedrock_bounding_box.type": "ประเภท",
	"dialog.bedrock_bounding_box.type.collision_box": "การชน",
	"dialog.bedrock_bounding_box.type.selection_box": "กรอบเลือก",
	"dialog.bedrock_bounding_box.type.hitbox": "กรอบโจมตี",
	"dialog.bedrock_bounding_box.hitbox_note": "โปรดทราบว่ากรอบโจมตีของเอนทิตี้ทำงานได้เฉพาะขนาดที่กำหนด และอาจไม่ปรับตามการหมุนของเอนทิตี้ในเกม",
	"dialog.bedrock_bounding_box.collision_note": "โปรดทราบว่ากรอบการชนของเอนทิตี้รองรับเฉพาะรูปทรงเดียวที่จัดกึ่งกลาง โดยมีหน้าตัดด้านบนเป็นสี่เหลี่ยมจัตุรัส",
	"dialog.bedrock_bounding_box.no_bounding_boxes": "ไม่มีกรอบขอบเขตในโปรเจกต์นี้",
	"dialog.install_plugins_from_list.ids": "ID ปลั๊กอิน",
	"dialog.install_plugins_from_list.info": "ติดตั้งปลั๊กอินหลายตัวจากรายการ ID ก่อนติดตั้ง กรุณาตรวจสอบว่าคุณต้องการปลั๊กอินทั้งหมดจริงๆ ปลั๊กอินที่ไม่ได้ใช้อาจเพิ่มความเสี่ยงของข้อผิดพลาดและความไม่เข้ากันกับการอัปเดตในอนาคต",
	"dialog.copy_installed_plugins.details": "รวมรายละเอียด",
	"dialog.flip_animation.phase_offset": "ออฟเซ็ตเฟส",
	"dialog.flip_animation.phase_offset.off": "ปิด",
	"dialog.flip_animation.phase_offset.custom": "กำหนดเอง",
	"dialog.flip_animation.clear_opposite": "เขียนทับด้านตรงข้าม",
	"settings.flipbook_textures_in_animation": "เล่นเทกซ์เจอร์ฟลิปบุ๊คในแอนิเมชัน",
	"settings.flipbook_textures_in_animation.desc": "ดูตัวอย่างแอนิเมชันบนเทกซ์เจอร์ฟลิปบุ๊คพร้อมกับไทม์ไลน์แอนิเมชัน",
	"settings.display_uv": "แสดงหน้า UV",
	"settings.display_uv.desc": "เลือกหน้า UV ที่แสดงในตัวแก้ไข UV",
	"settings.display_uv.selected_faces": "เฉพาะหน้าที่เลือก",
	"settings.display_uv.selected_elements": "หน้าทั้งหมดบนองค์ประกอบที่เลือก",
	"settings.display_uv.all_elements": "หน้าทั้งหมดบนองค์ประกอบทั้งหมด",
	"settings.local_position_values": "ค่าตำแหน่งท้องถิ่น",
	"settings.local_position_values.desc": "แสดงค่าตำแหน่งทั้งหมดในแผงเปลี่ยนในพื้นที่ท้องถิ่น",
	"settings.transform_cube_from_center": "เปลี่ยนคิวบ์จากศูนย์กลาง",
	"settings.transform_cube_from_center.desc": "แก้ไขค่าตำแหน่งคิวบ์จากศูนย์กลางแทนมุม",
	"settings.color_picker_tool_switch": "สลับเครื่องมือเลือกสี",
	"settings.color_picker_tool_switch.desc": "เมื่อเลือกพิกเซลโปร่งใส ให้สลับเป็นยางลบ เมื่อเลือกยางลบไว้ก่อนหน้าและเลือกสี ให้สลับเป็นแปรง",
	"keybind.preview_scroll_zoom": "ซูมมุมมอง",
	"keybind.uv_editor_scroll_zoom": "ซูม UV/2D",
	"action.blend_mode.alpha_mask": "มาสก์อัลฟา",
	"action.swap_tools.hold": "กดค้างเพื่อสลับ (ตัวเลือกสี)",
	"action.import_bedrock_voxel_shape": "นำเข้ารูปทรงวอกเซล Bedrock",
	"action.import_bedrock_voxel_shape.desc": "เพิ่มรูปทรงวอกเซลจากไฟล์ json ในโปรเจกต์ปัจจุบัน",
	"action.export_bedrock_voxel_shape": "ส่งออกรูปทรงวอกเซล Bedrock",
	"action.export_bedrock_voxel_shape.desc": "ส่งออกกรอบขอบเขตในโปรเจกต์เป็นไฟล์รูปทรงวอกเซล Bedrock",
	"action.plugins_window_menu": "เมนู",
	"action.copy_installed_plugins": "คัดลอกปลั๊กอินที่ติดตั้ง",
	"action.copy_installed_plugins.desc": "สร้างและคัดลอกรายการปลั๊กอินที่ติดตั้งอยู่",
	"action.install_plugins_from_list": "ติดตั้งปลั๊กอินจากรายการ",
	"action.install_plugins_from_list.desc": "ติดตั้งปลั๊กอินจากรายการ ID ปลั๊กอิน",
	"action.add_bounding_box": "เพิ่มกรอบขอบเขต",
	"action.add_bounding_box.desc": "เพิ่มกรอบขอบเขตใหม่",
	"action.split_alpha_into_layer": "แยกช่องอัลฟาเป็นเลเยอร์",
	"action.split_alpha_into_layer.desc": "แยกช่องอัลฟาของเทกซ์เจอร์เป็นเลเยอร์มาสก์อัลฟา",
	"action.generate_bedrock_block_box": "คัดลอกคอมโพเนนต์การชน/เลือก",
	"action.generate_bedrock_block_box.desc": "สร้างคอมโพเนนต์กรอบการชนหรือเลือกสำหรับบล็อก Minecraft Bedrock Edition",
	"action.generate_bedrock_entity_box": "คัดลอกคอมโพเนนต์การชน/โจมตี",
	"action.generate_bedrock_entity_box.desc": "สร้างคอมโพเนนต์การชนหรือการทดสอบการโจมตีสำหรับเอนทิตี้ Minecraft Bedrock Edition",
	"action.refresh_texture": "รีเฟรชเทกซ์เจอร์",
	"action.refresh_texture.desc": "โหลดเทกซ์เจอร์ใหม่จากไฟล์",
	"action.move_uv_to_cursor": "ย้าย UV ไปยังเคอร์เซอร์",
	"action.move_uv_to_cursor.desc": "ย้ายหน้า UV ที่เลือกไปยังตำแหน่งเคอร์เซอร์เมาส์",
	"action.edit_mode_uv_overlay": "แสดงองค์ประกอบทั้งหมด",
	"action.round_keyframe_values": "ปัดค่าคีย์เฟรม",
	"action.round_keyframe_values.desc": "ปัดค่าทั้งหมดของคีย์เฟรมที่เลือก",
	"action.keyframe_column_create.all_channels": "ทุกช่อง",
	"action.keyframe_column_create.all_channels.desc": "เริ่มต้นทุกช่องด้วยคีย์เฟรมแม้ว่าก่อนหน้านี้ไม่มีคีย์เฟรม",
	"action.add_all_to_timeline": "เพิ่มทั้งหมดในไทม์ไลน์",
	"action.mirror_animating": "มิเรอร์การทำแอนิเมชัน",
	"action.mirror_animating.desc": "สะท้อนการแก้ไขแอนิเมชันไปยังด้านตรงข้าม",
	"action.copy_animation_pose": "คัดลอกท่าแอนิเมชัน",
	"action.copy_animation_pose.desc": "คัดลอกคีย์เฟรมทั้งหมดเพื่อจำลองท่าแอนิเมชันปัจจุบัน",
	"menu.texture.file_format": "รูปแบบไฟล์",
	"menu.texture.wrap_mode": "โหมดห่อ",
	"menu.texture.wrap_mode.limited": "จำกัด",
	"menu.texture.wrap_mode.repeat": "ทำซ้ำ",
	"menu.texture.wrap_mode.clamp": "รัดขอบ",
	"edit.reparent_selection.adjust_position": "รักษาการแปลงโลก",
	"texture_mesh.texture_name": "ชื่อเทกซ์เจอร์",
	"display.slot.embedded": "ฝัง",
	"display.animate_preview": "ตัวอย่างแอนิเมชัน",
	"display.reference.flower_pot": "กระถางดอกไม้"
}